import React, { useCallback, useEffect, useRef, useState } from "react";
import PostAnalysisHighlights from "../../components/PostAnalysisHighlights";
import PostOptionsCompareModal from "../../components/PostOptionsCompareModal";
import {
  Calendar,
  Button,
  Select,
  Modal,
  Drawer,
  Card,
  Avatar,
  Input,
  Upload,
  Switch,
  Row,
  Col,
  DatePicker,
  TimePicker,
  Collapse,
  Form,
  Radio,
  Tooltip,
  Popover,
  Tag,
} from "antd";
import {
  LeftOutlined,
  RightOutlined,
  UploadOutlined,
  LikeOutlined,
  CommentOutlined,
  RetweetOutlined,
  SendOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  PlusOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  FileOutlined,
  EditOutlined,
  DeleteOutlined,
  StarOutlined,
  FileTextOutlined,
  ThunderboltOutlined,
  CopyOutlined,
  RobotOutlined,
  CheckOutlined,
  SearchOutlined,
  PictureOutlined,
  GlobalOutlined,
  TeamOutlined,
  LinkedinFilled,
} from "@ant-design/icons";
import useDraftAutosave from "../../hooks/useDraftAutosave";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import moment from "moment"; // <-- Use moment
import socketClient from "../../socket";
import BlogDescriptionModal, { outlineHasContent } from "../blogWrite/BlogDescriptionModal";
import "../../assets/styles/calendar.css";
import LinkdinIcon from "../../assets/images/linkdin-icon.svg";
// user-image.png was a real stock photo of a person masquerading as the
// "no picture" fallback — user.png is the actual faceless silhouette icon.
import UserImage from "../../assets/images/user.png";
import RightIcon from "../../assets/images/right-icon-errow.svg";
import PostImage from "../../assets/images/post01.jpg";
import LikeIcon from "../../assets/images/like-icon.svg";
import SendIconBtn from "../../assets/images/send-btn-icon.svg";
import RetweetIconBtn from "../../assets/images/repost-btn-icon.svg";
import T from "../../assets/images/T.svg";
import CommentIconBtn from "../../assets/images/comment-btn-icon.svg";
import LikeIconBtn from "../../assets/images/like-btn-icon.svg";
import HeaderPostIcon from "../../assets/images/header-post-icon.svg";
import UploadIcon from "../../assets/images/upload-icon.svg";
import UploadedImage01 from "../../assets/images/uploded-media-file.png";
import LinkIcon from "../../assets/images/link-icon.svg";
import CopyBtnIcon from "../../assets/images/file-copy-icon.svg";
import DeleteBtnIcon from "../../assets/images/delete-icon.svg";
import RefreshIcon from "../../assets/images/refresh-icon.svg";
import ViewIcon from "../../assets/images/view-icon.svg";
import PostDetailImage from "../../assets/images/post-detail-01.jpg";
import DeleteBinIcon from "../../assets/images/delete-bin-icon.svg";
import { useParams, useLocation } from "react-router-dom";
import CalendarIcon from "../../assets/images/calendar-icon.svg";
import DraftIcon from "../../assets/images/draft-icon.svg";
import MultipleImageUpload from "../../components/MultipleImageUpload";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { Severty, ShowToast } from "../../helper/toast";
import Carousel from "react-elastic-carousel";
import dayjs from "dayjs";
import NormalEditor, {
  normalizeEditorHtml,
} from "../../components/NormalEditor";
import { convertHtmlToLinkedInStyledText } from "../../helper/linkedinTextFormatter";
import { set } from "lodash";

// Permission helper
const getPermissionByName = (moduleName) => {
  try {
    const user = JSON.parse(localStorage.getItem("admin_userProfile") || "{}");
    if (user.type === "Admin") {
      return { view: true, add: true, edit: true, delete: true };
    }
    // Case/whitespace-insensitive match — see admin-Imergey's BlogTabs.js
    // for the identical fix (real stored role data has "blogs" lowercase
    // and trailing spaces on "Research Assistant "/"Writing Assistant ").
    const normalizedTarget = String(moduleName || "").trim().toLowerCase();
    const permissions = user?.roleId?.permission || [];
    return (
      permissions.find(
        (p) => String(p?.name || "").trim().toLowerCase() === normalizedTarget
      ) || {}
    );
  } catch {
    return {};
  }
};

const { Option } = Select;
const { TextArea } = Input;
const { Panel } = Collapse;
const statusColors = {
  scheduled: {
    backgroundColor: "#E6F4FF",
    borderColor: "#1677FF",
    label: "Scheduled",
  },
  review: {
    backgroundColor: "#FFF7E6",
    borderColor: "#FA8C16",
    label: "Review",
  },
  approved: {
    backgroundColor: "#F6FFED",
    borderColor: "#52C41A",
    label: "Approved",
  },
  published: {
    backgroundColor: "#F6FFED",
    borderColor: "#52C41A",
    label: "Published",
  },
  publish: {
    backgroundColor: "#F6FFED",
    borderColor: "#52C41A",
    label: "Published",
  },
  draft: {
    backgroundColor: "#F5F5F5",
    borderColor: "#8C8C8C",
    label: "Draft",
  },
  delayed: {
    backgroundColor: "#FFF1F0",
    borderColor: "#FF4D4F",
    label: "Delayed",
  },
};

const MARKING_TYPES = {
  out_of_office: { label: "Out of Office", color: "#722ED1", bg: "#F9F0FF", emoji: "🏠" },
  travel: { label: "Travel Update", color: "#FA8C16", bg: "#FFF7E6", emoji: "✈️" },
  observation: { label: "Observation / Note", color: "#096DD9", bg: "#E6F4FF", emoji: "📋" },
  other: { label: "Other", color: "#595959", bg: "#F5F5F5", emoji: "📌" },
};

const HOLIDAY_CONFIG = { label: "Event", color: "#D4B106", bg: "#FFFBE6", emoji: "🕊️" };

// Blog Write request status -> calendar card label. Completed splits in two:
// blogId set means it was already auto-promoted to a real Blog (delivery
// date hadn't passed at approval time — see BlogWriteService.changeStatus);
// blogId still null means the date HAD already passed, so it's sitting on
// the request page waiting for staff to pick a publish date manually.
const BLOG_WRITE_CALENDAR_STATUS_LABEL = (r) => {
  switch (r.status) {
    case "Pending":
    case "Assigned":
      return "Blog Request Raised";
    case "In Progress":
      return "Blog Writing in Progress";
    case "Waiting for Review":
      return "Draft Submitted for Review";
    case "Revision Requested":
      return "Changes Requested";
    case "Revised":
      return "Revised Draft Submitted";
    case "Completed":
      return r.blogId ? "Approved — Ready to Publish" : "Approved — Needs Publish Date";
    case "Overdue":
      return "Blog Request Overdue";
    default:
      return r.status;
  }
};
const EVENT_TYPE_OPTIONS = ["Holiday", "Campaign", "Observance", "Company Event", "Other"];
const DEFAULT_REGION_OPTIONS = [
  "Hong Kong",
  "India",
  "United States",
  "United Kingdom",
  "United Arab Emirates",
];
const FALLBACK_TIMEZONE_OPTIONS = [
  "Asia/Hong_Kong",
  "Asia/Kolkata",
  "Asia/Dubai",
  "Europe/London",
  "America/New_York",
  "America/Los_Angeles",
  "Australia/Sydney",
  "UTC",
];

const getTimezoneOptions = () => {
  const supportedTimezones =
    typeof Intl?.supportedValuesOf === "function"
      ? Intl.supportedValuesOf("timeZone")
      : [];

  return Array.from(
    new Set([...FALLBACK_TIMEZONE_OPTIONS, ...supportedTimezones])
  ).sort();
};

const TIMEZONE_OPTIONS = getTimezoneOptions();

const months = moment.months();

const stripHtml = (html) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
};

// LinkedIn wraps a list line's overflow so it lines up under the bullet/
// number ("hanging indent") — a plain white-space:pre-wrap blob of text
// can't do that, since the browser has no idea "- " or "1. " marks a list
// item; the wrapped line just falls back to the left margin instead of
// aligning under the item's own text, unlike the real published post. This
// renders each line of the (already-published-accurate) plain-text preview
// string as its own block, giving list-marker lines a CSS hanging indent so
// wrapped preview text matches how it actually looks once posted.
const LIST_LINE_PATTERN = /^(-\s|\d+\.\s)/;
const renderLinkedInPreviewLines = (text = "") =>
  text.split("\n").map((line, index) => {
    const isListLine = LIST_LINE_PATTERN.test(line);
    return (
      // eslint-disable-next-line react/no-array-index-key
      <div key={index} dir="auto" className={isListLine ? "linkedin-preview-list-line" : undefined}>
        {line || " "}
      </div>
    );
  });

// Only a post that is ALREADY a draft is safe to keep autosaving while it's
// open for editing — re-affirming "draft" on it is a no-op. Autosaving edits
// to a post under review/approved/published would silently downgrade its
// status back to Draft on every tick, which would be actively harmful.
//
// The clientStatus/brandStatus text check alone isn't enough: a post that's
// already been through internal review and/or client approval gets its
// clientStatus/brandStatus reset back to "Draft By Brand" while it's being
// revised for resubmission, which made it match this check even though it
// has real history. That let drawerDraftId (below) point at it, making it
// eligible for the "delete the redundant autosave draft" cleanup elsewhere
// in this file — silently soft-deleting an already-approved post. A record
// only counts as a genuinely fresh, untouched draft if it has never entered
// the review pipeline at all.
const isDraftRecordStatus = (item) => {
  const looksDraft =
    /draft/i.test(String(item?.clientStatus || "")) ||
    /draft/i.test(String(item?.brandStatus || ""));
  if (!looksDraft) return false;

  const hasReviewHistory =
    (item?.internalReview?.status && item.internalReview.status !== "none") ||
    !!item?.sentToClientName ||
    !!item?.sentToClientByName ||
    !!item?.clientApprovedByName ||
    !!item?.publishedByName ||
    !!item?.republishedByName ||
    !!item?.postId;

  return !hasReviewHistory;
};

const formatPreviewDate = (date) => {
  if (!date) return moment().format("MMM D");
  return moment(date).format("MMM D");
};

const getBrowserTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

const getTimezoneOffsetForSchedule = (dateValue, timeValue) => {
  if (!dateValue || !timeValue) {
    return new Date().getTimezoneOffset();
  }

  const [year, month, day] = String(dateValue).split("-").map(Number);
  const [hours, minutes] = String(timeValue).split(":").map(Number);

  if (
    [year, month, day, hours, minutes].some(
      (part) => Number.isNaN(part) || part == null,
    )
  ) {
    return new Date().getTimezoneOffset();
  }

  return new Date(year, month - 1, day, hours, minutes, 0, 0).getTimezoneOffset();
};

const getScheduledMoment = (item) => {
  if (!item?.selectedDate) return null;

  const scheduledDate = moment.utc(item.selectedDate).format("YYYY-MM-DD");

  // No time chosen yet — the common case for a fresh Draft (confirmed
  // against real data: draft posts routinely have selectedTime: null).
  // scheduledTime used to fall back to a fake "00:00" below and get run
  // through the timezoneOffset conversion meant for a REAL wall-clock
  // time, producing a UTC instant that can land on the PREVIOUS calendar
  // day once rendered in a viewer's local timezone (moment() below wraps
  // in the viewer's browser zone, not the post's stored offset). That
  // shifted the card back a day on the calendar for any viewer whose
  // timezone differed enough from whoever created the post — and made
  // drag-and-drop's current-vs-target date comparison (handleDrop)
  // disagree with what was actually on screen, since the post's real cell
  // and its "current date" reading no longer matched.
  //
  // A date with no time attached has no timezone-dependent instant to
  // compute — treat it as a pure calendar day, UTC-anchored, identical
  // for every viewer regardless of their own timezone.
  if (!item.selectedTime) {
    return moment.utc(`${scheduledDate}T00:00:00`);
  }

  const timezoneOffset = Number.isFinite(Number(item?.timezoneOffset))
    ? Number(item.timezoneOffset)
    : new Date().getTimezoneOffset();
  const [year, month, day] = scheduledDate.split("-").map(Number);
  const [hours, minutes] = String(item.selectedTime).split(":").map(Number);

  return moment(
    Date.UTC(year, month - 1, day, hours, minutes, 0, 0) +
      timezoneOffset * 60 * 1000,
  );
};

const isPostScheduledForFuture = (item) => {
  const scheduledAt = getScheduledMoment(item);
  return scheduledAt?.isValid() && scheduledAt.isAfter(moment());
};

const isPostPastDue = (item) => {
  const scheduledAt = getScheduledMoment(item);
  return scheduledAt?.isValid() && scheduledAt.isSameOrBefore(moment());
};

const isPostPublished = (item) => Boolean(item?.postId || item?.publishedExternally);

// Distinct from generic "Delayed" — set by the backend's updateDelayedStatuses
// specifically when the post missed its window because the client's LinkedIn
// token was already expired at the time, so this is called out clearly
// instead of an unexplained "Delayed" that needs opening the post to
// diagnose.
const isLinkedInExpiredStatus = (item) => {
  if (isPostPublished(item)) return false;
  const normalizedStatus = String(item?.brandStatus || item?.clientStatus || "").toLowerCase();
  return normalizedStatus === "linkedin token expired";
};

const isPostDelayed = (item) => {
  if (isPostPublished(item)) return false;

  const normalizedStatus = String(item?.brandStatus || item?.clientStatus || "").toLowerCase();
  if (normalizedStatus.includes("delay")) return true;

  return (
    isPostPastDue(item) &&
    !isPostPublished(item) &&
    normalizedStatus.includes("publish")
  );
};

// A first name alone is ambiguous when a client and a BM/admin happen to
// share it — pair every actor label with their designation so "Dushyant" the
// client and "Dushyant" the Brand Manager are never confused for each other.
const ROLE_DESIGNATIONS = { user: "Client", admin: "Admin", brand: "Brand", assistant: "Assistant" };

const getPublishedStatusLabel = (item) => {
  // New: show "Published by {Role} ({firstName})" when publisher identity is stored
  if (item?.publishedByName) {
    const firstName = item.publishedByName.split(" ")[0];
    const role = ROLE_DESIGNATIONS[item?.publishedByRole] || item?.publishedByRole;
    return role ? `Published by ${role} (${firstName})` : `Published by ${firstName}`;
  }

  // Fallback: existing logic for posts without publishedByName (backward-compat)
  const rawStatus = item?.brandStatus || item?.clientStatus;
  const normalizedStatus = String(rawStatus || "").toLowerCase();

  if (normalizedStatus === "publish by client") return "Published by Client";
  if (normalizedStatus === "publish by brand") return "Published by Brand";
  if (normalizedStatus === "publish by admin" || normalizedStatus === "publish") {
    return "Published";
  }

  if (normalizedStatus === "live") {
    const createdBy = Number(item?.createdBy);
    if (createdBy === 0) return "Published by Client";
    if (createdBy === 1) return "Published by Brand";
  }

  return "Published";
};

const getCalendarStatusLabel = (item, clientFirstName) => {
  const rawStatus = item?.brandStatus || item?.clientStatus;
  const normalizedStatus = String(rawStatus || "").toLowerCase();
  // A post that has actually gone live outranks every pre-publish
  // approval/review marker still sitting on the record — clientApprovedByName,
  // brandStatus literally still reading "Approved By Client", etc. The
  // backend now clears those the moment a post actually publishes (see
  // ExternalPublishHelper.ts / trialChecker.cron.ts), but older records
  // predate that fix, and this stays correct for them too instead of
  // depending on a one-time data migration. republishedByName is the one
  // legitimate exception — a genuine post-publish edit/re-approve/republish
  // cycle — so it's checked on its own below, ahead of this guard.
  const isLive = isPostPublished(item);

  // Draft always shows as "Draft" regardless of scheduled date
  if (normalizedStatus.includes("draft")) return "Draft";

  // Set by BlogWriteService.uploadVersion when the Blog Writer submits a new
  // version on a request whose Blog was already sent back for changes — the
  // calendar card otherwise stayed stuck on the stale "Changes Requested"
  // label with nothing telling the BM/BS a revision had actually landed.
  if (normalizedStatus === "revision submitted") return "Revision Submitted";

  // Internal review status takes priority over scheduled-date display
  if (item?.internalReview?.status === "pending") return "Internal Review Pending";
  if (item?.internalReview?.status === "changes_requested") return "Changes Requested";
  // The CLIENT requesting changes (clientStatus/brandStatus set directly by
  // requestChanges/submitCommentViaEmailToken) is a separate signal from the
  // internal reviewer's internalReview.status above — without this check, a
  // future-dated post falls straight through to isPostScheduledForFuture
  // below and misleadingly shows "Scheduled" instead of the actual status.
  if (normalizedStatus.includes("changes requested")) {
    // changesRequestedByName/Role records who actually clicked (Client or
    // their Assistant) — was previously always clientFirstName (the
    // client's own name looked up separately), which misattributed an
    // Assistant's request-changes as if the Client sent it.
    if (item?.changesRequestedByName) {
      const firstName = item.changesRequestedByName.split(" ")[0];
      const role = ROLE_DESIGNATIONS[item?.changesRequestedByRole] || item?.changesRequestedByRole || "Client";
      return `Changes Requested by ${role} (${firstName})`;
    }
    return clientFirstName ? `Changes Requested by ${clientFirstName}` : "Changes Requested";
  }

  // Post-publish edit cycle — same three names on every panel, in order of
  // how far the cycle has progressed. Each is cleared the moment an earlier
  // stage restarts (see ContentReviewService/CalenderController), so
  // whichever of these is set is always the current, non-stale stage.
  if (item?.republishedByName) {
    const firstName = item.republishedByName.split(" ")[0];
    const role = ROLE_DESIGNATIONS[item?.publishedByRole] || item?.publishedByRole;
    return role ? `Republished by ${role} (${firstName})` : `Republished by ${firstName}`;
  }
  if (item?.clientApprovedByName && !isLive) {
    // clientApprovedByName/Role — Client or their Assistant, per
    // clientApprovedByRole; was hardcoded to "Client" regardless.
    const firstName = item.clientApprovedByName.split(" ")[0];
    const role = ROLE_DESIGNATIONS[item?.clientApprovedByRole] || "Client";
    return `Approved by ${role} (${firstName})`;
  }
  // Awaiting client review — shows who it was sent TO (the client), not
  // who sent it. Covers both code paths that send content to the client
  // for review (the internal-review-gated ContentReviewService.sendToClient,
  // which sets sentToClientByName, and the simpler direct action="review"
  // path a reviewer uses, which only sets brandStatus).
  const isAwaitingClientReview =
    !isLive &&
    (!!item?.sentToClientByName ||
      normalizedStatus === "sent to client" ||
      normalizedStatus === "sent for review");
  if (isAwaitingClientReview) {
    return clientFirstName ? `Review needed by Client (${clientFirstName})` : "Sent to Client";
  }
  // Client approval supersedes the internal-approved label
  if (!isLive && String(item?.brandStatus || "").toLowerCase() === "approved by client") {
    const firstName = (item.clientApprovedByName || item.sentToClientName || "").split(" ")[0];
    const role = ROLE_DESIGNATIONS[item?.clientApprovedByRole] || "Client";
    return firstName ? `Approved by ${role} (${firstName})` : "Approved by Client";
  }
  // BS/BH internal sign-off just clears the post to go to the client — it
  // isn't the client's own approval, so it reads as a milestone rather than
  // "Approved by X" (which would otherwise look identical to the client's
  // actual approval label above).
  if (!isLive && String(item?.brandStatus || "").toLowerCase() === "internal review approved") {
    return "Internal Review Done";
  }

  // The CLIENT sending this post TO the Admin for review (the reverse of
  // isAwaitingClientReview above) sets brandStatus:"Under Review" — without
  // this check, dragging the post to a future date on the calendar made
  // isPostScheduledForFuture below win instead, misleadingly flipping the
  // label from "Under Review" to "Scheduled" even though nobody had made
  // any review decision yet. Guarded by !isLive for the same reason as the
  // checks above — a published post can't legitimately still be "Under
  // Review" no matter what stale status string is sitting on the record.
  if (!isLive && normalizedStatus === "under review") return "Under Review";

  if (isPostScheduledForFuture(item)) return "Scheduled";
  if (isPostPublished(item)) {
    return getPublishedStatusLabel(item);
  }
  // Any publish-variant status without postId → cron is working on it, show Publish Pending
  // Must come before isPostDelayed which catches past-due publish-status posts
  if (normalizedStatus.includes("publish")) return "Publish Pending";
  if (isLinkedInExpiredStatus(item)) return "LinkedIn Token Expired";
  if (isPostDelayed(item)) return "Delayed";

  const label = String(rawStatus || "")
    .split(" ")
    .map((word, index) =>
      index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word,
    )
    .join(" ");

  // Replace generic "Client" with actual client first name
  if (clientFirstName) {
    return label.replace(/\bClient\b/g, clientFirstName);
  }
  return label;
};

const getCalendarStatusStyle = (item) => {
  const rawStatus = item?.brandStatus || item?.clientStatus;
  if (String(rawStatus || "").toLowerCase().includes("draft")) return statusColors.draft;
  // Same "revision submitted" case as the label above — styled like the
  // other awaiting-your-review states (statusColors.review) so it stands
  // out on the calendar the same way Internal Review Pending does.
  if (String(rawStatus || "").toLowerCase() === "revision submitted") return statusColors.review;

  // Same isLive guard as getCalendarStatusLabel above — a published post
  // outranks every pre-publish approval/review marker still sitting on the
  // record, so its color/badge doesn't stay stuck on "Approved"/"Review"
  // forever after it actually goes live.
  const isLive = isPostPublished(item);

  // Post-publish edit cycle — same priority as the label above.
  if (item?.republishedByName) return statusColors.publish;
  if (item?.clientApprovedByName && !isLive) return statusColors.approved;

  // Internal review takes priority over scheduled-date styling
  if (item?.internalReview?.status === "pending") return statusColors.review;
  if (item?.internalReview?.status === "changes_requested") return statusColors.delayed;
  // Same fix as the label above — the client's own changes-requested status
  // is a separate signal from internalReview.status.
  if (String(rawStatus || "").toLowerCase().includes("changes requested")) return statusColors.delayed;
  if (!isLive && (item?.sentToClientByName || String(item?.brandStatus || "").toLowerCase() === "sent to client")) return statusColors.review;
  if (!isLive && String(item?.brandStatus || "").toLowerCase() === "approved by client") return statusColors.approved;
  if (!isLive && String(item?.brandStatus || "").toLowerCase() === "internal review approved") return statusColors.approved;
  // Same reverse-direction gap as getCalendarStatusLabel above — the CLIENT
  // sending this post TO the Admin sets brandStatus:"Under Review", and
  // without this check dragging it to a future date would flip the card's
  // color/badge to "Scheduled" instead of staying on the review color.
  if (!isLive && String(item?.brandStatus || "").toLowerCase() === "under review") return statusColors.review;

  if (isPostScheduledForFuture(item)) return statusColors.scheduled;
  if (isPostPublished(item)) return statusColors.publish;
  if (isLinkedInExpiredStatus(item)) return statusColors.delayed;
  if (isPostDelayed(item)) return statusColors.delayed;

  const statusKey = item.action?.toLowerCase();
  return (
    statusColors[statusKey] || {
      backgroundColor: "#eee",
      borderColor: "#ccc",
      label: item.status,
    }
  );
};

const getStatusIcon = (label) => {
  const l = (label || "").toLowerCase();
  if (l.includes("scheduled")) return <CalendarOutlined />;
  if (l.includes("published") || l.includes("approved") || l.includes("live")) return <CheckCircleOutlined />;
  if (l.includes("delayed") || l.includes("failed") || l.includes("linkedin")) return <CloseCircleOutlined />;
  if (l.includes("draft")) return <FileOutlined />;
  return <ClockCircleOutlined />;
};

const resolveCalendarTheme = (item, themes = []) => {
  const contentTheme = item?.contentTheme;

  if (contentTheme && typeof contentTheme === "object") {
    return {
      name: contentTheme.name,
      color: contentTheme.color || "#3B6B94",
    };
  }

  const themeId = String(contentTheme || "");
  const matchedTheme = themes.find((theme) => String(theme?._id) === themeId);

  if (!matchedTheme) return null;

  return {
    name: matchedTheme.name,
    color: matchedTheme.color || "#3B6B94",
  };
};

const resolveCalendarSubPillars = (item) => {
  const rawSubPillars = item?.subPillar;

  if (!Array.isArray(rawSubPillars)) {
    return rawSubPillars ? [rawSubPillars] : [];
  }

  return rawSubPillars.flat().filter(Boolean);
};

const normalizePostType = (type) => {
  if (type === "Title" || type === "Image" || type === "Video") return "Media";
  return type || "Media";
};

const isVideoUrl = (url) => /\.(mp4|mov|avi|webm|mkv|m4v)(\?|$)/i.test(url || "");

const CalendarPage = ({ user, prefillPostContent, onPrefillPostHandled }) => {
  const calendarPermission = getPermissionByName("Calendar");
  const navigate = useNavigate();
  const location = useLocation();
  
  // Redirect if user lacks view permission
  useEffect(() => {
    if (!calendarPermission?.view) {
      navigate("/dashboard");
    }
  }, [calendarPermission?.view]);
  
  const [record, setRecord] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(moment());
  const [isDrawerAction, setIsDrawerAction] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  // Compact "Create Blog Request" modal, right here on the Calendar —
  // staff no longer gets navigated away to the Blog Write module and back
  // just to raise a request for the client whose calendar they're already
  // on. Client is fixed to this calendar's own client.
  const [blogRequestModalOpen, setBlogRequestModalOpen] = useState(false);
  const [blogWriteMembers, setBlogWriteMembers] = useState([]);
  const [savingBlogRequest, setSavingBlogRequest] = useState(false);
  const [blogRequestForm] = Form.useForm();
  const [blogRequestOutline, setBlogRequestOutline] = useState(undefined);
  const [blogRequestDescModalOpen, setBlogRequestDescModalOpen] = useState(false);
  const [blogRequestFileList, setBlogRequestFileList] = useState([]);
  const [isModalVisible01, setIsModalVisible01] = useState(false);
  const [isLinkedInPosted, setIsLinkedInPosted] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [form] = Form.useForm();
  const [postText, setPostText] = useState("");
  const [postAnalysis, setPostAnalysis] = useState(null);
  const [postAnalysisLoading, setPostAnalysisLoading] = useState(false);
  // Content Intelligence analysis can take up to ~110s. The Analyze button
  // is disabled while a request is in flight, but nothing stops the user
  // from continuing to edit the post text in that window — when the slow
  // response lands, it would otherwise silently overwrite postAnalysis with
  // a score for whatever text was in the box when Analyze was clicked.
  const postTextLiveRef = useRef(postText);
  useEffect(() => {
    postTextLiveRef.current = postText;
  }, [postText]);

  // ── Post options: 2-3 alternative captions sent to the client together ──
  // Option 1 is the normal post text (form field `postText`); options 2-3 live
  // here. Staff pick which options to send in a side-by-side popup.
  const lang = (s) => s;
  const MAX_POST_OPTIONS = 3;
  const [extraOptionTexts, setExtraOptionTexts] = useState([]); // option 2..3
  const [activePostOption, setActivePostOption] = useState(0); // 0 = option 1
  const [optionSelection, setOptionSelection] = useState([true, true, true]);
  const [optionsModalOpen, setOptionsModalOpen] = useState(false);
  const [compareOpen, setCompareOpen] = useState(false);
  const [pickerLabel, setPickerLabel] = useState(null);
  const [pickerSingle, setPickerSingle] = useState(false);
  const [optionComments, setOptionComments] = useState(["", "", ""]);
  const optionCommentsRef = useRef(["", "", ""]);
  const extraOptionTextsRef = useRef([]);
  const optionSelectionRef = useRef([true, true, true]);
  const optionsTouchedRef = useRef(false);
  const pendingOptionsActionRef = useRef(null);
  const pendingOptionsQuickRef = useRef(false); // true = the action only opens another dialog
  const workspaceBusyRef = useRef(false); // refreshed every render below
  const workspaceTaskActiveRef = useRef(false);
  const extraEditorRefs = useRef([]);
  const [extraOptionMedia, setExtraOptionMedia] = useState([]); // per extra option: [{ url }]
  const extraOptionMediaRef = useRef([]);
  useEffect(() => {
    extraOptionTextsRef.current = extraOptionTexts;
  }, [extraOptionTexts]);

  const flushAllPostEditors = () => {
    postTextEditorRef.current?.flush();
    extraEditorRefs.current.forEach((r) => r?.flush && r.flush());
  };
  const allOptionTexts = [postText, ...extraOptionTexts];
  const optionDefs = allOptionTexts
    .map((text, idx) => ({ text, idx }))
    .filter((o) => stripHtml(o.text || "").trim());
  const filledOptionCount = optionDefs.length;
  // Saved option index (position among the filled options) of every option ticked for approval.
  const approvedIndexesFromSelection = () =>
    optionDefs.map((o, k) => (optionSelectionRef.current[o.idx] !== false ? k : -1)).filter((k) => k >= 0);
  const mediaForOption = (i) => (i === 0 ? attachment || [] : extraOptionMedia[i - 1] || []);
  const urlsOf = (list) => (list || []).map((f) => f && f.url).filter(Boolean);
  const updateExtraMedia = (idx, files) => {
    optionsTouchedRef.current = true;
    const formatted = (files || []).map((f) => ({ url: f.url, name: f.name, status: f.status }));
    const next = [...extraOptionMediaRef.current];
    next[idx] = formatted;
    extraOptionMediaRef.current = next;
    setExtraOptionMedia(next);
    setIsDirty(true);
  };

  // undefined = leave the saved options alone (nothing was ever touched).
  const getPostOptionsPayload = () => {
    const texts = [postTextLiveRef.current || "", ...extraOptionTextsRef.current];
    const filled = texts.filter((t) => stripHtml(t || "").trim());
    if (filled.length < 2) return optionsTouchedRef.current ? [] : undefined;
    return texts
      .map((text, i) => ({
        text,
        selected: optionSelectionRef.current[i] !== false,
        media: urlsOf(i === 0 ? attachment : extraOptionMediaRef.current[i - 1]),
      }))
      .filter((o) => stripHtml(o.text || "").trim());
  };
  const postOptionsPayloadField = () => {
    const o = getPostOptionsPayload();
    return o === undefined ? {} : { postOptions: o };
  };

  const addPostOption = () => {
    if (extraOptionTexts.length >= MAX_POST_OPTIONS - 1) return;
    optionsTouchedRef.current = true;
    extraOptionMediaRef.current = [...extraOptionMediaRef.current, []];
    setExtraOptionMedia(extraOptionMediaRef.current);
    setExtraOptionTexts((prev) => [...prev, ""]);
    setActivePostOption(extraOptionTexts.length + 1);
    setIsDirty(true);
  };
  const removePostOption = (idx) => {
    optionsTouchedRef.current = true;
    extraOptionMediaRef.current = extraOptionMediaRef.current.filter((_, i) => i !== idx);
    setExtraOptionMedia(extraOptionMediaRef.current);
    setExtraOptionTexts((prev) => prev.filter((_, i) => i !== idx));
    setActivePostOption(0);
    setIsDirty(true);
  };
  const updateExtraOption = (idx, value) => {
    optionsTouchedRef.current = true;
    const normalized = normalizeEditorHtml(value);
    const next = extraOptionTextsRef.current.map((t, i) => (i === idx ? normalized : t));
    extraOptionTextsRef.current = next;
    setExtraOptionTexts(next);
    setIsDirty(true);
  };
  const resetPostOptions = () => {
    extraOptionMediaRef.current = [];
    setExtraOptionMedia([]);
    setExtraOptionTexts([]);
    setActivePostOption(0);
    setOptionSelection([true, true, true]);
    optionSelectionRef.current = [true, true, true];
    optionsTouchedRef.current = false;
    optionCommentsRef.current = ["", "", ""];
    setOptionComments(["", "", ""]);
  };
  const applyPostOptionsFromRecord = (data) => {
    const opts = Array.isArray(data?.postOptions) ? data.postOptions : [];
    if (opts.length >= 2) {
      const first = normalizeEditorHtml(opts[0].text);
      setPostText(first);
      form.setFieldsValue({ postText: first });
      setExtraOptionTexts(opts.slice(1).map((o) => normalizeEditorHtml(o.text)));
      const toFiles = (arr) => (arr || []).map((url) => ({ url }));
      const mediaLists = opts.slice(1).map((o) => toFiles(o.media));
      extraOptionMediaRef.current = mediaLists;
      setExtraOptionMedia(mediaLists);
      if (Array.isArray(opts[0].media)) setAttachment(toFiles(opts[0].media));
      const sel = [0, 1, 2].map((i) => (opts[i] ? opts[i].selected !== false : true));
      setOptionSelection(sel);
      optionSelectionRef.current = sel;
      optionsTouchedRef.current = true;
    } else {
      resetPostOptions();
    }
    setActivePostOption(0);
  };

  const setOptionComment = (idx, value) => {
    const next = [...optionCommentsRef.current];
    next[idx] = value;
    optionCommentsRef.current = next;
    setOptionComments(next);
  };
  const clearOptionComments = () => {
    optionCommentsRef.current = ["", "", ""];
    setOptionComments(["", "", ""]);
  };
  // Folds the per-option comment boxes into the single comment the workflow
  // endpoints already take ("Option 2: make it shorter").
  const getMergedComment = (base) => {
    const texts = [postTextLiveRef.current || "", ...extraOptionTextsRef.current];
    const filledIdx = texts.map((t, i) => i).filter((i) => stripHtml(texts[i] || "").trim());
    if (filledIdx.length < 2) return base;
    // Numbered by position among the filled options (= the saved order) so the
    // number means the same option for staff and for the client.
    const lines = filledIdx
      .map((i, k) => ({ k, c: (optionCommentsRef.current[i] || "").trim() }))
      .filter((x) => x.c)
      .map((x) => `Option ${x.k + 1}: ${x.c}`);
    return [(base || "").trim(), ...lines].filter(Boolean).join("\n") || base;
  };

  const closeOptionsWorkspace = () => {
    setOptionsModalOpen(false);
    setCompareOpen(false);
    setPickerLabel(null);
    pendingOptionsActionRef.current = null;
  };
  const openOptionsPicker = (proceed, label, quick = false, single = false) => {
    pendingOptionsActionRef.current = proceed;
    pendingOptionsQuickRef.current = quick;
    setPickerSingle(single);
    setPickerLabel(label || lang("Send"));
    if (single) {
      // Publishing sends one caption: start on the client-approved option (or the first one sent).
      const approvedK = optionDefs.findIndex((_, k) => !!(record?.postOptions || [])[k]?.clientApproved);
      const sentK = optionDefs.findIndex((o) => optionSelection[o.idx] !== false);
      const pickK = approvedK >= 0 ? approvedK : sentK >= 0 ? sentK : 0;
      setOptionSelection([0, 1, 2].map((i) => i === optionDefs[pickK]?.idx));
    } else {
      setOptionSelection((prev) => [0, 1, 2].map((i) => prev[i] !== false));
    }
    setOptionsModalOpen(true);
  };
  // Run `proceed` straight away for a normal single-caption post; with 2-3
  // options, first open the side-by-side workspace so staff can edit, comment
  // and choose which options go out.
  const withOptionsPicker = (proceed, label, quick = false, single = false) => {
    flushAllPostEditors();
    if (filledOptionCount >= 2) openOptionsPicker(proceed, label, quick, single);
    else proceed();
  };
  // The compare screen stays open, with a spinner on the clicked button, while the
  // action (send / approve / request changes ...) is running, and closes once it is
  // done. If nothing starts within ~1.5 s (e.g. a validation error), it closes so the
  // form's messages are visible.
  const watchWorkspaceTask = () => {
    workspaceTaskActiveRef.current = true;
    const startedAt = Date.now();
    let sawBusy = false;
    const finish = () => {
      workspaceTaskActiveRef.current = false;
      closeOptionsWorkspace();
    };
    const tick = () => {
      if (!workspaceTaskActiveRef.current) return;
      if (workspaceBusyRef.current) sawBusy = true;
      const elapsed = Date.now() - startedAt;
      if ((sawBusy && !workspaceBusyRef.current) || (!sawBusy && elapsed > 1500) || elapsed > 120000) {
        finish();
        return;
      }
      setTimeout(tick, 150);
    };
    setTimeout(tick, 150);
  };
  const confirmOptionsPicker = () => {
    optionSelectionRef.current = optionSelection;
    const fn = pendingOptionsActionRef.current;
    if (pendingOptionsQuickRef.current) {
      closeOptionsWorkspace();
      if (fn) setTimeout(fn, 0);
      return;
    }
    if (fn) setTimeout(fn, 0);
    watchWorkspaceTask();
  };
  const runFromWorkspace = (fn, quick = false) => {
    optionSelectionRef.current = optionSelection;
    if (quick) {
      closeOptionsWorkspace();
      setTimeout(fn, 0);
      return;
    }
    setTimeout(fn, 0);
    watchWorkspaceTask();
  };
  const openCompare = () => {
    flushAllPostEditors();
    setPickerLabel(null);
    setOptionSelection((prev) => [0, 1, 2].map((i) => prev[i] !== false));
    setCompareOpen(true);
  };
  // The workflow buttons the composer footer would show right now, offered
  // inside the workspace too (same conditions as the footer).
  const buildWorkspaceActions = () => {
    const acts = [];
    if (!isPastDateNew && !isScheduledLocked && !isPublishedFooterLocked && canModifyPost && record?.action !== "approved") {
      acts.push({
        key: "review",
        label: "Send for review",
        type: "primary",
        needsPick: true,
        loading: formSubmitting && activeActionType === "review",
        disabled: formSubmitting,
        onClick: () => runFromWorkspace(() => { selectActionType("review"); setTimeout(() => form.submit(), 0); }),
      });
    }
    if (!isScheduledLocked && isEditMode && record?.brandStatus === "Under Review" && calendarPermission?.edit) {
      acts.push({
        key: "approve",
        label: "Approve",
        type: "primary",
        needsPick: true,
        loading: formSubmitting && activeActionType === "approved",
        disabled: formSubmitting,
        onClick: () => runFromWorkspace(async () => {
          try {
            await form.validateFields();
            selectActionType("approved");
            await onEdit(form.getFieldsValue());
          } catch (error) {
            console.log("Validation failed:", error);
          }
        }),
      });
    }
    return acts;
  };
  // Guideline Checker — our own LLM-based feature (originality.ai's version
  // has no API access at all, confirmed against their published docs).
  const [postGuidelineCheck, setPostGuidelineCheck] = useState(null);
  const [postGuidelineCheckLoading, setPostGuidelineCheckLoading] = useState(false);
  const [attachment, setAttachment] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [rescheduleModalVisible, setRescheduleModalVisible] = useState(false);
  const [reschedulePost, setReschedulePost] = useState(null);
  const [rescheduleDate, setRescheduleDate] = useState(null);
  const [rescheduleTime, setRescheduleTime] = useState(null);
  const [rescheduleLoading, setRescheduleLoading] = useState(false);
  const [isMarkExternalModalOpen, setIsMarkExternalModalOpen] = useState(false);
  const [linkedinUrlInput, setLinkedinUrlInput] = useState("");
  const [markExternalLoading, setMarkExternalLoading] = useState(false);
  // Which caption option actually went live (only when the post still has 2-3 options).
  const [markExternalOption, setMarkExternalOption] = useState(null);
  // Set only by the past-date "create + mark published" flow below — lets
  // the existing Mark-Published-on-LinkedIn modal target a post that was
  // just created in this same click, without touching isEditMode/record
  // (and whatever effects key off their transitions) to get there.
  const [pendingMarkExternalPostId, setPendingMarkExternalPostId] = useState(null);
  const [calendarData, setCalenderData] = useState([]);
  const [selectedPostType, setSelectedPostType] = useState("Media");
  const [isPublishSubmitting, setIsPublishSubmitting] = useState(false);
  const isPublishSubmittingRef = useRef(false);
  // Lets Save/Publish handlers force the post-text editor to commit any
  // still-pending debounced edit before we read form values — otherwise a
  // save triggered right after typing (before the 150ms debounce settles)
  // can submit the pre-edit text. See NormalEditor's flush().
  const postTextEditorRef = useRef(null);
  // Tracks which post's edit drawer is the most recently requested one.
  // handleEditClick's fetch is async — if the user opens post A, then opens
  // post B before A's response lands, A's response must not clobber B's
  // already-applied attachment/media/form state.
  const latestEditRequestIdRef = useRef(null);
  // General "a submit request is in flight" flag — covers every action
  // (draft/review/publish), unlike isPublishSubmitting which only guards
  // double-clicking Publish. Drives the loading spinner on the footer
  // buttons so clicking Send for Review / Save as Draft gives immediate
  // feedback instead of feeling like nothing happened until the drawer
  // closes on its own moments later.
  const [formSubmitting, setFormSubmitting] = useState(false);
  // Which action ("review" | "draft" | "publish") the in-flight submit is
  // for, so only the button the user actually clicked shows a spinner —
  // not every footer button at once.
  const [activeActionType, setActiveActionType] = useState(null);
  // Publish polling — tracks posts sent to LinkedIn that haven't received a postId yet
  const pendingPublishIdsRef = useRef(new Set());
  const publishPollIntervalRef = useRef(null);
  const publishPollCountRef = useRef(0);
  // Socket.io ref for real-time publish confirmation (polling is the fallback)
  const socketRef = useRef(null);
  const [themeData, setThemeData] = useState([]);
  const [selectedTheme, setSelectedTheme] = useState(null);
  const [subPillars, setSubPillars] = useState([]);
  const [editId, setEditId] = useState(null);
  const [isSubmittedModalOpen, setIsSubmittedModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const actionTypeRef = useRef("review");
  const [lastComment, setLastComment] = useState(null);
  const [lastCommentData, setLastCommentData] = useState([]);
  // Shared planning-notes thread — Client/BM/BS/Admin can all add to it;
  // it's what the client sees on a bare-Draft post's planning preview, and
  // stays visible afterward as a running planning log.
  const [planningNotes, setPlanningNotes] = useState([]);
  const [planningNoteDraft, setPlanningNoteDraft] = useState("");
  const [publishOption, setPublishOption] = useState("now");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerShouldOpen, setDrawerShouldOpen] = useState(false);
  // Calendar markings (admin can create/edit/delete self/team-wide markings)
  const [markingsData, setMarkingsData] = useState([]);
  const [blogWriteRequestsData, setBlogWriteRequestsData] = useState([]);
  const [isAdminMarkingModalOpen, setIsAdminMarkingModalOpen] = useState(false);
  const [editingAdminMarking, setEditingAdminMarking] = useState(null);
  const [adminMarkingForm] = Form.useForm();
  const [adminMarkingStartDate, setAdminMarkingStartDate] = useState(null);
  const [adminMarkingEndDate, setAdminMarkingEndDate] = useState(null);
  const [activeAdminMarkingPopoverId, setActiveAdminMarkingPopoverId] = useState(null);
  const [adminMarkingAssociates, setAdminMarkingAssociates] = useState(null);
  // Holidays (admin CRUD)
  const [holidaysData, setHolidaysData] = useState([]);
  const [holidayRegionOptions, setHolidayRegionOptions] = useState(DEFAULT_REGION_OPTIONS);
  const [activeHolidayPopoverId, setActiveHolidayPopoverId] = useState(null);
  // Drag and drop state (admin side)
  const [draggedPost, setDraggedPost] = useState(null);
  const [dragOverDate, setDragOverDate] = useState(null);
  const [isDraggingActive, setIsDraggingActive] = useState(false);
  const [isHolidayModalOpen, setIsHolidayModalOpen] = useState(false);
  const [editingHoliday, setEditingHoliday] = useState(null);
  const [holidayForm] = Form.useForm();
  const holidayVisibilityType = Form.useWatch("holidayVisibilityType", holidayForm);
  const [holidayStartDate, setHolidayStartDate] = useState(null);
  const [holidayEndDate, setHolidayEndDate] = useState(null);
  const [pollQuestion, setPollQuestion] = useState("");
  const [pollOptions, setPollOptions] = useState(["", ""]);
  const [pollResults, setPollResults] = useState(null);
  const [pollResultsLoading, setPollResultsLoading] = useState(false);
  const [pollResultsForbidden, setPollResultsForbidden] = useState(false);
  const [pendingPostType, setPendingPostType] = useState(null);
  const [typeChangeModalVisible, setTypeChangeModalVisible] = useState(false);

  // Send to Graphics — pre-fills a Graphics Request from the post currently
  // open. Admin always bypasses the workload block (per spec), so unlike the
  // brand-side version there's no workload warning/blocked flow here.
  const [gfxModalVisible, setGfxModalVisible] = useState(false);
  const [gfxForm] = Form.useForm();
  const [gfxMembers, setGfxMembers] = useState([]);
  const [gfxFileList, setGfxFileList] = useState([]);
  const [gfxSaving, setGfxSaving] = useState(false);

  const { request } = useRequest();
  const showModal = () => {
    setIsModalVisible(false);
    setIsModalVisible01(true);
  };
  const { id } = useParams();
  const handleCancel = () => {
    setIsModalVisible01(false);
  };
  const [open, setOpen] = useState(false);
  const selectActionType = (type) => {
    actionTypeRef.current = type;
    setActiveActionType(type);
  };

  const showDrawer = () => {
    setIsDrawerAction(true);
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setEditId(null);
  };

  // Autosave the composed post as a real Draft Post — matching what "Save as
  // Draft" already produces — so accidentally closing this drawer (X button,
  // mask click, Escape) leaves a recoverable entry right on the calendar
  // instead of discarding everything. Only active for a brand-new post — a
  // post already being edited has its own record and is left alone.
  const {
    scheduleSave: scheduleDrawerDraftSave,
    saveNow: flushDrawerDraft,
    getDraftId: getDrawerDraftId,
    setDraftId: setDrawerDraftId,
    cancelTick: cancelDrawerDraftTick,
    waitForPendingSave: waitForDrawerDraftSave,
  } = useDraftAutosave({
    enabled:
      open &&
      !!id &&
      (!isEditMode || isDraftRecordStatus(record)) &&
      (!!postText?.trim() || !!form.getFieldValue("title")),
    getPayload: () => {
      return {
        title: form.getFieldValue("title") || stripHtml(postText || "").trim().slice(0, 60) || "Untitled Post",
        contentTheme: form.getFieldValue("contentTheme"),
        subPillar: form.getFieldValue("subPillar"),
        mediaType: form.getFieldValue("mediaType") || "Media",
        postText,
        ...postOptionsPayloadField(),
        ...(!isEditMode ? { media: attachment?.map((item) => item.url) || [] } : {}),
        action: "draft",
        isAutosave: true,
        // Matches what a manual "Save as Draft" click sends for this panel.
        clientStatus: "Draft By Admin",
        brandStatus: "Draft",
        ...(selectedDate ? {
          selectedDate,
          selectedTime,
          timezone: getBrowserTimezone(),
          timezoneOffset: getTimezoneOffsetForSchedule(selectedDate, selectedTime),
        } : {}),
      };
    },
    createUrl: `/admin/access-module/calender/${id}`,
    updateUrl: (draftId) => `/admin/access-module/calender/${draftId}`,
    // Refresh the calendar list once the draft is first created so it shows
    // up immediately, without waiting for the next manual refresh.
    onSaved: (_draftId, { created }) => {
      if (created) fetchData();
    },
  });

  useEffect(() => {
    scheduleDrawerDraftSave();
  }, [postText, attachment, extraOptionTexts, scheduleDrawerDraftSave]);

  // Debounce alone would miss an in-app close (X / mask / Escape) that
  // happens before the timer fires — flush immediately whenever the drawer
  // is dismissed this way, then free the pointer for the next fresh post.
  const closeCreatePostDrawer = () => {
    flushDrawerDraft();
    setDrawerDraftId(null);
    resetForm();
    onClose();
    setIsEditMode(false);
  };

  const [uploadedImage, setUploadedImage] = useState(null);
  const authorName = user?.name || user?.linkedinName || "Your Profile";
  // Uploaded picture first, then LinkedIn's synced photo, then the faceless
  // silhouette icon — matches LinkedIn's own placeholder behavior.
  const authorImage = user?.image || user?.linkedinProfile || UserImage;
  const authorMeta = [user?.jobTitle, user?.organization]
    .filter(Boolean)
    .join(" • ");
  workspaceBusyRef.current = !!(formSubmitting || isPublishSubmitting);
  const markNeedsOption = filledOptionCount >= 2 && ((record?.postOptions || []).length >= 2 || !!pendingMarkExternalPostId);
  const clientApprovedIdx = optionDefs.findIndex((_, k) => !!(record?.postOptions || [])[k]?.clientApproved);
  const markOptionValue = markExternalOption !== null ? markExternalOption : clientApprovedIdx >= 0 ? clientApprovedIdx : null;
  const activeOptionText = activePostOption === 0 ? postText : extraOptionTexts[activePostOption - 1] || "";
  const previewAttachment = activePostOption === 0 ? attachment : extraOptionMedia[activePostOption - 1] || [];
  const previewText = stripHtml(activeOptionText || "");
  const previewLinkedInText = convertHtmlToLinkedInStyledText(activeOptionText || "");
  const previewTitle = form.getFieldValue("title");
  const canModifyPost = isEditMode
    ? Boolean(calendarPermission?.edit)
    : Boolean(calendarPermission?.add);
  const isScheduledLocked = isEditMode && record?.action === "publish" && isPostScheduledForFuture(record) && !isDirty;
  // A brand-new post (not editing an existing one) being composed for a date
  // that's already in the past can't legitimately go through Send for
  // Review/Save as Draft/Publish — there's no "later" left to schedule or
  // review it for. The only honest thing to record is that it was already
  // published somewhere else (LinkedIn's native app, say) before this entry
  // was made. Existing posts are completely unaffected regardless of their
  // own date — this only ever applies to a fresh compose session.
  const isPastDateNew = !isEditMode && !!selectedDate && moment(selectedDate, "YYYY-MM-DD").isBefore(moment(), "day");
  // Once a post has actually gone live, the action buttons (Send for Review,
  // Save as Draft, Publish) have nothing left to do — hide them so a client-
  // approved/published post doesn't look like it's still awaiting action.
  // They come back the moment the user edits (isDirty), same as the
  // scheduled-post lock above. Distinct from isPublishedLocked below, which
  // locks individual form FIELDS (media/pillar/etc.) regardless of isDirty.
  // isPostPublished (postId set) is STICKY — it stays true forever once a post
  // has ever gone live, even after it's pulled back into an active review
  // cycle. Without this exclusion, resending an already-published post for
  // review would wrongly hide every footer button, because the stale postId
  // alone satisfied the lock.
  const isPendingReview = record?.clientStatus === "Under Review" || record?.action === "review";
  const isPublishedFooterLocked = isEditMode && isPostPublished(record) && !isDirty && !isPendingReview;
  // Once a post is live on LinkedIn, only its text can still change —
  // media, schedule, tags/pillars, and post type are locked. Mirrors the
  // backend guard in AccessModuleController.editCalender.
  const isPublishedLocked = isEditMode && isPostPublished(record);

  // Stable reference (NormalEditor is React.memo'd) — a plain inline function
  // here would be a brand-new onChange prop on every FullCalender render,
  // which defeats the memo and forces the whole editor+toolbar to re-render
  // even for changes that have nothing to do with typing.
  const syncPostText = useCallback((value) => {
    const normalizedValue = normalizeEditorHtml(value);
    // The editor also fires onChange for plain clicks/selection moves — only
    // an actual text change should invalidate the analysis (and its
    // highlights); a click on a highlight must not wipe them.
    const textChanged = (postTextLiveRef.current || "") !== normalizedValue;
    postTextLiveRef.current = normalizedValue;
    form.setFieldsValue({ postText: normalizedValue });
    setPostText(normalizedValue);
    if (textChanged) setPostAnalysis(null);
  }, [form]);

  const handleRewriteWithAI = () => {
    const textToCheck = stripHtml(postText || "").trim();
    if (!textToCheck) {
      ShowToast("Write some content first.", Severty.ERROR);
      return;
    }
    navigate(`/writing-assistant/${id}`, { state: { initialContent: postText } });
  };

  const handleAnalyzePostContent = async () => {
    const textToAnalyze = stripHtml(postText || "").trim();
    if (!textToAnalyze) {
      ShowToast("Write some content first.", Severty.ERROR);
      return;
    }
    setPostAnalysisLoading(true);
    handleCheckPostGuidelines(textToAnalyze); // fire alongside analysis, not awaited — own loading state
    try {
      const res = await request({
        url: "/admin/access-module/research/analyze",
        method: "POST",
        data: { text: textToAnalyze, language: "en" },
      });
      if (!res?.data) throw new Error("No analysis returned");
      // Discard this result if the editor's content changed while the
      // request was in flight.
      if (stripHtml(postTextLiveRef.current || "").trim() !== textToAnalyze) {
        return;
      }
      setPostAnalysis(res.data);
      ShowToast("Content analyzed!", Severty.SUCCESS);
    } catch {
      ShowToast("Analysis failed.", Severty.ERROR);
    } finally {
      setPostAnalysisLoading(false);
    }
  };

  const submitPlanningNote = async () => {
    if (!planningNoteDraft.trim() || !editId) return;
    try {
      const res = await request({
        url: `/admin/access-module/post/${editId}/planning-note`,
        method: "PUT",
        data: { text: planningNoteDraft },
      });
      if (res?.status === 200) {
        setPlanningNotes(res.data?.planningNotes || []);
        setPlanningNoteDraft("");
      } else {
        ShowToast(res?.message || "Failed to add note", Severty.ERROR);
      }
    } catch {
      ShowToast("Failed to add note", Severty.ERROR);
    }
  };

  const handleCheckPostGuidelines = async (text) => {
    const textToCheck = text || stripHtml(postText || "").trim();
    if (!textToCheck) {
      ShowToast("Write some content first.", Severty.ERROR);
      return;
    }
    setPostGuidelineCheckLoading(true);
    try {
      const res = await request({
        url: "/admin/access-module/research/guideline-check",
        method: "POST",
        data: { text: textToCheck, guideline: "AP-inspired" },
      });
      if (!res?.data) throw new Error("No guideline check result returned");
      setPostGuidelineCheck(res.data);
    } catch {
      ShowToast("Guideline check failed.", Severty.ERROR);
    } finally {
      setPostGuidelineCheckLoading(false);
    }
  };

  const handleCopyPostGuidelineSuggestion = async (suggestion) => {
    try {
      await navigator.clipboard.writeText(suggestion);
      ShowToast("Suggestion copied!", Severty.SUCCESS);
    } catch {
      ShowToast("Could not copy — clipboard access blocked.", Severty.ERROR);
    }
  };


  const handleImageUpload = (info) => {
    const file = info.file.originFileObj;
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setUploadedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDateSelect = (value) => {
    setIsDrawerAction(false);
    setDrawerShouldOpen(false);

    setIsDrawerOpen(true);
    setSelectedDate(moment(value).format("YYYY-MM-DD"));
    // setOpen(true);
  };

  const handleReschedule = async () => {
    if (!rescheduleDate) {
      ShowToast("Please select a new date", Severty.WARNING);
      return;
    }
    const newDate = rescheduleDate.format("YYYY-MM-DD");
    const newTime = rescheduleTime ? rescheduleTime.format("HH:mm") : null;
    setRescheduleLoading(true);

    // move-date (used below) only ever updates selectedDate/selectedTime —
    // it has no postText/media parameters of its own, and this modal opens
    // on top of the main edit drawer without saving it first, so any
    // caption/media edit still sitting unsaved in the main form got
    // silently discarded the moment reschedule succeeded. Persist the main
    // form's current state first (same payload shape onEdit builds), then
    // move-date changes the date on what was just saved. Only runs when the
    // drawer that owns this form is actually open for this same post
    // (editId matches) — the Reschedule button can also be clicked straight
    // from a calendar card with the drawer closed, and there's no form to
    // persist in that case.
    if (open && editId && String(editId) === String(reschedulePost?._id)) {
      flushAllPostEditors();
      let mainFormValues;
      try {
        mainFormValues = await form.validateFields();
      } catch (e) {
        setRescheduleLoading(false);
        return; // required-field validation failed — surfaced by the form itself
      }

      const urls =
        attachment && attachment.length
          ? attachment?.map((item) => item.url)
          : "";
      const pollDataReschedule = mainFormValues.mediaType === "Poll"
        ? {
            question: pollQuestion,
            options: pollOptions.filter((o) => o.trim()),
            duration: parseInt(mainFormValues.pollDuration || "3"),
          }
        : undefined;
      const carouselDocumentTitleReschedule = mainFormValues.mediaType === "Carousel"
        ? mainFormValues.carouselDocumentTitle
        : undefined;
      let attachmentTypeReschedule = "none";
      if (mainFormValues.mediaType === "Carousel") {
        attachmentTypeReschedule = "carousel";
      } else if (mainFormValues.mediaType === "Media" && urls && urls.length > 0) {
        const firstUrl = Array.isArray(urls) ? urls[0] : String(urls).split(",")[0];
        attachmentTypeReschedule = isVideoUrl(firstUrl) ? "video" : "image";
      }

      const persistPayload = {
        ...mainFormValues,
        media: urls,
        postType: mainFormValues.mediaType,
        ...postOptionsPayloadField(),
        attachmentType: attachmentTypeReschedule,
        selectedDate: selectedDate || newDate,
        selectedTime: selectedTime || newTime,
        timezone: getBrowserTimezone(),
        timezoneOffset: getTimezoneOffsetForSchedule(selectedDate || newDate, selectedTime || newTime),
        isAutosave: true,
        ...(pollDataReschedule ? { pollData: pollDataReschedule } : {}),
        ...(carouselDocumentTitleReschedule != null ? { carouselDocumentTitle: carouselDocumentTitleReschedule } : {}),
      };

      const saved = await request({
        url: `/admin/access-module/calender/${editId}`,
        method: "PUT",
        data: persistPayload,
        onError: () => ShowToast("Failed to save latest changes before rescheduling", Severty.ERROR),
      });
      if (saved?.status !== 200) {
        if (saved) ShowToast(saved.message, Severty.ERROR);
        setRescheduleLoading(false);
        return;
      }
    }

    request({
      url: `/admin/access-module/calender/move-date/${reschedulePost._id}`,
      method: "PUT",
      data: { selectedDate: newDate, ...(newTime ? { selectedTime: newTime } : {}) },
      onSuccess: () => {
        ShowToast("Post rescheduled successfully", Severty.SUCCESS);
        setRescheduleModalVisible(false);
        setReschedulePost(null);
        setRescheduleDate(null);
        setRescheduleTime(null);
        setRescheduleLoading(false);
        resetForm();
        setIsEditMode(false);
        fetchData();
      },
      onError: (err) => {
        ShowToast(err?.response?.data?.message || "Failed to reschedule post", Severty.ERROR);
        setRescheduleLoading(false);
      },
    });
  };

  const handleOpenCreateModal = (value) => {
    resetForm();
    setIsEditMode(false);
    setRecord(null);
    setEditId(null);
    selectActionType("review");
    handleDateSelect(value.toDate ? value.toDate() : value);
    setIsCreateModalVisible(true);
  };

  const handleAddPostClick = () => {
    setIsCreateModalVisible(false);
    // Cancel any pending autosave debounce tick from whatever session was
    // active before this click, FIRST — same reasoning as handleEditClick.
    // Without this, a stale tick from a previously-viewed/composed post can
    // fire after this fresh compose session's own data is already in the
    // form, creating a stray duplicate.
    cancelDrawerDraftTick();
    // Guarantee a clean compose state regardless of what happened last time
    // this drawer was open. The onEdit success path closes the drawer via a
    // plain setOpen(false) instead of closeCreatePostDrawer, and never resets
    // isEditMode/editId/record. Without this, clicking "Add Post" right after
    // successfully editing an existing post would submit through onEdit using
    // the stale editId — silently overwriting that previous post instead of
    // creating a new one.
    setIsEditMode(false);
    setEditId(null);
    setRecord(null);
    setDrawerDraftId(null);
    // Don't rely on the [open]-only useEffect elsewhere in this file to clear
    // this — it only fires on a false->true transition and reads isEditMode
    // from whatever render it happens to run in, which is fragile. Verified
    // live (brand-manager-Imergey, same code pattern): after viewing a
    // locked/published post (isDisable gets set true) and then opening a
    // brand-new compose form, that effect can miss the reset, leaving every
    // field on the new post's form disabled. Set it directly here instead.
    setIsDisable(false);
    resetForm();
    setOpen(true);
  };

  const handleAddBlogClick = () => {
    setIsCreateModalVisible(false);
    navigate(`/create-new-manully-blog/${id}`, {
      state: { mode: "create", selectedDate },
    });
  };

  // Was "Write Blog on LinkedIn" (opened LinkedIn's own article editor in a
  // new tab). Per direct request, admin/brand-manager now route this into
  // the internal Blog Write Requests workflow instead — staff brief a Blog
  // Writer Team member rather than drafting the LinkedIn article
  // themselves. selectedDate carries over as the request's prefilled
  // Delivery Date. User-panel deliberately keeps the old LinkedIn-editor
  // behavior (no Blog Write Team there) — see that repo's own
  // FullCalender.js, unchanged.
  const handleSendBlogWriteRequestClick = () => {
    setIsCreateModalVisible(false);
    blogRequestForm.resetFields();
    blogRequestForm.setFieldsValue({
      deliveryDate: selectedDate ? moment(selectedDate) : null,
      priority: "Medium",
    });
    setBlogRequestOutline(undefined);
    setBlogRequestFileList([]);
    if (blogWriteMembers.length === 0) {
      request({
        url: apiPath.blogWriteTeamMembers,
        method: "GET",
        onSuccess: (data) => setBlogWriteMembers(data?.data?.members || []),
        onError: () => {},
      });
    }
    setBlogRequestModalOpen(true);
  };

  const submitBlogRequest = (values) => {
    setSavingBlogRequest(true);
    const formData = new FormData();
    formData.append("clientId", user?._id || "");
    formData.append("clientNameRef", user?.name || "");
    formData.append("projectTitle", values.projectTitle);
    if (values.deliveryDate) formData.append("deliveryDate", `${values.deliveryDate.format("YYYY-MM-DD")}T00:00:00.000Z`);
    formData.append("priority", values.priority || "Medium");
    if (values.assignedTo) formData.append("assignedTo", values.assignedTo);
    formData.append("outline", JSON.stringify(blogRequestOutline || {}));
    blogRequestFileList.forEach((f) => formData.append("referenceFiles", f));
    request({
      url: apiPath.blogWriteRequests,
      method: "POST",
      data: formData,
      onSuccess: (data) => {
        setSavingBlogRequest(false);
        if (data.status === 200 || data.status === true) {
          ShowToast("Blog request raised", Severty.SUCCESS);
          setBlogRequestModalOpen(false);
          blogRequestForm.resetFields();
          setBlogRequestOutline(undefined);
          setBlogRequestFileList([]);
          fetchBlogWriteRequests();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (err) => {
        setSavingBlogRequest(false);
        ShowToast(err?.response?.data?.message || "Failed to create request", Severty.ERROR);
      },
    });
  };

  const handleCopy = (text, successMsg = "Copied to clipboard!") => {
    if (!text) {
      ShowToast("Nothing to copy.", Severty.ERROR);
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(() => ShowToast(successMsg, Severty.SUCCESS))
        .catch(() => {
          const el = document.createElement("textarea");
          el.value = text;
          el.style.position = "fixed";
          el.style.opacity = "0";
          document.body.appendChild(el);
          el.focus();
          el.select();
          document.execCommand("copy");
          document.body.removeChild(el);
          ShowToast(successMsg, Severty.SUCCESS);
        });
    } else {
      const el = document.createElement("textarea");
      el.value = text;
      el.style.position = "fixed";
      el.style.opacity = "0";
      document.body.appendChild(el);
      el.focus();
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      ShowToast(successMsg, Severty.SUCCESS);
    }
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedDate(null);
  };

  // Drag and drop handlers (admin side)
  const handleDragStart = (e, item) => {
    e.stopPropagation();
    setIsDraggingActive(true);
    setDraggedPost(item);
    if (e.dataTransfer) {
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/plain", item._id);
    }
    if (e.currentTarget) e.currentTarget.style.opacity = "0.5";
  };

  const handleDragEnd = (e) => {
    if (e.currentTarget) e.currentTarget.style.opacity = "1";
    setIsDraggingActive(false);
    setDraggedPost(null);
    setDragOverDate(null);
  };

  const handleDragOver = (e, date) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer) e.dataTransfer.dropEffect = "move";
    setDragOverDate(date);
  };

  const handleDragLeave = (e) => {
    e.stopPropagation();
    if (e.currentTarget.contains(e.relatedTarget)) return;
    setDragOverDate(null);
  };

  const handleDrop = (e, targetDate) => {
    e.preventDefault();
    e.stopPropagation();
    setDragOverDate(null);

    if (!draggedPost) return;

    const targetFormattedDate = moment(targetDate).format("YYYY-MM-DD");
    // .utc() — draggedPost.selectedDate is stored as UTC midnight of the
    // intended calendar day; reading it with a plain moment() re-interprets
    // that instant in the viewer's own browser timezone, which can read a
    // day early/late depending on the viewer, making this no-op check
    // disagree with what's actually on screen (same root cause as
    // getScheduledMoment's fix above).
    const currentFormattedDate = moment.utc(draggedPost.selectedDate).format("YYYY-MM-DD");

    if (targetFormattedDate === currentFormattedDate) {
      setDraggedPost(null);
      setIsDraggingActive(false);
      return;
    }

    const postToMove = draggedPost;
    const previousDate = postToMove.selectedDate;
    const existingTime = postToMove.selectedTime || "09:00";
    setDraggedPost(null);
    setIsDraggingActive(false);

    // Optimistic update — move the card to the new date immediately instead
    // of waiting for the PUT to round-trip and only updating on its
    // response. Even a fast request is still a real network round-trip, and
    // leaving the UI unchanged during it makes the drop look like it didn't
    // register. Rolled back below if the request actually fails.
    setCalenderData((prev) =>
      prev.map((p) =>
        p._id === postToMove._id ? { ...p, selectedDate: targetFormattedDate } : p
      )
    );

    request({
      url: `/admin/access-module/calender/move-date/${postToMove._id}`,
      method: "PUT",
      data: { selectedDate: targetFormattedDate, selectedTime: existingTime },
      onSuccess: (data) => {
        if (data.status !== 200) {
          // Roll back — the optimistic move above didn't actually take.
          setCalenderData((prev) =>
            prev.map((p) =>
              p._id === postToMove._id ? { ...p, selectedDate: previousDate } : p
            )
          );
          ShowToast(data.message || "Failed to move post", Severty.ERROR);
          return;
        }
        ShowToast("Post moved successfully", Severty.SUCCESS);
      },
      onError: (err) => {
        // Roll back — the optimistic move above didn't actually take.
        setCalenderData((prev) =>
          prev.map((p) =>
            p._id === postToMove._id ? { ...p, selectedDate: previousDate } : p
          )
        );
        // Was a generic "Error moving post" regardless of cause — silently
        // discarding the backend's actual reason (e.g. ALREADY_PUBLISHED,
        // or the PAST_DATE guard against accidentally triggering an
        // immediate live publish).
        ShowToast(err?.response?.data?.message || "Error moving post", Severty.ERROR);
      },
    });
  };

  const dateCellRender = (value) => {
    const formattedDate = moment(value).format("YYYY-MM-DD");
    const isFutureDate = value.isSameOrAfter(moment(), "day");

    // Get all items matching this date (regardless of month)
    const listData = calendarData?.filter(
      (entry) => {
        const scheduledAt = getScheduledMoment(entry);
        return (
          scheduledAt?.isValid() &&
          scheduledAt.format("YYYY-MM-DD") === formattedDate
        );
      }
    );

    // Get markings that span this date
    const dayMarkings = markingsData.filter((m) => {
      const start = moment(m.startDate).format("YYYY-MM-DD");
      const end = moment(m.endDate).format("YYYY-MM-DD");
      return formattedDate >= start && formattedDate <= end;
    });

    // Get holidays that span this date
    const dayHolidays = holidaysData.filter((h) => {
      const start = moment(h.startDate).format("YYYY-MM-DD");
      const end = moment(h.endDate).format("YYYY-MM-DD");
      return formattedDate >= start && formattedDate <= end;
    });

    // Get Blog Write requests raised for this client whose delivery date is this day.
    const dayBlogWriteRequests = blogWriteRequestsData.filter((r) => {
      return r.deliveryDate && moment(r.deliveryDate).format("YYYY-MM-DD") === formattedDate;
    });

    const isDragOver =
      dragOverDate &&
      moment(dragOverDate).format("YYYY-MM-DD") === formattedDate;

    return (
      <div
        className={`calendar-cell-content${isFutureDate ? " cal-future" : ""}`}
        style={{
          backgroundColor: isDragOver ? "#e6f7ff" : "transparent",
          border: isDragOver ? "2px dashed #1890ff" : "2px solid transparent",
          borderRadius: "4px",
          minHeight: "80px",
          height: "100%",
          boxSizing: "border-box",
        }}
      >
        {/* Holidays (admin can edit/delete) */}
        {dayHolidays.length > 0 && (
          <div className="calendar-markings-area">
            {dayHolidays.map((holiday) => {
              const tooltipContent = (
                <div style={{ maxWidth: 240 }}>
                  <div style={{ fontWeight: 600, marginBottom: 4 }}>
                    {HOLIDAY_CONFIG.emoji} {holiday.name}
                  </div>
                  <div style={{ fontSize: 11, color: "#8c6914", marginBottom: 4 }}>
                    {holiday.category || HOLIDAY_CONFIG.label} - {holiday.visibilityType === "region" ? "Region / timezone specific" : "Global"}
                  </div>
                  {holiday.timezone && (
                    <div style={{ fontSize: 11, color: "#8c6914", marginBottom: 4 }}>
                      Timezone: {holiday.timezone}
                    </div>
                  )}
                  {holiday.region && (
                    <div style={{ fontSize: 11, color: "#8c6914", marginBottom: 4 }}>
                      🌐 {holiday.region}
                    </div>
                  )}
                  {holiday.description && (
                    <div style={{ fontSize: 12, color: "#555", marginBottom: 8 }}>{holiday.description}</div>
                  )}
                  <div style={{ display: "flex", gap: 8 }}>
                    <Button
                      size="small"
                      icon={<EditOutlined />}
                      onClick={(e) => {
                        e.stopPropagation();
                        setActiveHolidayPopoverId(null);
                        openEditHolidayModal(holiday);
                      }}
                      style={{ fontSize: 11 }}
                    >
                      Edit
                    </Button>
                    <Button
                      size="small"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={(e) => {
                        e.stopPropagation();
                        setActiveHolidayPopoverId(null);
                        deleteHoliday(holiday._id);
                      }}
                      style={{ fontSize: 11 }}
                    >
                      Remove
                    </Button>
                  </div>
                </div>
              );
              return (
                <Popover
                  key={holiday._id}
                  content={tooltipContent}
                  title={null}
                  trigger="click"
                  placement="bottom"
                  open={activeHolidayPopoverId === holiday._id}
                  onOpenChange={(open) =>
                    setActiveHolidayPopoverId(open ? holiday._id : null)
                  }
                >
                  <div
                    className="calendar-marking-strip calendar-holiday-strip"
                    style={{
                      backgroundColor: HOLIDAY_CONFIG.bg,
                      borderLeftColor: HOLIDAY_CONFIG.color,
                      color: HOLIDAY_CONFIG.color,
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <span className="marking-emoji">{HOLIDAY_CONFIG.emoji}</span>
                    <span className="marking-label">{holiday.name}</span>
                  </div>
                </Popover>
              );
            })}
          </div>
        )}

        {/* Calendar Markings — read-only for admin, shows User/Brand creator label */}
        {dayMarkings.length > 0 && (
          <div className="calendar-markings-area">
            {dayMarkings.map((marking) => {
              const typeConfig = MARKING_TYPES[marking.type] || MARKING_TYPES.other;
              const isBrandMarking = marking.createdByType === "brand";
              const isAdminMarking = marking.createdByType === "admin" || marking.targetAdmins === true;
              const creatorFullName = marking.createdByUserId?.name || "";
              const creatorFirstName = creatorFullName
                ? creatorFullName.split(" ")[0]
                : isBrandMarking ? "Brand" : "User";
              const targetName =
                marking.targetAdmins === true
                  ? "Admin"
                  : marking.userId && typeof marking.userId === "object" && marking.userId.name
                  ? marking.userId.name.split(" ")[0]
                  : null;
              const creatorLabel = targetName || creatorFirstName;
              const tooltipContent = (
                <div style={{ maxWidth: 240 }}>
                  <div style={{ fontWeight: 600, marginBottom: 4 }}>
                    {typeConfig.emoji} {typeConfig.label}
                  </div>
                  <div style={{ fontSize: 11, color: "#8c8c8c", marginBottom: 4 }}>
                    Created by: <strong>{creatorFullName || (isBrandMarking ? "Brand" : "User")}</strong>
                  </div>
                  <div style={{ fontSize: 12, color: "#555", marginBottom: 4 }}>
                    {moment(marking.startDate).format("MMM D")}
                    {moment(marking.startDate).format("YYYY-MM-DD") !== moment(marking.endDate).format("YYYY-MM-DD") &&
                      ` – ${moment(marking.endDate).format("MMM D")}`}
                  </div>
                  {marking.isBroadcast && (
                    <div style={{ fontSize: 11, color: "#6366f1", marginBottom: 4 }}>
                      🌐 Visible to all clients
                    </div>
                  )}
                  {marking.note && (
                    <div style={{ fontSize: 12, color: "#333" }}>{marking.note}</div>
                  )}
                  {isAdminMarking && (
                    <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                      <Button
                        size="small"
                        icon={<EditOutlined />}
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveAdminMarkingPopoverId(null);
                          openEditAdminMarkingModal(marking);
                        }}
                        style={{ fontSize: 11 }}
                      >
                        Edit
                      </Button>
                      <Button
                        size="small"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveAdminMarkingPopoverId(null);
                          deleteAdminMarking(marking._id);
                        }}
                        style={{ fontSize: 11 }}
                      >
                        Remove
                      </Button>
                    </div>
                  )}
                </div>
              );
              return (
                <Popover
                  key={marking._id}
                  content={tooltipContent}
                  title={null}
                  trigger="click"
                  placement="bottom"
                  open={activeAdminMarkingPopoverId === marking._id}
                  onOpenChange={(open) =>
                    setActiveAdminMarkingPopoverId(open ? marking._id : null)
                  }
                >
                  <div
                    className={`calendar-marking-strip${isBrandMarking ? " brand-marking" : ""}${marking.isBroadcast ? " broadcast-marking" : ""}`}
                    style={{
                      backgroundColor: typeConfig.bg,
                      borderLeftColor: typeConfig.color,
                      color: typeConfig.color,
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <span className="marking-creator-tag">{creatorLabel}</span>
                    <span className="marking-emoji">{typeConfig.emoji}</span>
                    {/* Only "Observation / Note" markings show the actual
                        typed note on the strip itself (matching how an
                        admin-managed Holiday shows its real name) — every
                        other marking type (Out of Office, Travel, Other)
                        keeps showing its generic type label as before. */}
                    <span className="marking-label">
                      {marking.type === "observation" && marking.note?.trim()
                        ? marking.note.trim()
                        : typeConfig.label}
                    </span>
                  </div>
                </Popover>
              );
            })}
          </div>
        )}

        {/* Blog Write requests raised for this client — same calendar-card
            shape Posts/Blogs already use (icon banner + title + status
            pill), not a thin strip, so it reads as a card among the other
            cards instead of a marking. Clicking opens the exact same
            request detail page the Blog Write module's own "View" opens. */}
        {dayBlogWriteRequests.map((r) => {
          const label = BLOG_WRITE_CALENDAR_STATUS_LABEL(r);
          return (
            <div
              key={r._id}
              className="calendar-card"
              style={{ borderLeftColor: "#08979C", cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/blog-write-requests/${r._id}`);
              }}
            >
              <div className="cal-card-banner" style={{ background: "linear-gradient(135deg,#13c2c2 0%,#08979C 100%)" }}>
                <span className="cal-card-type-pill">Blog Request</span>
                <div className="cal-card-banner-placeholder">
                  <span className="cal-card-banner-icon">📝</span>
                </div>
              </div>
              <div className="cal-card-body">
                <div className="cal-card-title">{r.projectTitle}</div>
                <div
                  className="cal-card-status"
                  style={{ background: "#08979C18", color: "#08979C", borderColor: "#08979C50" }}
                >
                  <span>{label}</span>
                </div>
              </div>
            </div>
          );
        })}

        {/* Create/Mark are now available on past dates too — a post created
            on a past date can only be recorded as already-published-
            elsewhere (see the create-drawer's past-date button set below),
            and calendar markings (Out of Office etc.) are just as valid to
            log retroactively as going forward. Only the add permission still
            gates this. */}
        {calendarPermission?.add && (
          <div className="calendar-today-buttons">
            <Button
              className="post-btn-create"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenCreateModal(value);
              }}
            >
              <PlusOutlined /> Create
            </Button>
            <Button
              className="post-btn-create"
              onClick={(e) => {
                e.stopPropagation();
                openAddAdminMarkingModal(value);
              }}
            >
              <PlusOutlined /> Mark
            </Button>
          </div>
        )}

        {/* Show posts for all dates */}
        {listData?.map((item, index) => {
          const statusStyle = getCalendarStatusStyle(item);
          const clientFirstName = (user?.name || user?.linkedinName || "").split(" ")[0] || null;
          const statusLabel = getCalendarStatusLabel(item, clientFirstName);
          const firstMedia =
            item.media && item.media.length > 0
              ? item.media[0]?.split(",")[0].trim()
              : "";
          const theme = resolveCalendarTheme(item, themeData);
          const calendarSubPillars = resolveCalendarSubPillars(item);
          const visibleSubPillars = calendarSubPillars.slice(0, 3);

          const isBlog = item.type === "blog";

          // Banner gradient & icon per post type
          //
          // Video detection previously relied on item.postType === "Video" —
          // but "Video" is never actually a value this app produces. The
          // Type selector only ever offers a single "Media (Image / Video)"
          // option (postType "Media"), with image-vs-video decided by file
          // extension and stored separately as attachmentType. attachmentType
          // isn't even in the Post schema (silently dropped by Mongoose's
          // default strict-schema save), so it can't be trusted here either.
          // The only reliable signal is the media URL's own extension —
          // reuse isVideoUrl(), the same helper the rest of this file already
          // uses to make this exact call. Without this, a genuine video post
          // fell into the "treat as image" branch below and rendered
          // <img src="...mp4">, which browsers show as a broken-image icon.
          const isFirstMediaVideo = isVideoUrl(firstMedia);
          const bannerMeta = (() => {
            if (isBlog) return { bg: "linear-gradient(135deg,#667eea 0%,#764ba2 100%)", icon: "📝", hasMedia: false };
            if (item.postType === "Poll") return { bg: "linear-gradient(135deg,#4facfe 0%,#00c6fb 100%)", icon: "📊", hasMedia: false };
            if (item.postType === "Carousel") return { bg: "linear-gradient(135deg,#f093fb 0%,#f5576c 100%)", icon: "📄", hasMedia: false };
            if (firstMedia) return { bg: "", icon: null, hasMedia: true, isVideo: isFirstMediaVideo };
            if (item.postType === "Video") return { bg: "linear-gradient(135deg,#4e54c8 0%,#8f94fb 100%)", icon: "🎬", hasMedia: false };
            return { bg: "linear-gradient(135deg,#a8c0e0 0%,#3b6b94 100%)", icon: "🖼️", hasMedia: false };
          })();

          const isPublished = Boolean(item.postId);
          const isDraggable = (!isPublished || !!item.publishedExternally) && calendarPermission?.edit;

          return (
            <div
              key={item._id || index}
              className="calendar-card"
              style={{
                borderLeftColor: statusStyle.borderColor,
                cursor: isDraggable ? "grab" : "pointer",
                opacity: draggedPost?._id === item._id ? 0.5 : 1,
              }}
              draggable={isDraggable}
              onDragStart={(e) => { if (isDraggable) handleDragStart(e, item); }}
              onDragEnd={handleDragEnd}
              onClick={() => {
                if (!isDraggingActive && draggedPost?._id !== item._id) handleEditClick(item);
              }}
            >
              {/* ── Banner ── */}
              <div
                className="cal-card-banner"
                style={bannerMeta.bg ? { background: bannerMeta.bg } : {}}
              >
                {isBlog && <span className="cal-card-blog-tag">📄 Blog</span>}
                <span className="cal-card-type-pill">
                  {item.postType || (isBlog ? "Blog" : "Post")}
                </span>
                {bannerMeta.hasMedia ? (
                  bannerMeta.isVideo ? (
                    <video className="cal-card-banner-media" muted draggable={false} onDragStart={(e) => e.preventDefault()}>
                      <source src={firstMedia} type="video/mp4" />
                    </video>
                  ) : (
                    <img src={firstMedia} alt="" className="cal-card-banner-media" draggable={false} onDragStart={(e) => e.preventDefault()} />
                  )
                ) : (
                  <div className="cal-card-banner-placeholder">
                    <span className="cal-card-banner-icon">{bannerMeta.icon}</span>
                  </div>
                )}
              </div>

              {/* ── Card Body ── */}
              <div className="cal-card-body">
                <div className="cal-card-title">{item.title}</div>
                {theme?.name && (
                  <div
                    className="calendar-theme-chip"
                    style={{
                      backgroundColor: `${theme.color}18`,
                      borderColor: `${theme.color}40`,
                      color: theme.color,
                    }}
                    title={theme.name}
                  >
                    <span className="calendar-theme-dot" style={{ backgroundColor: theme.color }} />
                    <span className="calendar-theme-name">{theme.name}</span>
                  </div>
                )}
                {visibleSubPillars.length > 0 && (
                  <div className="calendar-subpillar-row">
                    {visibleSubPillars.map((pillar, pillarIndex) => (
                      <span
                        key={`${pillar}-${pillarIndex}`}
                        className="calendar-subpillar-chip"
                        style={{
                          backgroundColor: `${theme?.color || "#3B6B94"}10`,
                          borderColor: `${theme?.color || "#3B6B94"}30`,
                          color: theme?.color || "#3B6B94",
                        }}
                        title={pillar}
                      >
                        {pillar}
                      </span>
                    ))}
                    {calendarSubPillars.length > visibleSubPillars.length && (
                      <span className="calendar-subpillar-more">
                        +{calendarSubPillars.length - visibleSubPillars.length}
                      </span>
                    )}
                  </div>
                )}
                <div
                  className="cal-card-status"
                  style={{
                    background: statusStyle.borderColor + "18",
                    color: statusStyle.borderColor,
                    borderColor: statusStyle.borderColor + "50",
                  }}
                >
                  {getStatusIcon(statusLabel)}
                  <span>{statusLabel}</span>
                  {item.publishedExternally && (
                    <Tooltip title="Published on LinkedIn (external) — click to view">
                      <a
                        href={item.linkedinPostUrl || undefined}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        style={{ marginLeft: 4, display: "inline-flex", color: "#0A66C2" }}
                      >
                        <LinkedinFilled />
                      </a>
                    </Tooltip>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const handleThemeChange = (value) => {
    const selected = themeData.find((theme) => theme._id === value);
    setSelectedTheme(selected);
    setSubPillars(selected ? selected.subPillars : []);
  };

  const applyPostTypeChange = (newType) => {
    setSelectedPostType(newType);
    setAttachment([]);
    setPollQuestion("");
    setPollOptions(["", ""]);
    setPollResults(null);
    setPollResultsForbidden(false);
    form.setFieldsValue({ mediaType: newType, carouselDocumentTitle: undefined, pollQuestion: undefined, pollDuration: "3" });
  };

  const handlePostTypeChange = (value) => {
    const strippedText = (postText || "").replace(/<[^>]*>/g, "").trim();
    const hasData =
      strippedText.length > 0 ||
      (attachment && attachment.length > 0) ||
      pollQuestion.trim().length > 0 ||
      pollOptions.some((opt) => opt.trim().length > 0) ||
      !!form.getFieldValue("carouselDocumentTitle");
    if (hasData) {
      form.setFieldsValue({ mediaType: selectedPostType });
      setPendingPostType(value);
      setTypeChangeModalVisible(true);
    } else {
      applyPostTypeChange(value);
    }
  };

  const handleMediaChange = (files) => {
    console.log("files", files);

    // Format the files for the attachment state
    const formattedFiles = files?.map((file) => ({
      url: file.url, // Use the URL from the file object
      name: file.name, // Optional: include the name if needed
      status: file.status, // Optional: include the status if needed
    }));

    setAttachment(formattedFiles);
  };

  useEffect(() => {
    if (open) {
      // resetForm();
      {
        !isEditMode && setIsDisable(false);
      }
    }
  }, [open]);

  const resetForm = () => {
    resetPostOptions();
    form.resetFields();
    form.setFieldsValue({ mediaType: "Media" });
    setPostText("");
    setAttachment([]);
    setSelectedPostType("Media");
    setSubPillars([]);
    setPollQuestion("");
    setPollOptions(["", ""]);
    setPollResults(null);
    setIsDirty(false);
  };

  // Pre-fill post editor from Writing Assistant "Send for Post"
  useEffect(() => {
    if (!prefillPostContent) return;
    // Cancel any pending autosave debounce tick from whatever session was
    // active before this, and clear record/drawerDraftId — same reasoning
    // as handleEditClick/handleAddPostClick. This is a third, separate
    // entry point into the compose drawer that was missing both guards.
    cancelDrawerDraftTick();
    setRecord(null);
    setDrawerDraftId(null);
    // Reset to a clean new-post state
    form.resetFields();
    form.setFieldsValue({ mediaType: "Media" });
    setAttachment([]);
    setSelectedPostType("Media");
    setSubPillars([]);
    setPollQuestion("");
    setPollOptions(["", ""]);
    setPollResults(null);
    setIsEditMode(false);
    setEditId(null);
    setIsLinkedInPosted(false);
    setIsDisable(false);
    // Set the writing assistant content as the post text
    const normalized = normalizeEditorHtml(prefillPostContent);
    setPostText(normalized);
    form.setFieldsValue({ postText: normalized });
    // Open the drawer
    setIsDrawerAction(true);
    setOpen(true);
    // Clear the prefill so it doesn't re-trigger
    onPrefillPostHandled?.();
  }, [prefillPostContent]);

  const contentThemeData = async () => {
    try {
      let url = "/admin/access-module/content/" + id;

      request({
        url,
        method: "GET",
        onSuccess: (data) => {
          if (data.status === 200) {
            setThemeData(data.data.themes);
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: () => {
          // ShowToast(`Error ${"creating"} blog`, Severty.ERROR);
        },
        // onFinally: () => setLoading(false),
      });
    } catch (error) {
      console.log("error", error);
    }
  };
  const getCommentStyle = (type) => ({
    background: type === "Brand" ? "#e6f7ff" : "#fff1f0",
    border: `1px solid ${type === "brand" ? "#91d5ff" : "#ffa39e"}`,
    color: "#333",
    padding: "10px 12px",
    borderRadius: "12px",
    maxWidth: "70%",
    wordBreak: "break-word",
  });

  // ── Publish polling ──────────────────────────────────────────────────────────
  const MAX_POLL_ATTEMPTS = 24; // 24 × 5 s = 2 min

  const stopPublishPolling = () => {
    if (publishPollIntervalRef.current) {
      clearInterval(publishPollIntervalRef.current);
      publishPollIntervalRef.current = null;
    }
    publishPollCountRef.current = 0;
  };

  const startPublishPolling = (postDbId) => {
    pendingPublishIdsRef.current.add(postDbId);
    if (publishPollIntervalRef.current) return;

    publishPollCountRef.current = 0;
    publishPollIntervalRef.current = setInterval(() => {
      publishPollCountRef.current += 1;
      if (publishPollCountRef.current > MAX_POLL_ATTEMPTS) {
        stopPublishPolling();
        return;
      }
      request({
        url: "/admin/access-module/calender/" + id,
        method: "GET",
        onSuccess: (data) => {
          if (data.status !== 200) return;
          const freshData = data.data.calendarData || [];
          setCalenderData(freshData);
          pendingPublishIdsRef.current.forEach((pid) => {
            const freshPost = freshData.find((p) => p._id === pid);
            if (freshPost?.postId) {
              pendingPublishIdsRef.current.delete(pid);
              setRecord((prev) => (prev?._id === pid ? freshPost : prev));
            }
          });
          if (pendingPublishIdsRef.current.size === 0) {
            stopPublishPolling();
          }
        },
      });
    }, 5000);
  };
  // ─────────────────────────────────────────────────────────────────────────────

  const fetchData = async (values) => {
    console.log(">>>>>>>>", { ...values, attachment });

    try {
      const urls =
        attachment && attachment.length
          ? attachment?.map((item) => item.url)
          : "";
      console.log(urls);
      // setLoading(true);
      const payload = {
        ...values,
        media: urls,
        selectedDate,
        selectedTime,
      };
      request({
        url: "/admin/access-module/calender/" + id,
        method: "GET",
        onSuccess: (data) => {
          if (data.status === 200) {
            const freshData = data.data.calendarData || [];
            setCalenderData(freshData);
            // Auto-start polling for any publish-pending posts without postId.
            // Covers posts submitted in a previous session and posts where the admin
            // panel has no socket (socket.io-client not installed in admin).
            freshData.forEach((post) => {
              if (!post.postId) {
                const status = String(post.brandStatus || post.clientStatus || "").toLowerCase();
                if (status.includes("publish")) {
                  startPublishPolling(post._id);
                }
              }
            });
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: () => {
          // ShowToast(`Error ${"creating"} blog`, Severty.ERROR);
        },
        // onFinally: () => setLoading(false),
      });
    } catch (error) {
      console.log("Error adding data", error);
      ShowToast("Error adding data.", Severty.ERROR);
    } finally {
      // setLoading(false);
    }
    setIsSubmittedModalOpen(true);
  };

  const fetchMarkings = () => {
    if (!id) return;
    request({
      url: `/admin/access-module/calendar-marking/${id}`,
      method: "GET",
      onSuccess: (data) => {
        if (data.status === 200) {
          setMarkingsData(data.data.markings || []);
        }
      },
      onError: () => {},
    });
  };

  // Active Blog Write requests raised for this client — shown as their own
  // card on the delivery-date cell alongside Posts/Blogs, so staff can see
  // "a blog is in progress for Oct 9" without leaving the calendar. Cancelled
  // requests are already excluded server-side (BlogWriteService.listForClient).
  const fetchBlogWriteRequests = () => {
    if (!id) return;
    request({
      url: `admin/blog-write/requests/client/${id}`,
      method: "GET",
      onSuccess: (data) => {
        if (data.status === 200) {
          setBlogWriteRequestsData(data.data.requests || []);
        }
      },
      onError: () => {},
    });
  };

  const fetchHolidays = () => {
    request({
      url: "/admin/access-module/holidays",
      method: "GET",
      onSuccess: (data) => {
        if (data.status === 200) {
          setHolidaysData(data.data.holidays || []);
        }
      },
      onError: () => {},
    });
  };

  const fetchHolidayRegionOptions = () => {
    request({
      url: "/admin/access-module/holidays/region-options",
      method: "GET",
      onSuccess: (data) => {
        if (data.status === 200) {
          const regions = data.data.regions || [];
          setHolidayRegionOptions(
            regions.length ? regions : DEFAULT_REGION_OPTIONS
          );
        }
      },
      onError: () => {},
    });
  };

  const openAddHolidayModal = (dateValue) => {
    setEditingHoliday(null);
    holidayForm.resetFields();
    const formatted = dateValue ? moment(dateValue).format("YYYY-MM-DD") : null;
    setHolidayStartDate(formatted);
    setHolidayEndDate(formatted);
    holidayForm.setFieldsValue({
      holidayCategory: "Holiday",
      holidayVisibilityType: "global",
    });
    setIsHolidayModalOpen(true);
  };

  const openEditHolidayModal = (holiday) => {
    setEditingHoliday(holiday);
    setHolidayStartDate(moment(holiday.startDate).format("YYYY-MM-DD"));
    setHolidayEndDate(moment(holiday.endDate).format("YYYY-MM-DD"));
    holidayForm.setFieldsValue({
      holidayName: holiday.name,
      holidayCategory: holiday.category || "Holiday",
      holidayVisibilityType: holiday.visibilityType || "global",
      holidayRegion:
        Array.isArray(holiday.regions) && holiday.regions.length
          ? holiday.regions
          : holiday.region
            ? [holiday.region]
            : undefined,
      holidayTimezone: holiday.timezone ? [holiday.timezone] : undefined,
      holidayDescription: holiday.description,
    });
    setIsHolidayModalOpen(true);
  };

  const saveHoliday = (values) => {
    if (!holidayStartDate || !holidayEndDate) {
      ShowToast("Please select start and end dates.", Severty.ERROR);
      return;
    }
    const selectedRegions = Array.isArray(values.holidayRegion)
      ? values.holidayRegion
      : values.holidayRegion
        ? [values.holidayRegion]
        : [];
    const selectedRegion = selectedRegions[0];
    const selectedTimezone = Array.isArray(values.holidayTimezone)
      ? values.holidayTimezone[0]
      : values.holidayTimezone;
    const payload = {
      name: values.holidayName,
      startDate: holidayStartDate,
      endDate: holidayEndDate,
      category: values.holidayCategory || "Holiday",
      visibilityType: values.holidayVisibilityType || "global",
      region: values.holidayVisibilityType === "region" ? selectedRegion || "" : selectedRegion || "International",
      regions: values.holidayVisibilityType === "region" ? selectedRegions : [],
      timezone: selectedTimezone || "",
      description: values.holidayDescription || "",
    };
    if (editingHoliday) {
      request({
        url: `/admin/access-module/holidays/${editingHoliday._id}`,
        method: "PUT",
        data: payload,
        onSuccess: (data) => {
          if (data.status === 200) {
            ShowToast("Event updated", Severty.SUCCESS);
            setIsHolidayModalOpen(false);
            setEditingHoliday(null);
            holidayForm.resetFields();
            fetchHolidays();
          }
        },
        onError: () => ShowToast("Failed to update event", Severty.ERROR),
      });
    } else {
      request({
        url: "/admin/access-module/holidays",
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          if (data.status === 200) {
            ShowToast("Event added", Severty.SUCCESS);
            setIsHolidayModalOpen(false);
            holidayForm.resetFields();
            fetchHolidays();
          }
        },
        onError: () => ShowToast("Failed to add event", Severty.ERROR),
      });
    }
  };

  const deleteHoliday = (holidayId) => {
    request({
      url: `/admin/access-module/holidays/${holidayId}`,
      method: "DELETE",
      onSuccess: (data) => {
        if (data.status === 200) {
          ShowToast("Event removed", Severty.SUCCESS);
          fetchHolidays();
        }
      },
      onError: () => ShowToast("Failed to remove event", Severty.ERROR),
    });
  };

  const openAddAdminMarkingModal = (value) => {
    setEditingAdminMarking(null);
    adminMarkingForm.resetFields();
    const formattedDate = moment(value.toDate ? value.toDate() : value).format("YYYY-MM-DD");
    setAdminMarkingStartDate(formattedDate);
    setAdminMarkingEndDate(formattedDate);
    adminMarkingForm.setFieldsValue({ markFor: `client:${id}` });
    setAdminMarkingAssociates(null);
    request({
      url: `/admin/access-module/calendar-marking/${id}/associates`,
      method: "GET",
      onSuccess: (data) => {
        if (data?.data) {
          setAdminMarkingAssociates(data.data);
          adminMarkingForm.setFieldsValue({ markFor: `client:${data.data.client?._id || id}` });
        }
      },
    });
    setIsAdminMarkingModalOpen(true);
  };

  const openEditAdminMarkingModal = (marking) => {
    setEditingAdminMarking(marking);
    setAdminMarkingStartDate(moment(marking.startDate).format("YYYY-MM-DD"));
    setAdminMarkingEndDate(moment(marking.endDate).format("YYYY-MM-DD"));
    adminMarkingForm.setFieldsValue({
      adminMarkingType: marking.type,
      adminMarkingNote: marking.note,
    });
    setIsAdminMarkingModalOpen(true);
  };

  const saveAdminMarking = (values) => {
    if (!adminMarkingStartDate || !adminMarkingEndDate) {
      ShowToast("Please select start and end dates.", Severty.ERROR);
      return;
    }
    const payload = {
      type: values.adminMarkingType,
      note: values.adminMarkingNote || "",
      startDate: adminMarkingStartDate,
      endDate: adminMarkingEndDate,
    };
    if (editingAdminMarking) {
      request({
        url: `/admin/access-module/calendar-marking/${editingAdminMarking._id}`,
        method: "PUT",
        data: payload,
        onSuccess: () => {
          ShowToast("Marking updated", Severty.SUCCESS);
          setIsAdminMarkingModalOpen(false);
          setEditingAdminMarking(null);
          adminMarkingForm.resetFields();
          fetchMarkings();
        },
        onError: () => ShowToast("Failed to update marking", Severty.ERROR),
      });
    } else {
      const [markForRole, markForUserId] = (values.markFor || `client:${id}`).split(":");
      request({
        url: `/admin/access-module/calendar-marking/${id}`,
        method: "POST",
        data: {
          ...payload,
          markForRole,
          ...(markForUserId ? { markForUserId } : {}),
        },
        onSuccess: () => {
          ShowToast("Marking added", Severty.SUCCESS);
          setIsAdminMarkingModalOpen(false);
          adminMarkingForm.resetFields();
          fetchMarkings();
        },
        onError: () => ShowToast("Failed to add marking", Severty.ERROR),
      });
    }
  };

  const deleteAdminMarking = (markingId) => {
    request({
      url: `/admin/access-module/calendar-marking/${markingId}`,
      method: "DELETE",
      onSuccess: () => {
        ShowToast("Marking removed", Severty.SUCCESS);
        fetchMarkings();
      },
      onError: () => ShowToast("Failed to remove marking", Severty.ERROR),
    });
  };

  useEffect(() => {
    fetchData();
    contentThemeData();
    fetchMarkings();
    fetchBlogWriteRequests();
    fetchHolidays();
    fetchHolidayRegionOptions();

    // ── Real-time publish updates via Socket.io ──────────────────────────────
    // The backend emits "post:published" to the admin_broadcasts room whenever
    // any post goes live on LinkedIn. This lets the admin calendar update
    // instantly without a page refresh. Polling (startPublishPolling) runs in
    // parallel as the fallback — it handles cases where the socket is
    // unavailable or the connection drops.
    const PUBLISH_EVENT = "post:published";
    const token = localStorage.getItem("admin_token");
    const socketUrl = process.env.REACT_APP_SOCKET_URL;

    if (token && socketUrl) {
      try {
        socketRef.current = socketClient(token);

        socketRef.current.on(PUBLISH_EVENT, (data) => {
          const postDbId = data?._id;
          if (!postDbId) return;

          // Update the calendar tile in real time
          setCalenderData((prev) =>
            prev.map((item) =>
              item._id === postDbId
                ? {
                    ...item,
                    postId: data.postId || item.postId,
                    linkedinPostUrl: data.linkedinPostUrl || item.linkedinPostUrl,
                  }
                : item
            )
          );

          // If the drawer is open for this exact post, refresh its record too
          setRecord((prev) =>
            prev?._id === postDbId
              ? {
                  ...prev,
                  postId: data.postId || prev.postId,
                  linkedinPostUrl: data.linkedinPostUrl || prev.linkedinPostUrl,
                }
              : prev
          );

          // Socket delivered the update — stop polling for this post
          pendingPublishIdsRef.current.delete(postDbId);
          if (pendingPublishIdsRef.current.size === 0) {
            stopPublishPolling();
          }
        });

        socketRef.current.on("connect_error", (err) => {
          // Socket unreachable — polling fallback will handle it silently
          console.warn("[Admin Calendar] Socket unavailable, polling fallback active:", err.message);
        });
      } catch (err) {
        // Socket setup crashed — polling fallback is already active, no action needed
        console.warn("[Admin Calendar] Socket init failed, polling fallback active:", err.message);
      }
    }
    // ────────────────────────────────────────────────────────────────────────

    return () => {
      // Clean up both socket and polling interval on unmount
      stopPublishPolling();
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, []);

  const headerRender = ({ value, onChange }) => {
    const current = moment(value);
    const currentYear = current.year();
    const years = Array.from({ length: 9 }, (_, i) => currentYear - 4 + i);

    const selectMonth = (newMonth) => {
      const newDate = moment(value).month(newMonth);
      onChange(newDate);
      setCurrentMonth(newDate);
      setDrawerShouldOpen(false);
      setIsDrawerOpen(false);
      setOpen(false);
    };

    const selectYear = (newYear) => {
      const newDate = moment(value).year(newYear);
      onChange(newDate);
      setCurrentMonth(newDate);
      setDrawerShouldOpen(false);
      setIsDrawerOpen(false);
      setOpen(false);
    };

    return (
      <div className="calendar-header">
        <h2 onClick={(e) => e.stopPropagation()}>
          {current.format("MMMM, YYYY")}
        </h2>
        <div className="calendar-controls">
          <Select
            value={current.month()}
            onChange={(newMonth) => {
              selectMonth(newMonth); // Call selectMonth without passing event
            }}
          >
            {months?.map((month, index) => (
              <Option key={month} value={index}>
                {month}
              </Option>
            ))}
          </Select>
          <Select value={current.year()} onChange={selectYear}>
            {years?.map((year) => (
              <Option
                key={year}
                value={year}
                style={{ fontWeight: year === currentYear ? "bold" : "normal" }} // Highlight current year
              >
                {year}
              </Option>
            ))}
          </Select>
          <Button
            icon={<LeftOutlined />}
            onClick={(e) => {
              e.stopPropagation(); // Prevent event propagation
              const newDate = current.clone().subtract(1, "month");
              onChange(newDate);
              setCurrentMonth(newDate);
              setOpen(false);
            }}
          />
          <Button
            icon={<RightOutlined />}
            onClick={(e) => {
              e.stopPropagation(); // Prevent event propagation
              const newDate = current.clone().add(1, "month");
              onChange(newDate);
              setCurrentMonth(newDate);
              setOpen(false);
            }}
          />
          <Button
            onClick={(e) => {
              e.stopPropagation(); // Prevent event propagation
              const today = moment();
              onChange(today);
              setCurrentMonth(today);
              setOpen(false);
            }}
          >
            Today
          </Button>
          <Button
            icon={<StarOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              openAddHolidayModal(null);
            }}
            style={{
              background: HOLIDAY_CONFIG.bg,
              borderColor: HOLIDAY_CONFIG.color,
              color: HOLIDAY_CONFIG.color,
              fontWeight: 500,
            }}
          >
            Add Event
          </Button>
        </div>
      </div>
    );
  };

  const openSendToGraphics = () => {
    const stripHtmlLocal = (html) =>
      (html || "").replace(/<[^>]*>/g, " ").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim();
    // `record` isn't cleared when opening the Create flow (only reset when
    // the drawer closes), so it can still hold a previously-viewed post's
    // data — `isEditMode` is the reliable signal for which one is actually
    // open right now. `postText` state is always in sync with the currently
    // open editor either way (reset on create, synced on every keystroke).
    const liveTitle = isEditMode ? (record?.title || "") : (form.getFieldValue("title") || "");
    gfxForm.resetFields();
    setGfxFileList([]);
    gfxForm.setFieldsValue({
      clientNameRef: user?.name || user?.linkedinName || "",
      clientLinkedinUrl: user?.linkedinUrl || null,
      campaignProject: liveTitle,
      postTitle: liveTitle,
      postBody: stripHtmlLocal(postText),
      priority: "Medium",
    });
    if (!gfxMembers.length) {
      request({
        url: apiPath.graphicsTeamMembers,
        method: "GET",
        onSuccess: (data) => setGfxMembers(data?.data?.members || []),
        onError: () => {},
      });
    }
    setGfxModalVisible(true);
  };

  const onGfxFinish = (values) => {
    setGfxSaving(true);
    const formData = new FormData();
    Object.entries(values).forEach(([key, val]) => {
      if (key === "deliveryDate" && val) return formData.append("deliveryDate", `${val.format("YYYY-MM-DD")}T00:00:00.000Z`);
      if (val !== undefined && val !== null) formData.append(key, val);
    });
    // Admin can always override the workload block per the spec.
    formData.append("override", "true");
    gfxFileList.forEach((f) => formData.append("referenceFiles", f));

    request({
      url: apiPath.graphicsRequests,
      method: "POST",
      data: formData,
      onSuccess: (data) => {
        setGfxSaving(false);
        if (data.status === 200) {
          ShowToast("Graphics request created successfully", Severty.SUCCESS);
          setGfxModalVisible(false);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (err) => {
        setGfxSaving(false);
        ShowToast(err?.response?.data?.message || "Failed to create graphics request", Severty.ERROR);
      },
    });
  };

  const deleteContent = (record) => {
    console.log(record, "::::::::::::::::::::::::::::::::::::::::::::::::::");
    setDeleteLoading(true);
    request({
      url: `/admin/access-module/calender/${record?._id}`, // ✅ FIXED HERE
      method: "DELETE",
      onSuccess: (data) => {
        setDeleteLoading(false);
        if (data.status === 200) {
          ShowToast(data.message, Severty.SUCCESS);
          setIsDeleteModalOpen(false);
          setRecord(null);
          setAttachment(null);
          setPostText("");
          setOpen(false);
          fetchData();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (data) => {
        setDeleteLoading(false);
        ShowToast(data?.message || "Something went wrong", Severty.ERROR);
      },
      // onFinally: () => setLoading(false),
    });
  };

  useEffect(() => {
    if (record) {
      form.setFieldsValue(record);
    } else {
      form.resetFields();
    }
  }, [record]);

  const onFinish = async (values) => {
    if (formSubmitting) return;
    // See handleCreateThenMarkExternal's matching comment — a debounce tick
    // fired moments ago may still be in flight, and cancelDrawerDraftTick()
    // alone can't stop a fetch that already went out, so getDrawerDraftId()
    // right after it could still read a stale null.
    await waitForDrawerDraftSave();
    cancelDrawerDraftTick();

    // Autosave may already have created a real draft Post for this compose
    // session. Route the submission to update THAT record instead of
    // creating a second one — otherwise clicking Send for Review/Publish
    // right after typing left both a stray autosaved "Draft" card and the
    // real submitted one on the calendar.
    const existingDraftId = !isEditMode && getDrawerDraftId();
    if (existingDraftId) {
      setEditId(existingDraftId);
      return onEdit(values, existingDraftId);
    }

    console.log(">>>>>>>>", { ...values, attachment });
    const submittedActionType = actionTypeRef.current;
    if (submittedActionType === "publish" && isPublishSubmittingRef.current) return;
    if (submittedActionType === "publish") { isPublishSubmittingRef.current = true; setIsPublishSubmitting(true); }
    setFormSubmitting(true);

    try {
      const urls =
        attachment && attachment.length
          ? attachment?.map((item) => item.url)
          : "";
      console.log(urls);
      // setLoading(true);
      let attachmentType = "none";
      if (values.mediaType === "Carousel") {
        attachmentType = "carousel";
      } else if (values.mediaType === "Media" && urls && urls.length > 0) {
        const firstUrl = Array.isArray(urls) ? urls[0] : String(urls).split(",")[0];
        attachmentType = isVideoUrl(firstUrl) ? "video" : "image";
      }
      let finalDate = selectedDate;
      let finalTime = selectedTime;

      if (publishOption === "now" && submittedActionType !== "draft") {
        const now = moment();
        finalDate = now.format("YYYY-MM-DD");
        finalTime = now.format("HH:mm");
      } else if (submittedActionType === "draft" && !finalDate) {
        finalDate = moment().format("YYYY-MM-DD");
      }

      const pollData = values.mediaType === "Poll"
        ? {
            question: pollQuestion,
            options: pollOptions.filter((o) => o.trim()),
            duration: parseInt(values.pollDuration || "3"),
          }
        : undefined;
      const carouselDocumentTitle = values.mediaType === "Carousel"
        ? values.carouselDocumentTitle
        : undefined;
      const payload = {
        ...values,
        media: urls,
        postType: values.mediaType,
        ...postOptionsPayloadField(),
        attachmentType,
        selectedDate: finalDate,
        selectedTime: finalTime,
        timezone: getBrowserTimezone(),
        timezoneOffset: getTimezoneOffsetForSchedule(finalDate, finalTime),
        comment: getMergedComment(values.commentbox),
        action: submittedActionType,
        ...(pollData ? { pollData } : {}),
        ...(carouselDocumentTitle != null ? { carouselDocumentTitle } : {}),
        clientStatus:
          submittedActionType === "draft"
            ? "Draft By Admin"
            : submittedActionType === "review"
            ? "Under Review"
            : submittedActionType === "publish"
            ? "Publish By Admin"
            : submittedActionType,
        brandStatus:
          submittedActionType === "draft"
            ? "Draft"
            : submittedActionType === "review"
            ? "Sent For Review"
            : submittedActionType === "publish"
            ? "Publish"
            : submittedActionType,
      };
      // Awaited so the drawer only closes and the button's spinner only clears
      // once the post is actually saved — previously this fired without
      // awaiting and the outer `finally` closed the drawer immediately,
      // making Send for Review / Save as Draft feel like they did nothing.
      await request({
        url: "/admin/access-module/calender/" + id,
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          if (data.status === 200) {
            const createdPost = data?.data?.theme;
            if (createdPost?._id) {
              setCalenderData((currentData = []) => {
                const alreadyExists = currentData.some(
                  (item) => item?._id === createdPost._id
                );
                return alreadyExists ? currentData : [...currentData, createdPost];
              });
            }
            ShowToast(
              submittedActionType === "draft"
                ? "Post Draft"
                : submittedActionType === "review"
                ? "Post sent For Review"
                : `${submittedActionType} successfully`,
              Severty.SUCCESS
            );
            setSelectedDate(null);
            setSelectedTime(null);
            form.resetFields();
            setOpen(false);
            resetForm();
            // The post is now saved for real — stop autosave from continuing
            // to revise the now-redundant draft-store copy.
            setDrawerDraftId(null);
            fetchData();
            // If publishing now, poll until LinkedIn confirms — no refresh needed
            if (submittedActionType === "publish" && publishOption === "now" && createdPost?._id) {
              startPublishPolling(createdPost._id);
            }
            setIsSubmittedModalOpen(true);
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (err) => {
          // Previously silent — a rejected save looked identical to a
          // successful one: the drawer still closed and the list still
          // refetched (see the `finally` below), so the post appeared to
          // vanish with zero feedback.
          ShowToast(
            err?.response?.data?.message || "Failed to save post.",
            Severty.ERROR
          );
        },
        onFinally: () => { isPublishSubmittingRef.current = false; setIsPublishSubmitting(false); },
      });
    } catch (error) {
      console.log("Error adding data", error);
      ShowToast("Error adding data.", Severty.ERROR);
      if (submittedActionType === "publish") { isPublishSubmittingRef.current = false; setIsPublishSubmitting(false); }
    } finally {
      // Only the submitting flag is reset unconditionally — closing the
      // drawer and refetching now happens solely in onSuccess above, so a
      // failed save leaves the drawer open (with the user's edits intact)
      // instead of silently discarding them.
      setFormSubmitting(false);
    }
  };

  // Past-date compose flow: creates the post (as a draft, same payload shape
  // onFinish's draft path uses) and, on success, opens the existing "Mark
  // Published on LinkedIn" modal targeting the just-created post — see
  // pendingMarkExternalPostId. Deliberately mirrors onFinish's draft-path
  // payload rather than calling onFinish itself, so the always-goes-through-
  // review-or-schedule assumptions baked into that function (and its
  // existing-draft-autosave redirect) aren't disturbed for this narrower,
  // always-immediate case.
  const handleCreateThenMarkExternal = async () => {
    if (formSubmitting) return;
    try {
      flushAllPostEditors();
      const values = await form.validateFields();
      // A debounce tick that fired a moment ago may still be mid-flight —
      // cancelDrawerDraftTick() only stops a FUTURE tick, it can't un-send a
      // fetch that's already gone out. Waiting for it here first means
      // getDrawerDraftId() below reflects the truth instead of a stale null
      // — without this, that race created two identical posts (one from
      // this click, one from the racing autosave landing moments later).
      await waitForDrawerDraftSave();
      cancelDrawerDraftTick();
      setFormSubmitting(true);

      // Same situation onFinish itself guards against: typing into this
      // compose session may already have autosaved a real draft Post behind
      // the scenes. If so, update THAT record with the current (freshest)
      // form values instead of creating a second, duplicate post.
      const existingDraftId = getDrawerDraftId();

      const urls = attachment && attachment.length ? attachment.map((item) => item.url) : "";
      let attachmentType = "none";
      if (values.mediaType === "Carousel") {
        attachmentType = "carousel";
      } else if (values.mediaType === "Media" && urls && urls.length > 0) {
        const firstUrl = Array.isArray(urls) ? urls[0] : String(urls).split(",")[0];
        attachmentType = isVideoUrl(firstUrl) ? "video" : "image";
      }
      const pollData = values.mediaType === "Poll"
        ? {
            question: pollQuestion,
            options: pollOptions.filter((o) => o.trim()),
            duration: parseInt(values.pollDuration || "3"),
          }
        : undefined;
      const carouselDocumentTitle = values.mediaType === "Carousel" ? values.carouselDocumentTitle : undefined;

      const payload = {
        ...values,
        media: urls,
        postType: values.mediaType,
        ...postOptionsPayloadField(),
        attachmentType,
        selectedDate,
        selectedTime,
        timezone: getBrowserTimezone(),
        timezoneOffset: getTimezoneOffsetForSchedule(selectedDate, selectedTime),
        comment: getMergedComment(values.commentbox),
        action: "draft",
        ...(pollData ? { pollData } : {}),
        ...(carouselDocumentTitle != null ? { carouselDocumentTitle } : {}),
        clientStatus: "Draft By Admin",
        brandStatus: "Draft",
      };

      await request({
        url: existingDraftId
          ? `/admin/access-module/calender/${existingDraftId}`
          : "/admin/access-module/calender/" + id,
        method: existingDraftId ? "PUT" : "POST",
        data: payload,
        onSuccess: (data) => {
          setFormSubmitting(false);
          if (data.status !== 200) {
            ShowToast(data.message, Severty.ERROR);
            return;
          }
          const savedPost = data?.data?.theme || data?.data;
          const savedPostId = savedPost?._id || existingDraftId;
          if (!savedPostId) {
            ShowToast("Post was created, but couldn't be found again to mark it published — please find it on the calendar and use Mark Published on LinkedIn from there.", Severty.ERROR);
            return;
          }
          if (savedPost?._id) {
            setCalenderData((currentData = []) => {
              const alreadyExists = currentData.some((item) => item?._id === savedPost._id);
              return alreadyExists
                ? currentData.map((item) => (item?._id === savedPost._id ? savedPost : item))
                : [...currentData, savedPost];
            });
          }
          // Point the autosave pointer AT the post we just created/updated,
          // rather than nulling it — the compose drawer is still open
          // underneath the Mark-Published modal (this doesn't close it), so
          // its autosave stays enabled. setDraftId(null) resets
          // useDraftAutosave's internal "blocked" flag as a side effect,
          // silently re-arming a future debounce tick — with the id nulled
          // out too, that tick would POST a brand-new post instead of
          // updating this one, producing a duplicate stray Draft. Pointing
          // at savedPostId instead means any further tick correctly PUTs to
          // the real record. Confirmed live on the brand panel.
          setDrawerDraftId(savedPostId);
          setPendingMarkExternalPostId(savedPostId);
          setLinkedinUrlInput("");
          setIsMarkExternalModalOpen(true);
        },
        onError: (err) => {
          setFormSubmitting(false);
          ShowToast(err?.response?.data?.message || "Failed to save post.", Severty.ERROR);
        },
      });
    } catch (error) {
      setFormSubmitting(false);
      if (error?.errorFields) return; // antd form validation — already shown inline
      console.log("Error creating past-dated post:", error);
      ShowToast("Error creating post.", Severty.ERROR);
    }
  };

  const onEdit = async (values, overrideId) => {
    // setEditId() doesn't take effect until the next render, so a caller
    // that just set it (like onFinish delegating here) must pass the id
    // directly — otherwise this closure would still read the stale editId.
    const targetId = overrideId || editId;
    if (formSubmitting) return;
    cancelDrawerDraftTick();

    console.log(">>>>>>>>", { ...values, attachment });
    const submittedActionType = actionTypeRef.current;
    if (submittedActionType === "publish" && isPublishSubmittingRef.current) return;
    if (submittedActionType === "publish") { isPublishSubmittingRef.current = true; setIsPublishSubmitting(true); }
    setFormSubmitting(true);

    try {
      const urls =
        attachment && attachment.length
          ? attachment?.map((item) => item.url)
          : "";
      console.log(urls);
      // setLoading(true);
      let attachmentType = "none";
      if (values.mediaType === "Carousel") {
        attachmentType = "carousel";
      } else if (values.mediaType === "Media" && urls && urls.length > 0) {
        const firstUrl = Array.isArray(urls) ? urls[0] : String(urls).split(",")[0];
        attachmentType = isVideoUrl(firstUrl) ? "video" : "image";
      }
      let finalDate = selectedDate;
      let finalTime = selectedTime;

      if (publishOption === "now" && submittedActionType !== "draft") {
        const now = moment();
        finalDate = now.format("YYYY-MM-DD");
        finalTime = now.format("HH:mm");
      } else if (submittedActionType === "draft" && !finalDate) {
        finalDate = moment().format("YYYY-MM-DD");
      }

      const pollDataEdit = values.mediaType === "Poll"
        ? {
            question: pollQuestion,
            options: pollOptions.filter((o) => o.trim()),
            duration: parseInt(values.pollDuration || "3"),
          }
        : undefined;
      const carouselDocumentTitleEdit = values.mediaType === "Carousel"
        ? values.carouselDocumentTitle
        : undefined;
      const payload = {
        ...values,
        media: urls,
        postType: values.mediaType,
        ...postOptionsPayloadField(),
        ...(submittedActionType === "approved" && filledOptionCount >= 2 ? { approvedOptionIndexes: approvedIndexesFromSelection() } : {}),
        attachmentType,
        selectedDate: finalDate,
        comment: getMergedComment(values.commentbox),
        selectedTime: finalTime,
        timezone: getBrowserTimezone(),
        timezoneOffset: getTimezoneOffsetForSchedule(finalDate, finalTime),
        action: submittedActionType,
        ...(pollDataEdit ? { pollData: pollDataEdit } : {}),
        ...(carouselDocumentTitleEdit != null ? { carouselDocumentTitle: carouselDocumentTitleEdit } : {}),
      };
      // Awaited so the drawer only closes and the button's spinner only clears
      // once the edit is actually saved — previously this fired without
      // awaiting and the outer `finally` closed the drawer immediately.
      await request({
        url: `/admin/access-module/calender/${targetId}`,
        method: "PUT",
        data: payload,
        onSuccess: (data) => {
          if (data.status === 200) {
            ShowToast(
              `Post sent for ${submittedActionType} successfully`,
              Severty.SUCCESS
            );
            setSelectedDate(null);
            setSelectedTime(null);
            form.resetFields();
            setOpen(false);
            setIsModalOpen(false);
            resetForm();
            // The post is now saved for real (whether via a genuine edit, or
            // via onFinish delegating here to update an autosaved draft) —
            // stop autosave from continuing to revise it.
            setDrawerDraftId(null);
            // This closes the drawer directly rather than via
            // closeCreatePostDrawer, so isEditMode/editId/record must be
            // reset here too — otherwise the next "Add Post" click would
            // submit through onEdit using this stale editId, silently
            // overwriting this post instead of creating a new one.
            setIsEditMode(false);
            setEditId(null);
            setRecord(null);
            fetchData();
            // If publishing now, poll until LinkedIn confirms (postId set) — no refresh needed
            if (submittedActionType === "publish" && publishOption === "now") {
              startPublishPolling(targetId);
            }
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (err) => {
          // Previously silent — a rejected save (permission denied, validation
          // error, etc.) looked identical to a successful one: the drawer still
          // closed and the list still refetched (see the `finally` below), so
          // the edit appeared to vanish with zero feedback on reopen.
          ShowToast(
            err?.response?.data?.message || "Failed to save changes.",
            Severty.ERROR
          );
        },
        onFinally: () => { isPublishSubmittingRef.current = false; setIsPublishSubmitting(false); },
      });
    } catch (error) {
      ShowToast("Error adding data.", Severty.ERROR);
      if (submittedActionType === "publish") { isPublishSubmittingRef.current = false; setIsPublishSubmitting(false); }
    } finally {
      // Only the submitting flag is reset unconditionally — closing the
      // drawer and refetching now happens solely in onSuccess above, so a
      // failed save leaves the drawer open (with the user's edits intact)
      // instead of silently discarding them.
      setFormSubmitting(false);
    }
  };

  const handleEditClick = async (item) => {
    console.log("item>>>>>", item);
    if (item.type === "blog") {
      navigate(`/create-new-manully-blog/${id}`, {
        state: { record: item, isEdit: true },
      });
      return;
    }

    // Cancel any pending autosave debounce tick from whatever session was
    // active before this click, FIRST — before any other state changes.
    // Without this, a still-queued tick from an abandoned new-post compose
    // (or a previously-viewed draft) fires AFTER this function has already
    // overwritten postText/selectedPostType/selectedDate with the newly-
    // opened post's own data, and since drawerDraftId gets reset to null
    // below for a non-draft post, that stale tick creates a brand-new
    // duplicate via POST — using the *now-current* (this post's own) title/
    // type/date — instead of either updating anything or being silently
    // dropped.
    cancelDrawerDraftTick();
    setIsEditMode(true);
    setIsDirty(false);
    setRecord(item);
    setPostText(normalizeEditorHtml(item.postText));
    setEditId(item._id);
    latestEditRequestIdRef.current = item._id;
    // Only re-point autosave at an existing draft — never at a post that's
    // already under review/approved/published, so an accidental close there
    // can't silently downgrade its status back to Draft.
    setDrawerDraftId(isDraftRecordStatus(item) ? item._id : null);
    form.resetFields();
    applyPostTypeChange(normalizePostType(item.postType));
    setLastComment(
      Array.isArray(item?.comment)
        ? item.comment[item.comment.length - 1]
        : null
    );
    setLastCommentData(
      Array.isArray(item?.commentData) ? item.commentData : null
    );
    setPlanningNotes(Array.isArray(item?.planningNotes) ? item.planningNotes : []);

    // Fetch post data from the API
    try {
      const response = await request({
        url: `/admin/access-module/postById/${item._id}`, // Call the API to get the post by ID
        method: "GET",
        onSuccess: (response) => {
          // A newer handleEditClick call has since fired (a different post
          // was opened while this fetch was in flight) — applying this
          // response now would overwrite that other post's attachment/media/
          // form state with this one's data. Drop it silently.
          if (latestEditRequestIdRef.current !== item._id) {
            return;
          }
          if (response.status === 200) {
            // Check if the response structure is as expected
            if (response.data && response.data.post) {
              const postData = response.data.post; // Access the post object from the response

              // Format media correctly.
              // postData.media can hold each attachment as its own array
              // element (["url1", "url2"]) or, for older records, as a
              // single comma-joined string in the first element
              // ("url1,url2"). Flatten across every element instead of only
              // reading media[0], otherwise anything past the first
              // attachment silently disappears here.
              const mediaUrls =
                postData.postType !== "Title" && postData.postType !== "Poll"
                  ? (Array.isArray(postData.media) ? postData.media : [postData.media])
                      .flatMap((entry) => String(entry ?? "").split(","))
                      .map((url) => url.trim())
                      .filter(Boolean)
                  : [];
              const formattedMedia =
                postData.postType !== "Title" && postData.postType !== "Poll"
                  ? mediaUrls?.map((url) => ({ url: url.trim() })).filter((item) => item.url)
                  : "";

              setLastComment(
                Array.isArray(postData?.comment)
                  ? postData.comment[postData.comment.length - 1]
                  : null
              );
              setLastCommentData(
                Array.isArray(postData?.commentData) ? postData.commentData : null
              );
              console.log("formattedMedia", formattedMedia);
              setAttachment(formattedMedia); // Set the formatted media
              setSelectedPostType(normalizePostType(postData.postType));

              // Populate poll fields
              if (postData.postType === "Poll" && postData.pollData) {
                setPollQuestion(postData.pollData.question || "");
                setPollOptions(
                  postData.pollData.options?.length > 0
                    ? postData.pollData.options
                    : ["", ""]
                );
                form.setFieldsValue({
                  pollQuestion: postData.pollData.question || "",
                  pollDuration: String(postData.pollData.duration || "3"),
                });
                if (postData.postId) {
                  setPollResultsLoading(true);
                  setPollResultsForbidden(false);
                  request({
                    url: `/admin/access-module/calender/poll-results/${postData._id}`,
                    method: "GET",
                    onSuccess: (r) => {
                      if (r?.data?.code === "FORBIDDEN" || r?.code === "FORBIDDEN") {
                        setPollResults(null);
                        setPollResultsForbidden(true);
                      } else if (r.status === 200) {
                        setPollResults(r.data?.pollResults || null);
                        setPollResultsForbidden(false);
                      }
                      setPollResultsLoading(false);
                    },
                    onError: () => { setPollResultsLoading(false); setPollResultsForbidden(false); },
                  });
                }
              } else {
                setPollQuestion("");
                setPollOptions(["", ""]);
                setPollResults(null);
              }

              // Populate carousel document title
              if (postData.postType === "Carousel") {
                form.setFieldsValue({ carouselDocumentTitle: postData.carouselDocumentTitle || "" });
              }

              // Set all form fields from the fetched record
              const _matchedTheme = themeData.find((t) => t._id === postData.contentTheme);
              setSelectedTheme(_matchedTheme || postData.contentTheme);
              setSubPillars(_matchedTheme ? _matchedTheme.subPillars : []);
              form.setFieldsValue({
                title: postData.title,
                contentTheme: postData.contentTheme,
                subPillar: Array.isArray(postData.subPillar)
                  ? postData.subPillar[0]
                  : postData.subPillar || "",
                mediaType: normalizePostType(postData.postType),
                postText: normalizeEditorHtml(postData.postOptions?.length >= 2 ? postData.postOptions[0].text : postData.postText),
                addFirstComment: postData.addFirstComment,
                visibility: postData.visibility || "PUBLIC",
              });
              applyPostOptionsFromRecord(postData);
    
              setIsDisable(true);
              setOpen(true);
              fetchData();
            } else {
              console.error("Post data is not available in the response");
              ShowToast("Post data is not available.", Severty.ERROR);
            }
          } else {
            ShowToast(response.message, Severty.ERROR); // Show error message if status is not 200
          }
        },
        onError: (error) => {
          ShowToast(error.message, Severty.ERROR);
        }
      });
      console.log("resposne", response);

      
    } catch (error) {
      console.error("Error fetching post data:", error);
      ShowToast("Error fetching post data.", Severty.ERROR); // Show error message on catch
    }
  };

  // Deep-link from notification/activity-feed click — open a specific post directly
  useEffect(() => {
    if (location.state?.openItem) {
      handleEditClick(location.state.openItem);
      navigate(location.pathname, { replace: true, state: {} });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state?.openItem]);

  useEffect(() => {
    if (record) {
      const scheduledAt = getScheduledMoment(record);
      form.setFieldsValue({
        title: record.title,
        contentTheme: record.contentTheme,
        subPillar: Array.isArray(record.subPillar)
          ? record.subPillar[0]
          : record.subPillar || "",
        mediaType: record.postType,
        postText: normalizeEditorHtml(record.postText),
        addFirstComment: record.addFirstComment,
        visibility: record.visibility || "PUBLIC",
      });
      if (scheduledAt?.isValid()) {
        setSelectedDate(scheduledAt.format("YYYY-MM-DD"));
        setSelectedTime(scheduledAt.format("HH:mm"));
        setPublishOption("later");
      } else {
        setSelectedDate(null);
        setSelectedTime(null);
      }
      setLastComment(
        Array.isArray(record?.comment)
          ? record.comment[record.comment.length - 1]
          : null
      );
      setLastCommentData(
        Array.isArray(record?.commentData) ? record.commentData : null
      );
      const normalizedType = normalizePostType(record.postType);
      // record.media can hold each attachment as its own array element
      // (["url1", "url2"]) or, for older records, as a single comma-joined
      // string in the first element ("url1,url2"). Flatten across every
      // element instead of only reading media[0], otherwise anything past
      // the first attachment silently disappears when the post reloads.
      const mediaUrls =
        normalizedType === "Media"
          ? (Array.isArray(record.media) ? record.media : [record.media])
              .flatMap((entry) => String(entry ?? "").split(","))
              .map((url) => url.trim())
              .filter(Boolean)
          : [];
      const formattedMedia = mediaUrls.map((url) => ({ url: url.trim() })).filter((item) => item.url);
      setSelectedPostType(normalizedType);
      form.setFieldsValue({ mediaType: normalizedType });
      setAttachment(formattedMedia);
    } else {
      form.resetFields();
      form.setFieldsValue({ mediaType: "Media" });
    }
  }, [record]);

  const handleCalendarDragOver = (e) => {
    if (!isDraggingActive) return;
    const cell = e.target.closest("td[title]");
    if (!cell) return;
    e.preventDefault();
    if (e.dataTransfer) e.dataTransfer.dropEffect = "move";
    const dateStr = cell.getAttribute("title");
    if (dateStr) setDragOverDate(moment(dateStr));
  };

  const handleCalendarDragLeave = (e) => {
    if (e.currentTarget.contains(e.relatedTarget)) return;
    setDragOverDate(null);
  };

  const handleCalendarDrop = (e) => {
    if (!draggedPost) return;
    const cell = e.target.closest("td[title]");
    if (!cell) return;
    const dateStr = cell.getAttribute("title");
    if (!dateStr) return;
    handleDrop(e, moment(dateStr));
  };

  return (
    <div
      className="full-calendar-page"
      onDragOver={handleCalendarDragOver}
      onDragLeave={handleCalendarDragLeave}
      onDrop={handleCalendarDrop}
    >
      <Calendar
        className="full-page-calendar"
        fullscreen
        dateCellRender={dateCellRender}
        onSelect={handleDateSelect}
        headerRender={headerRender}
        // Predates the "past dates can Create/Mark too" feature (see the
        // isPastDateNew comment further down this file) and was never
        // updated to match it — this used to correctly block empty past
        // dates back when the calendar had no past-date creation flow at
        // all. Now it's a leftover: Ant Design's Calendar makes a
        // disabledDate:true cell genuinely non-interactive (pointer-events:
        // none via its own ant-picker-cell-disabled styling), which
        // silently ate every hover/click on an empty past cell — no Create/
        // Mark buttons could ever appear, since the browser never even
        // fires :hover on a disabled cell. Confirmed live: an empty past
        // cell carried `ant-picker-cell-disabled`; a past cell with an
        // existing post did not (it's excluded below), which is exactly why
        // only EMPTY past dates were affected. No date should be disabled
        // here any more — every date, past or future, empty or not, needs
        // to stay interactive for Create/Mark.
        disabledDate={() => false}
      />

      {/* Connect LinkedIn Modal Start */}
      <Modal
        className="tab_modal"
        title="Connect Your LinkedIn Account"
        visible={isModalVisible}
        onCancel={handleModalClose}
        footer={null}
        centered
      >
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              fontSize: 48,
              fontWeight: "bold",
              color: "#0077B5",
              margin: "20px 0",
            }}
          >
            in
          </div>
          <p>
            Link your profile to unlock scheduling, automation, analytics, and
            more — everything you need to grow your presence effortlessly.
          </p>
          <Button
            type="primary"
            block
            style={{ marginTop: 16 }}
            onClick={() => navigate("/linkedin-connect")}
          >
            Connect
          </Button>
          <Link className="link-btn" type="link" onClick={showModal}>
            Help or know more
          </Link>
        </div>
      </Modal>

      {/* Create Modal with Add Post / Add Blog options */}
      <Modal
        className="tab_modal"
        title="Create"
        open={isCreateModalVisible}
        onCancel={() => setIsCreateModalVisible(false)}
        footer={null}
        centered
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <Button type="primary" block onClick={handleAddPostClick}>
            Create Post (Auto Publish)
          </Button>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
              gap: 12,
            }}
          >
            <div>
              <Button
                type="primary"
                block
                onClick={handleSendBlogWriteRequestClick}
                style={{ height: 44, fontWeight: 500 }}
              >
                Send Request to Blog Writer
              </Button>
              <p
                style={{
                  margin: "6px 0 0",
                  color: "#6B7280",
                  fontSize: 12,
                  lineHeight: "16px",
                }}
              >
                Raises a blog request for this client, right here.
              </p>
            </div>
            <div>
              <Button
                type="primary"
                block
                onClick={handleAddBlogClick}
                style={{ height: 44, fontWeight: 500 }}
              >
                Create Blog (Manual Publish)
              </Button>
              <p
                style={{
                  margin: "6px 0 0",
                  color: "#6B7280",
                  fontSize: 12,
                  lineHeight: "16px",
                }}
              >
                App Blog creates a post with a blog link.
              </p>
            </div>
          </div>
        </div>
      </Modal>

      {/* Create Blog Request — stays on the Calendar, doesn't navigate away.
          Client is this calendar's own client. */}
      <Modal
        title="Create Blog Request"
        open={blogRequestModalOpen}
        onCancel={() => setBlogRequestModalOpen(false)}
        footer={null}
      >
        <Form form={blogRequestForm} layout="vertical" onFinish={submitBlogRequest}>
          <Form.Item label="Client">
            <Input value={user?.name} disabled />
          </Form.Item>
          <Form.Item label="Blog Title" name="projectTitle" rules={[{ required: true, message: "Required" }]}>
            <Input placeholder="Blog title" />
          </Form.Item>

          <Form.Item label="Blog Post Outline Framework">
            <div className="blog-desc-trigger">
              <Button onClick={() => setBlogRequestDescModalOpen(true)}>
                {outlineHasContent(blogRequestOutline) ? "Edit Blog Post Outline Framework" : "+ Add Blog Post Outline Framework"}
              </Button>
              {outlineHasContent(blogRequestOutline) && <Tag color="green">Blog Post Outline Framework added ✓</Tag>}
            </div>
          </Form.Item>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Delivery Date" name="deliveryDate" rules={[{ required: true, message: "Required" }]}>
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Priority" name="priority">
                <Select>
                  <Select.Option value="Low">Low</Select.Option>
                  <Select.Option value="Medium">Medium</Select.Option>
                  <Select.Option value="High">High</Select.Option>
                  <Select.Option value="Urgent">Urgent</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item label="Assign To" name="assignedTo">
            <Select allowClear placeholder="Blog Writer" showSearch optionFilterProp="children">
              {blogWriteMembers.map((m) => (
                <Select.Option key={m._id} value={m._id}>{m.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Attachments (reference documents, links, brand guidelines, images, videos)">
            <Upload
              multiple
              beforeUpload={(file) => {
                setBlogRequestFileList((prev) => [...prev, file]);
                return false;
              }}
              onRemove={(file) => setBlogRequestFileList((prev) => prev.filter((f) => f.uid !== file.uid))}
              fileList={blogRequestFileList}
            >
              <Button icon={<UploadOutlined />}>Select Files</Button>
            </Upload>
          </Form.Item>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 8 }}>
            <Button onClick={() => setBlogRequestModalOpen(false)}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={savingBlogRequest}>
              Create Request
            </Button>
          </div>
        </Form>
      </Modal>

      <BlogDescriptionModal
        open={blogRequestDescModalOpen}
        value={blogRequestOutline}
        onChange={setBlogRequestOutline}
        onClose={() => setBlogRequestDescModalOpen(false)}
      />

      {/* Help or know more modal  */}
      <Modal
        className="tab_modal"
        title={null}
        open={isModalVisible01}
        footer={null}
        onCancel={handleCancel}
        width={1000}
        closeIcon={
          <span style={{ fontSize: 20 }}>
            <CloseOutlined />
          </span>
        }
      >
        <div className="know-modal-header">
          <h3>Help or know more</h3>
          <p>
            Lorem ipsum dolor sit amet consectetur. Orci enim hac eu nec non
            diam varius. Eget eu vivamus nulla et scelerisque. Enim enim
            fermentum quis orci pellentesque. Congue vitae faucibus proin neque.
          </p>
        </div>

        <Collapse
          className="according-know-more"
          accordion
          expandIconPosition="end"
          expandIcon={({ isActive }) => (
            <PlusOutlined rotate={isActive ? 45 : 0} />
          )}
          ghost
        >
          {[1, 2, 3, 4]?.map((item) => (
            <Panel
              className="according-know-button"
              header={
                <h6 className="collapse-inner-headding">
                  Lorem ipsum dolor sit amet consectetur. Orci enim hac eu nec
                  non diam varius ?
                </h6>
              }
              key={item}
            >
              <p className="collapse-inner-body">
                This is the detailed answer or content for item {item}.
              </p>
            </Panel>
          ))}
        </Collapse>

        <div className="know-footer-modal">
          <Button className="fill-btndark">Setup Demo Call</Button>
          <Button className="fill-btnlight">Contact Account Manager</Button>
        </div>
      </Modal>

      {/* Create Post Drawer start */}
      <Drawer
        className="post-upload-drawer"
        placement="left"
        title={false}      
  closable={false}   
        width="90%"
        onClose={closeCreatePostDrawer}
        open={open}
      >
        <div className={`create-post-container ${isDisable ? "b" : ""}`}>
          <div className="post-up-header">
            <Avatar
              src={authorImage}
              alt={authorName}
              size={52}
              className="post-up-header-avatar"
            />
            <h6>
              {authorName} <img src={RightIcon} alt="arrow" /> Create Post
            </h6>
            <div className="ant-drawer-header-title">
 <Button
      className="ant-drawer-close main-new-drawer-claose"
      onClick={closeCreatePostDrawer}
    >
      <CloseOutlined />
    </Button>
            </div>
             
          </div>
          <div className="drawer--up-body">
            <Row gutter={[32, 20]}>
              <Col span={24} lg={12}>
                <div className="post-preview-panel">
                  <div className="post-preview-label">LinkedIn Preview</div>
                  <div className="post-section-main linkedin-preview-shell">
                    <div className="profile-header">
                      <div className="profile-post-images">
                        <img src={authorImage} alt={authorName} />
                      </div>
                      <div className="profile-info">
                        <div className="profile-name">{authorName}</div>
                        <div className="profile-followers">
                          {authorMeta || "Professional update"}
                        </div>
                        <div className="profile-date">
                          {formatPreviewDate(selectedDate)} <CalendarOutlined />
                        </div>
                      </div>
                    </div>
                    {previewTitle ? (
                      <div className="linkedin-preview-title">
                        {previewTitle}
                      </div>
                    ) : null}
                    {previewText ? (
                      <div className="linkedin-preview-text">
                        {renderLinkedInPreviewLines(previewLinkedInText)}
                      </div>
                    ) : (
                      <div className="linkedin-preview-placeholder">
                        Your post preview will appear here as you type.
                      </div>
                    )}
                    <div className="upload-post-description">
                      {selectedPostType === "Media" && previewAttachment && previewAttachment.length > 0 && (
                        isVideoUrl(previewAttachment[0]?.url || "") ? (
                          <video controls className="post-video" style={{ width: "100%", height: "auto" }}>
                            <source src={previewAttachment[0].url} type="video/mp4" />
                          </video>
                        ) : (
                          <Carousel>
                            {previewAttachment.map((file, index) => (
                              <img key={index} src={file.url} alt={`post preview ${index}`} className="post-image" />
                            ))}
                          </Carousel>
                        )
                      )}
                      {selectedPostType === "Poll" && (
                        <div style={{ border: "1px solid #e0e0e0", borderRadius: 8, padding: 16, margin: "12px 0" }}>
                          <div style={{ fontWeight: 600, marginBottom: 12, fontSize: 14 }}>
                            {pollQuestion || "Your poll question"}
                          </div>
                          {pollResultsLoading ? (
                            <div style={{ textAlign: "center", padding: "12px 0", color: "#888" }}>Loading results...</div>
                          ) : pollResultsForbidden ? (
                            <div style={{ textAlign: "center", padding: "10px 0", color: "#faad14", fontSize: 12 }}>
                              ⚠️ Live results unavailable — LinkedIn read permissions not granted
                            </div>
                          ) : pollResults ? (
                            <>
                              {pollResults.options.map((opt, idx) => {
                                const pct = pollResults.totalVoteCount > 0
                                  ? Math.round((opt.voteCount / pollResults.totalVoteCount) * 100)
                                  : 0;
                                return (
                                  <div key={idx} style={{ marginBottom: 10 }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 3 }}>
                                      <span>{opt.text}</span>
                                      <span style={{ fontWeight: 600 }}>{pct}%</span>
                                    </div>
                                    <div style={{ background: "#e8e8e8", borderRadius: 4, height: 8, overflow: "hidden" }}>
                                      <div style={{ width: `${pct}%`, background: "#0a66c2", height: "100%", borderRadius: 4, transition: "width 0.6s ease" }} />
                                    </div>
                                    <div style={{ fontSize: 11, color: "#888", marginTop: 2 }}>{opt.voteCount} votes</div>
                                  </div>
                                );
                              })}
                              <div style={{ fontSize: 12, color: "#888", marginTop: 8, display: "flex", justifyContent: "space-between" }}>
                                <span>{pollResults.totalVoteCount} total votes</span>
                                {pollResults.votingStatus && (
                                  <span style={{ color: pollResults.votingStatus === "OPEN" ? "#52c41a" : "#ff4d4f", fontWeight: 600 }}>
                                    {pollResults.votingStatus}
                                  </span>
                                )}
                              </div>
                            </>
                          ) : (
                            pollOptions.filter((o) => o.trim()).map((opt, idx) => (
                              <div key={idx} style={{ border: "1px solid #0a66c2", borderRadius: 20, padding: "6px 16px", marginBottom: 8, fontSize: 13, color: "#0a66c2" }}>
                                {opt}
                              </div>
                            ))
                          )}
                        </div>
                      )}
                      {selectedPostType === "Carousel" && attachment && attachment.length > 0 && (
                        <div style={{ border: "1px solid #e0e0e0", borderRadius: 8, padding: 12, margin: "12px 0", textAlign: "center" }}>
                          <div style={{ fontSize: 32, marginBottom: 4 }}>📄</div>
                          <div style={{ fontSize: 13, color: "#555" }}>{form.getFieldValue("carouselDocumentTitle") || "PDF Document"}</div>
                          <div style={{ fontSize: 11, color: "#888" }}>{attachment.length} page(s)</div>
                        </div>
                      )}
                    </div>

                    <div>
                      <div className="post-interactions">
                        <div className="like-counts">
                          <img src={LikeIcon} alt="likes" />
                          <span>0</span>
                        </div>
                        <div className="cm-reort-text">
                          <span>0 Comment</span>
                          <span>0 Repost</span>
                        </div>
                      </div>
                      <div className="action-buttons">
                        <Button className="post-action-btn active">
                          <img src={LikeIconBtn} alt="like" /> Like
                        </Button>
                        <Button className="post-action-btn">
                          <img src={CommentIconBtn} alt="comment" /> Comment
                        </Button>
                        <Button className="post-action-btn">
                          <img src={RetweetIconBtn} alt="repost" /> Repost
                        </Button>
                        <Button className="post-action-btn">
                          <img src={SendIconBtn} alt="send" /> Send
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col span={24} lg={12}>
                <Form
                  form={form}
                  layout="vertical"
                  initialValues={{
                    ...(isEditMode ? record : {}),
                    mediaType: "Media",
                    pollDuration: "3",
                  }}
                  onFinish={isEditMode ? onEdit : onFinish}
                  className="post-contant-outerpanel"
                  onValuesChange={(changedValues) => {
                    setIsDirty(true);
                    if (changedValues.postText !== undefined) {
                      setPostText(normalizeEditorHtml(changedValues.postText));
                    }
                  }}
                >
                  <div
                    className="post-editor-title"
                  >
                    <span className="post-editor-icon-box">
                      <FileTextOutlined />
                    </span>
                    <span className="post-editor-title-text">Post Content</span>
                    {isEditMode && calendarPermission?.edit && (
                      <div className="post-detail-page">
                        <Tooltip title="Copy LinkedIn link">
                          <Button
                            className="post-edit-btn"
                            onClick={() => {
                              const linkedinLink =
                                record?.linkedinPostUrl ||
                                (record?.postId
                                  ? `https://www.linkedin.com/feed/update/${record.postId}/`
                                  : null);
                              if (!linkedinLink) {
                                ShowToast(
                                  "LinkedIn link not available for this post.",
                                  Severty.ERROR,
                                );
                                return;
                              }
                              handleCopy(linkedinLink, "Link copied!");
                            }}
                          >
                            <img src={LinkIcon} alt="Link" />
                          </Button>
                        </Tooltip>
                        <Tooltip title="Edit">
                          {calendarPermission?.delete && (
                            <Button
                              className="post-edit-btn"
                              onClick={() => setIsDeleteModalOpen(true)}
                            >
                              <img src={DeleteBtnIcon} alt="Delete" />
                            </Button>
                          )}
                        </Tooltip>
                        <Button
                          className="fill-btn"
                          onClick={() => setIsDisable(false)}
                        >
                          Edit Post
                        </Button>
                      </div>
                    )}
                  </div>

                  <Form.Item
                    name="title"
                    label="Title"
                    rules={[
                      { required: true, message: "Please enter a title" },
                    ]}
                  >
                    <Input
                      placeholder="Enter post title"
                      className="post-input"
                      disabled={isDisable || !canModifyPost || isPublishedLocked}
                    />
                  </Form.Item>

                  {/* Content Theme Field */}
                  <Form.Item
                    name="contentTheme"
                    label="Content Theme"
                    rules={[
                      {
                        required: true,
                        message: "Please select content theme",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select content theme"
                      onChange={handleThemeChange}
                      disabled={isDisable || !canModifyPost || isPublishedLocked}
                    >
                      {themeData?.map((theme) => (
                        <Select.Option key={theme._id} value={theme._id}>
                          {theme.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  {/* Sub Pillar Field */}
                  <Form.Item
                    name="subPillar"
                    label="Sub Pillar"
                    rules={[
                      { required: true, message: "Please select a pillar" },
                    ]}
                  >
                    <Select placeholder="Select pillar" disabled={isDisable || !canModifyPost || isPublishedLocked}>
                      {subPillars?.flat()?.map((pillar, index) => (
                        <Select.Option key={index} value={pillar}>
                          {pillar}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  {/* Type Field */}
                  <Form.Item
                    name="mediaType"
                    label="Type"
                    rules={[
                      { required: true, message: "Please select post type" },
                    ]}
                  >
                    <Select
                      onChange={handlePostTypeChange}
                      disabled={isDisable || !canModifyPost || isPublishedLocked}
                    >
                      <Select.Option value="Media">🖼️ Media (Image / Video)</Select.Option>
                      <Select.Option value="Poll">📊 Poll</Select.Option>
                      <Select.Option value="Carousel">📄 Carousel (PDF)</Select.Option>
                    </Select>
                  </Form.Item>

                  {/* Post options: 2-3 alternative captions the client can choose from */}
                  <div className="post-options-bar" style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap", padding: "0 18px", margin: "0 0 8px" }}>
                    {extraOptionTexts.length > 0 &&
                      allOptionTexts.map((_, i) => (
                        <div
                          key={i}
                          onClick={() => setActivePostOption(i)}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 6,
                            height: 34,
                            boxSizing: "border-box",
                            padding: "0 16px",
                            borderRadius: 17,
                            fontSize: 13,
                            lineHeight: 1,
                            cursor: "pointer",
                            border: activePostOption === i ? "1px solid #1677ff" : "1px solid #d9d9d9",
                            background: activePostOption === i ? "rgba(22,119,255,0.08)" : "#fff",
                            color: activePostOption === i ? "#1677ff" : "#555",
                            fontWeight: activePostOption === i ? 600 : 400,
                          }}
                        >
                          {lang("Option")} {i + 1}
                          {i > 0 && !isDisable && (
                            <CloseOutlined
                              style={{ fontSize: 10 }}
                              onClick={(e) => { e.stopPropagation(); removePostOption(i - 1); }}
                            />
                          )}
                        </div>
                      ))}
                    {!isDisable && extraOptionTexts.length < MAX_POST_OPTIONS - 1 && (
                      <div
                        onClick={addPostOption}
                        title={lang("Add another caption option for the client to choose from")}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 6,
                          height: 34,
                          boxSizing: "border-box",
                          padding: "0 16px",
                          borderRadius: 17,
                          fontSize: 13,
                          lineHeight: 1,
                          cursor: "pointer",
                          border: "1px dashed #1677ff",
                          color: "#1677ff",
                        }}
                      >
                        <PlusOutlined style={{ fontSize: 11 }} />
                        {extraOptionTexts.length === 0 ? lang("Add option") : lang("Option")}
                      </div>
                    )}
                    {filledOptionCount >= 2 && (
                      <div
                        onClick={openCompare}
                        title={lang("Edit, comment and compare all options side by side")}
                        style={{
                          marginLeft: "auto",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 6,
                          height: 34,
                          boxSizing: "border-box",
                          padding: "0 16px",
                          borderRadius: 17,
                          fontSize: 13,
                          fontWeight: 600,
                          lineHeight: 1,
                          cursor: "pointer",
                          border: "1px solid #1677ff",
                          background: "#1677ff",
                          color: "#fff",
                        }}
                      >
                        {lang("Compare options")}
                      </div>
                    )}
                  </div>

                  <Form.Item
                    style={activePostOption === 0 ? undefined : { display: "none" }}
                    name="postText"
                    label={
                      <div className="post-text-label-row">
                        <span>Post text</span>
                        <Button
                          type="link"
                          size="small"
                          icon={<ThunderboltOutlined />}
                          disabled={isDisable || !canModifyPost}
                          onClick={handleRewriteWithAI}
                          className="post-rewrite-ai-btn"
                        >
                          Write with Assistant
                        </Button>
                      </div>
                    }
                    rules={[
                      { required: true, message: "Please enter post text" },
                    ]}
                  >
                    <NormalEditor
                      ref={postTextEditorRef}
                      content={postText}
                      onChange={syncPostText}
                      disabled={isDisable || !canModifyPost}
                      toolbarPreset="linkedin"
                      placeholder="Write caption, #hashtags, @mentions, or links..."
                      minHeight={260}
                    />
                  </Form.Item>

                  {extraOptionTexts.map((text, idx) => (
                    <div key={`post-option-${idx}`} style={{ display: activePostOption === idx + 1 ? "block" : "none", marginBottom: 24 }}>
                      <div style={{ fontWeight: 600, marginBottom: 8 }}>
                        {lang("Post text")} — {lang("Option")} {idx + 2}
                      </div>
                      <NormalEditor
                        ref={(el) => { extraEditorRefs.current[idx] = el; }}
                        content={text}
                        onChange={(v) => updateExtraOption(idx, v)}
                        disabled={isDisable}
                        toolbarPreset="linkedin"
                        placeholder={lang("Write another caption option...")}
                        minHeight={260}
                      />
                      {(selectedPostType === "Media" || selectedPostType === "Carousel") && (
                        <div style={{ marginTop: 16 }}>
                          <div style={{ fontWeight: 600, marginBottom: 8 }}>
                            {selectedPostType === "Carousel" ? lang("PDF Document (Carousel)") : lang("Media (Image / Video)")} — {lang("Option")} {idx + 2}
                          </div>
                          <MultipleImageUpload
                            fileType={
                              selectedPostType === "Carousel"
                                ? ["application/pdf"]
                                : ["image/png", "image/jpeg", "image/jpg", "image/gif", "image/webp", "video/mp4"]
                            }
                            imageType="blog"
                            btnName={selectedPostType === "Carousel" ? lang("Upload PDF") : lang("Attach Image or Video")}
                            maxCount={selectedPostType === "Carousel" ? 1 : undefined}
                            onChange={(files) => updateExtraMedia(idx, files)}
                            data={extraOptionMedia[idx] || []}
                            isDisable={isDisable}
                          />
                        </div>
                      )}
                    </div>
                  ))}

                  <PostOptionsCompareModal
                    open={optionsModalOpen || compareOpen}
                    mode="select"
                    singleSelect={pickerSingle}
                    options={optionDefs.map((o) => ({ text: o.text }))}
                    selection={optionDefs.map((o) => optionSelection[o.idx] !== false)}
                    onSelectionChange={(next) => {
                      const merged = [...optionSelection];
                      optionDefs.forEach((o, k) => { merged[o.idx] = next[k]; });
                      setOptionSelection(merged);
                    }}
                    editable={!isDisable || !!calendarPermission?.edit}
                    onTextChange={(k, html) => {
                      const idx = optionDefs[k]?.idx;
                      if (idx === 0) syncPostText(html);
                      else if (idx > 0) updateExtraOption(idx - 1, html);
                    }}
                    comments={optionDefs.map((o) => optionComments[o.idx] || "")}
                    media={optionDefs.map((o) => mediaForOption(o.idx))}
                    approvedFlags={optionDefs.map((_, k) => !!(record?.postOptions || [])[k]?.approved)}
                    approvedBy={optionDefs.map((_, k) => (record?.postOptions || [])[k]?.approvedByName || "")}
                    clientApprovedFlags={optionDefs.map((_, k) => !!(record?.postOptions || [])[k]?.clientApproved)}
                    clientApprovedBy={optionDefs.map((_, k) => (record?.postOptions || [])[k]?.clientApprovedByName || "")}
                    commentData={lastCommentData}
                    showInternalTag
                    onMediaChange={(k, files) => {
                      const idx = optionDefs[k]?.idx;
                      if (idx === 0) handleMediaChange(files);
                      else if (idx > 0) updateExtraMedia(idx - 1, files);
                    }}
                    mediaConfig={
                      selectedPostType === "Media"
                        ? { fileType: ["image/png", "image/jpeg", "image/jpg", "image/gif", "image/webp", "video/mp4"], btnName: lang("Attach Image or Video") }
                        : selectedPostType === "Carousel"
                        ? { fileType: ["application/pdf"], btnName: lang("Upload PDF"), maxCount: 1 }
                        : null
                    }
                    onCommentChange={(k, v) => {
                      const idx = optionDefs[k]?.idx;
                      if (idx !== undefined) setOptionComment(idx, v);
                    }}
                    actions={
                      pickerLabel
                        ? [{ key: "go", label: pickerLabel, type: "primary", needsPick: true, onClick: confirmOptionsPicker }]
                        : buildWorkspaceActions()
                    }
                    onCancel={closeOptionsWorkspace}
                  />

                  {/* Send to Graphics — same card treatment as Content Intelligence below,
                      available in both create and edit mode. */}
                  <div className="post-ci-panel">
                    <div className="post-ci-header">
                      <div>
                        <h4 className="post-ci-title">Send to Graphics</h4>
                        <p className="post-ci-subtitle">
                          Create a Graphics Team request pre-filled with this post's title and text
                        </p>
                      </div>
                      <Button
                        type="primary"
                        icon={<PictureOutlined />}
                        onClick={openSendToGraphics}
                        className="post-ci-analyze-btn"
                      >
                        Send to Graphics
                      </Button>
                    </div>
                  </div>

                  {/* Analysis highlights (plagiarism/grammar/…) on the post text,
                      removable — shown once Analyze Content has run. */}
                  {postAnalysis && <PostAnalysisHighlights html={postText} analysis={postAnalysis} />}

                  {/* Content Intelligence — readability, suggestions, fact check */}
                  <div className="post-ci-panel">
                    <div className="post-ci-header">
                      <div>
                        <h4 className="post-ci-title">Content Intelligence</h4>
                        <p className="post-ci-subtitle">
                          {postAnalysis
                            ? "Analysis complete — review your scores below"
                            : "Analyze your content for readability, suggestions and facts"}
                        </p>
                      </div>
                      <Button
                        type="primary"
                        icon={<ThunderboltOutlined />}
                        loading={postAnalysisLoading}
                        onClick={handleAnalyzePostContent}
                        disabled={isDisable || !canModifyPost}
                        className="post-ci-analyze-btn"
                      >
                        Analyze Content
                      </Button>
                    </div>

                    <div className="post-ci-cards">
                      {/* Readability — overall score is 0-100 (average of Flesch Reading
                          Ease and Dale-Chall Grade, each graded per-point across its own
                          target band); same engine and scale as the Writing Assistant card. */}
                      {(() => {
                        const score = postAnalysis?.readability_details?.overall_score;
                        const readColor = score >= 80 ? "#16a34a" : score >= 50 ? "#d97706" : "#dc2626";
                        const status = score >= 80 ? "Excellent" : score >= 50 ? "Needs Improvement" : "Poor";
                        return (
                          <div className="post-ci-card">
                            <div className="post-ci-card-top">
                              <div className="post-ci-icon" style={{ background: score != null ? `${readColor}1a` : "#f1f5f9" }}>
                                <FileTextOutlined style={{ color: score != null ? readColor : "#94a3b8" }} />
                              </div>
                              <span className="post-ci-label">Readability Score</span>
                            </div>
                            {score != null ? (
                              <div style={{ textAlign: "center", margin: "2px 0 8px" }}>
                                <span style={{ fontSize: 30, fontWeight: 800, color: readColor }}>{score}</span>
                                <span style={{ fontSize: 14, color: "#94a3b8" }}>/100</span>
                                <div style={{ height: 6, background: "#f1f5f9", borderRadius: 3, overflow: "hidden", margin: "6px auto 0" }}>
                                  <div style={{ width: `${score}%`, height: "100%", background: readColor, borderRadius: 3 }} />
                                </div>
                                <span className="post-ci-badge" style={{ background: `${readColor}18`, color: readColor, marginTop: 6, display: "inline-block" }}>
                                  {status}
                                </span>
                              </div>
                            ) : (
                              <div className="post-ci-value" style={{ color: "#cbd5e1" }}>—</div>
                            )}
                            <p className="post-ci-note">
                              Average of Flesch Reading Ease and Dale-Chall Grade, scored against their target ranges.
                            </p>
                          </div>
                        );
                      })()}

                      {/* Guideline Checker — our own LLM-based feature. originality.ai's
                          version isn't reachable via their API at all (confirmed against
                          their published /scan parameter list). */}
                      <div className="post-ci-card">
                        <div className="post-ci-card-top">
                          <div className="post-ci-icon" style={{ background: "#eff6ff" }}>
                            <CheckOutlined style={{ color: "#2563eb" }} />
                          </div>
                          <span className="post-ci-label">Guideline Checker</span>
                        </div>
                        {postGuidelineCheckLoading && (
                          <p className="post-ci-empty">Checking guidelines...</p>
                        )}
                        {!postGuidelineCheckLoading && postGuidelineCheck?.alignment_score != null && (
                          <>
                            <div
                              className="post-ci-accuracy"
                              style={{
                                background: postGuidelineCheck.alignment_score >= 80 ? "#dcfce7" : postGuidelineCheck.alignment_score >= 40 ? "#fef3c7" : "#fee2e2",
                                color: postGuidelineCheck.alignment_score >= 80 ? "#15803d" : postGuidelineCheck.alignment_score >= 40 ? "#b45309" : "#b91c1c",
                              }}
                            >
                              {postGuidelineCheck.alignment_score >= 80 ? "✓" : postGuidelineCheck.alignment_score >= 40 ? "⚠" : "✗"}{" "}
                              {postGuidelineCheck.alignment_score}% - {postGuidelineCheck.alignment_score >= 90 ? "Highly Aligned" : postGuidelineCheck.alignment_score >= 70 ? "Mostly Aligned" : postGuidelineCheck.alignment_score >= 40 ? "Needs Revision" : "Poorly Aligned"}
                            </div>
                            {postGuidelineCheck.summary && (
                              <p className="post-ci-note" style={{ marginTop: 6 }}>{postGuidelineCheck.summary}</p>
                            )}
                            {(postGuidelineCheck.sentences || []).length ? (
                              <ul className="post-ci-fact-list">
                                {postGuidelineCheck.sentences.slice(0, 5).map((s, i) => (
                                  <li key={i} className="post-ci-fact-item">
                                    <div className="post-ci-fact-claim">{s.text}</div>
                                    {s.explanation && <p className="post-ci-note" style={{ margin: "2px 0" }}>{s.explanation}</p>}
                                    {s.suggestion && (
                                      <span className="post-ci-fact-badge" style={{ background: "#dcfce718", color: "#15803d" }}>
                                        {s.suggestion}{" "}
                                        <button
                                          type="button"
                                          onClick={() => handleCopyPostGuidelineSuggestion(s.suggestion)}
                                          style={{ marginLeft: 6, border: "none", background: "transparent", color: "#2563eb", cursor: "pointer", textDecoration: "underline" }}
                                        >
                                          Copy
                                        </button>
                                      </span>
                                    )}
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <p className="post-ci-empty">No guideline violations found.</p>
                            )}
                          </>
                        )}
                        {!postGuidelineCheckLoading && postGuidelineCheck?.alignment_score == null && (
                          <p className="post-ci-empty">
                            {postGuidelineCheck ? "Guideline check unavailable." : "Run analysis to check style guideline alignment."}
                          </p>
                        )}
                      </div>

                      {/* Fact Check */}
                      <div className="post-ci-card">
                        <div className="post-ci-card-top">
                          <div className="post-ci-icon" style={{ background: "#fef9c3" }}>
                            <SearchOutlined style={{ color: "#ca8a04" }} />
                          </div>
                          <span className="post-ci-label">Fact Check</span>
                        </div>
                        {postAnalysis?.accuracy_score != null && (
                          <div
                            className="post-ci-accuracy"
                            style={{
                              background: postAnalysis.accuracy_score >= 70 ? "#dcfce7" : postAnalysis.accuracy_score >= 40 ? "#fef3c7" : "#fee2e2",
                              color: postAnalysis.accuracy_score >= 70 ? "#15803d" : postAnalysis.accuracy_score >= 40 ? "#b45309" : "#b91c1c",
                            }}
                          >
                            {postAnalysis.accuracy_score >= 70 ? "✓" : postAnalysis.accuracy_score >= 40 ? "⚠" : "✗"}{" "}
                            Accuracy: <strong>{postAnalysis.accuracy_score}%</strong>
                          </div>
                        )}
                        {(postAnalysis?.facts || []).length ? (
                          <ul className="post-ci-fact-list">
                            {postAnalysis.facts.map((f, i) => {
                              const v = f.verdict || "Unverified";
                              const vColor = v === "Supported" ? "#15803d" : v === "Partially Supported" ? "#b45309" : v === "Contradicted" ? "#b91c1c" : "#64748b";
                              return (
                                <li key={i} className="post-ci-fact-item">
                                  <div className="post-ci-fact-claim">{f.claim}</div>
                                  <span className="post-ci-fact-badge" style={{ background: `${vColor}18`, color: vColor }}>
                                    {v} {f.confidence != null ? `· ${f.confidence}%` : ""}
                                  </span>
                                </li>
                              );
                            })}
                          </ul>
                        ) : (
                          <p className="post-ci-empty">
                            {postAnalysis
                              ? "No verifiable claims found in this content."
                              : "Run analysis to fact-check your claims."}
                          </p>
                        )}
                      </div>

                      {/* Plagiarism (originality.ai, falls back when unavailable) */}
                      <div className="post-ci-card">
                        <div className="post-ci-card-top">
                          <div className="post-ci-icon" style={{ background: "#ffe4e6" }}>
                            <CopyOutlined style={{ color: "#be123c" }} />
                          </div>
                          <span className="post-ci-label">Plagiarism</span>
                        </div>
                        {postAnalysis?.plagiarism?.plagiarism_score != null ? (
                          <>
                            <div
                              className="post-ci-accuracy"
                              style={{
                                background: postAnalysis.plagiarism.plagiarism_score <= 10 ? "#dcfce7" : postAnalysis.plagiarism.plagiarism_score <= 30 ? "#fef3c7" : "#fee2e2",
                                color: postAnalysis.plagiarism.plagiarism_score <= 10 ? "#15803d" : postAnalysis.plagiarism.plagiarism_score <= 30 ? "#b45309" : "#b91c1c",
                              }}
                            >
                              {postAnalysis.plagiarism.plagiarism_score <= 10 ? "✓" : postAnalysis.plagiarism.plagiarism_score <= 30 ? "⚠" : "✗"}{" "}
                              Matched: <strong>{postAnalysis.plagiarism.plagiarism_score}%</strong>
                            </div>
                            {(postAnalysis.plagiarism.matches || []).length ? (
                              <ul className="post-ci-fact-list">
                                {postAnalysis.plagiarism.matches.slice(0, 5).map((m, i) => (
                                  <li key={i} className="post-ci-fact-item">
                                    <div className="post-ci-fact-claim">
                                      <a href={m.url} target="_blank" rel="noreferrer">{m.url}</a>
                                    </div>
                                    <span className="post-ci-fact-badge" style={{ background: "#be123c18", color: "#be123c" }}>
                                      {m.similarity}% match
                                    </span>
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <p className="post-ci-empty">No matching sources found.</p>
                            )}
                          </>
                        ) : (
                          <p className="post-ci-empty">
                            {postAnalysis
                              ? "Plagiarism check unavailable — showing fallback analysis only."
                              : "Run analysis to scan for plagiarism."}
                          </p>
                        )}
                      </div>

                      {/* AI Detection (originality.ai, falls back when unavailable) */}
                      <div className="post-ci-card">
                        <div className="post-ci-card-top">
                          <div className="post-ci-icon" style={{ background: "#ede9fe" }}>
                            <RobotOutlined style={{ color: "#6d28d9" }} />
                          </div>
                          <span className="post-ci-label">AI Detection</span>
                        </div>
                        {postAnalysis?.ai_detection?.ai_score != null ? (
                          <div
                            className="post-ci-accuracy"
                            style={{
                              background: postAnalysis.ai_detection.ai_score < 20 ? "#dcfce7" : postAnalysis.ai_detection.ai_score < 50 ? "#fef3c7" : "#fee2e2",
                              color: postAnalysis.ai_detection.ai_score < 20 ? "#15803d" : postAnalysis.ai_detection.ai_score < 50 ? "#b45309" : "#b91c1c",
                            }}
                          >
                            {postAnalysis.ai_detection.ai_score < 20 ? "✓" : postAnalysis.ai_detection.ai_score < 50 ? "⚠" : "✗"}{" "}
                            AI-likely: <strong>{postAnalysis.ai_detection.ai_score}%</strong>
                          </div>
                        ) : (
                          <p className="post-ci-empty">
                            {postAnalysis
                              ? "AI detection unavailable — showing fallback analysis only."
                              : "Run analysis to check for AI-generated content."}
                          </p>
                        )}
                        {postAnalysis?.ai_detection?.verdict && (
                          <p className="post-ci-empty" style={{ marginTop: 4 }}>{postAnalysis.ai_detection.verdict}</p>
                        )}
                      </div>

                      {/* Grammar & Spelling (originality.ai, falls back when unavailable) */}
                      <div className="post-ci-card">
                        <div className="post-ci-card-top">
                          <div className="post-ci-icon" style={{ background: "#dcfce7" }}>
                            <CheckOutlined style={{ color: "#16a34a" }} />
                          </div>
                          <span className="post-ci-label">Grammar & Spelling</span>
                        </div>
                        {postAnalysis?.grammar?.score != null ? (() => {
                          const issues = postAnalysis.grammar.issues || [];
                          return (
                            <>
                              <div
                                className="post-ci-accuracy"
                                style={{
                                  background: postAnalysis.grammar.score >= 90 ? "#dcfce7" : postAnalysis.grammar.score >= 70 ? "#fef3c7" : "#fee2e2",
                                  color: postAnalysis.grammar.score >= 90 ? "#15803d" : postAnalysis.grammar.score >= 70 ? "#b45309" : "#b91c1c",
                                }}
                              >
                                {postAnalysis.grammar.score >= 90 ? "✓" : postAnalysis.grammar.score >= 70 ? "⚠" : "✗"}{" "}
                                Correctness: <strong>{postAnalysis.grammar.score}%</strong>
                                {postAnalysis.grammar.grade ? ` · Grade ${postAnalysis.grammar.grade}` : ""}
                              </div>
                              {issues.length ? (
                                <ul className="post-ci-fact-list">
                                  {issues.slice(0, 4).map((iss, i) => (
                                    <li key={i} className="post-ci-fact-item">
                                      <div className="post-ci-fact-claim">{iss.message}</div>
                                      <span className="post-ci-fact-badge" style={{ background: "#fef3c718", color: "#b45309" }}>
                                        {iss.category || "Issue"}
                                      </span>
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <p className="post-ci-empty">No grammar or spelling issues found.</p>
                              )}
                            </>
                          );
                        })() : (
                          <p className="post-ci-empty">
                            {postAnalysis
                              ? "Grammar check unavailable — showing fallback analysis only."
                              : "Run analysis to check grammar and spelling."}
                          </p>
                        )}
                      </div>

                      {/* Content Quality (originality.ai's High/Medium/Low classifier) */}
                      <div className="post-ci-card">
                        <div className="post-ci-card-top">
                          <div className="post-ci-icon" style={{ background: "#e0f2fe" }}>
                            <FileTextOutlined style={{ color: "#0284c7" }} />
                          </div>
                          <span className="post-ci-label">Content Quality</span>
                        </div>
                        {postAnalysis?.content_quality?.label ? (
                          <>
                            <div
                              className="post-ci-accuracy"
                              style={{
                                background: postAnalysis.content_quality.label === "High" ? "#dcfce7" : postAnalysis.content_quality.label === "Medium" ? "#fef3c7" : "#fee2e2",
                                color: postAnalysis.content_quality.label === "High" ? "#15803d" : postAnalysis.content_quality.label === "Medium" ? "#b45309" : "#b91c1c",
                              }}
                            >
                              {postAnalysis.content_quality.label === "High" ? "✓" : postAnalysis.content_quality.label === "Medium" ? "⚠" : "✗"}{" "}
                              {postAnalysis.content_quality.label}
                              {postAnalysis.content_quality.confidence != null ? ` · ${postAnalysis.content_quality.confidence}%` : ""}
                            </div>
                            {Object.keys(postAnalysis.content_quality.probs || {}).length > 0 && (
                              <div style={{ marginTop: 8, display: "flex", flexDirection: "column", gap: 4 }}>
                                {["High", "Medium", "Low"].filter((band) => postAnalysis.content_quality.probs[band] != null).map((band) => (
                                  <div key={band} style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: "#64748b" }}>
                                    <span>{band}</span><span>{postAnalysis.content_quality.probs[band]}%</span>
                                  </div>
                                ))}
                              </div>
                            )}
                          </>
                        ) : (
                          <p className="post-ci-empty">
                            {postAnalysis
                              ? "Content quality check unavailable — showing fallback analysis only."
                              : "Run analysis to check content quality."}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* LinkedIn's own audience control for the post — mirrors
                      LinkedIn's native "Anyone" / "Connections only" post
                      composer option. Wired through to the actual publish
                      call (LinkedInPostsService); previously this slot held
                      an unrelated, unused field (addFirstComment) labeled
                      "Visibility" but never actually controlling anything. */}
                  <div className="post-comment-toggle post-visibility-block">
                    <p>Visibility</p>
                    <Form.Item name="visibility" initialValue="PUBLIC" noStyle>
                      <Radio.Group
                        className="post-visibility-group"
                        disabled={isDisable || !canModifyPost || isPublishedLocked}
                      >
                        <Radio value="PUBLIC" className="post-visibility-option">
                          <span className="post-visibility-icon">
                            <GlobalOutlined />
                          </span>
                          <span className="post-visibility-text">
                            <strong>Anyone</strong>
                            <small>Anyone on or off LinkedIn</small>
                          </span>
                        </Radio>
                        <Radio value="CONNECTIONS" className="post-visibility-option">
                          <span className="post-visibility-icon">
                            <TeamOutlined />
                          </span>
                          <span className="post-visibility-text">
                            <strong>Connections only</strong>
                            <small>Only your LinkedIn connections</small>
                          </span>
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>

                  {/* Media Field (Image / Video) */}
                  {selectedPostType === "Media" && (
                    <Form.Item
                      className="custom-media-item"
                      style={activePostOption === 0 ? undefined : { display: "none" }}
                      label="Media (Image / Video)"
                      name="media"
                    >
                      <MultipleImageUpload
                        fileType={["image/png", "image/jpeg", "image/jpg", "image/gif", "image/webp", "video/mp4"]}
                        imageType="blog"
                        btnName="Attach Image or Video"
                        onChange={handleMediaChange}
                        data={attachment}
                        isDisable={isDisable || !canModifyPost || isPublishedLocked}
                      />
                    </Form.Item>
                  )}

                  {/* Poll Fields */}
                  {selectedPostType === "Poll" && (
                    <div className="poll-form-section" style={{ marginBottom: 16 }}>
                      <Form.Item
                        name="pollQuestion"
                        label="Poll Question"
                        rules={[{ required: true, message: "Please enter the poll question" }]}
                      >
                        <Input
                          placeholder="What would you like to ask?"
                          className="post-input"
                          disabled={isDisable || !canModifyPost || isPublishedLocked}
                          maxLength={140}
                          showCount
                          onChange={(e) => setPollQuestion(e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item label="Poll Options (2–4)" required>
                        {pollOptions.map((opt, idx) => (
                          <div key={idx} style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                            <Input
                              placeholder={`Option ${idx + 1}`}
                              value={opt}
                              disabled={isDisable || !canModifyPost || isPublishedLocked}
                              maxLength={30}
                              showCount
                              onChange={(e) => {
                                const updated = [...pollOptions];
                                updated[idx] = e.target.value;
                                setPollOptions(updated);
                              }}
                            />
                            {pollOptions.length > 2 && (
                              <Button danger size="small" disabled={isDisable || !canModifyPost || isPublishedLocked}
                                onClick={() => setPollOptions(pollOptions.filter((_, i) => i !== idx))}>
                                ✕
                              </Button>
                            )}
                          </div>
                        ))}
                        {pollOptions.length < 4 && !(isDisable || !canModifyPost || isPublishedLocked) && (
                          <Button type="dashed" size="small"
                            onClick={() => setPollOptions([...pollOptions, ""])}>
                            + Add Option
                          </Button>
                        )}
                      </Form.Item>
                      <Form.Item name="pollDuration" label="Poll Duration" initialValue="3">
                        <Select disabled={isDisable || !canModifyPost || isPublishedLocked}>
                          <Select.Option value="1">1 Day</Select.Option>
                          <Select.Option value="3">3 Days</Select.Option>
                          <Select.Option value="7">1 Week</Select.Option>
                          <Select.Option value="14">2 Weeks</Select.Option>
                        </Select>
                      </Form.Item>
                    </div>
                  )}

                  {/* Carousel (PDF) Fields */}
                  {selectedPostType === "Carousel" && (
                    <>
                      <Form.Item
                        name="carouselDocumentTitle"
                        label="Document title"
                        rules={[{ required: true, message: "Please add a descriptive title to your document" }]}
                        extra={
                          <span style={{ fontSize: 12, color: "#888" }}>
                            Add a descriptive title to your document
                          </span>
                        }
                      >
                        <Input
                          placeholder="Add a descriptive title to your document"
                          className="post-input"
                          disabled={isDisable || !canModifyPost || isPublishedLocked}
                          maxLength={200}
                          showCount
                        />
                      </Form.Item>
                      <Form.Item
                        className="custom-media-item"
                      style={activePostOption === 0 ? undefined : { display: "none" }}
                        label="PDF Document (Carousel)"
                        name="media"
                        rules={[{ required: true, message: "Please upload a PDF document" }]}
                      >
                        <MultipleImageUpload
                          fileType={["application/pdf"]}
                          imageType="blog"
                          btnName="Upload PDF"
                          maxCount={1}
                          onChange={handleMediaChange}
                          data={attachment}
                          isDisable={isDisable || !canModifyPost || isPublishedLocked}
                        />
                      </Form.Item>
                    </>
                  )}

                  {isEditMode && record?.action === "review" && (
                    <>
                      {lastComment && (
                        <div style={{ marginBottom: 12 }}>
                          <label
                            style={{
                              fontWeight: "bold",
                              fontSize: 16,
                              display: "block",
                              marginBottom: 6,
                            }}
                          >
                            Comments
                          </label>

                          <div
                            style={{
                              maxHeight: "300px",
                              overflowY: "auto",
                              background: "#fafafa",
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                              padding: "10px",
                            }}
                          >
                            {lastCommentData.length > 0 ? (
                              lastCommentData
                                .slice()
                                .reverse()
                                ?.map((data, index) => {
                                  const isBrand = data.type === "brand";

                                  return (
                                    <div
                                      key={index}
                                      style={{
                                        display: "flex",
                                        justifyContent: isBrand
                                          ? "flex-end"
                                          : "flex-start",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <div style={getCommentStyle(data.type)}>
                                        {/* whiteSpace: pre-wrap — the Comment box is a
                                            plain <TextArea>, so a numbered/bulleted list
                                            typed as separate lines is real "\n" characters
                                            in data.comment. Without pre-wrap, the browser's
                                            default CSS collapses every newline into a
                                            single space on render, turning
                                            "1 test\n2 test\n3 test" into
                                            "1 test 2 test 3 test" — unreadable list-style
                                            comments. */}
                                        <div
                                          style={{
                                            fontSize: 14,
                                            marginBottom: 4,
                                            whiteSpace: "pre-wrap",
                                          }}
                                        >
                                          {data.comment}
                                        </div>
                                        <div
                                          style={{
                                            fontSize: 12,
                                            color: "#888",
                                          }}
                                        >
                                          <strong>By:</strong>{" "}
                                          {data.commentUserName || data.commentUserId?.name || data.type} |{" "}
                                          {dayjs(data.time).format(
                                            "DD MMM YYYY, HH:mm"
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })
                            ) : (
                              <p
                                style={{
                                  color: "#999",
                                  textAlign: "center",
                                  margin: 0,
                                }}
                              >
                                No comments yet
                              </p>
                            )}
                          </div>
                        </div>
                        // <div style={{ marginBottom: 8, padding: 10, background: "#f5f5f5", borderRadius: 5 }}>
                        //   <strong>Last Comment:</strong>
                        //   <p style={{ margin: 0 }}>{lastComment}</p>
                        // </div>
                      )}

                      <Form.Item name="commentbox" label="Comment box">
                        <TextArea
                          placeholder="please enter your comment..."
                          rows={5}
                          className="post-input"
                          disabled={!canModifyPost}
                        />
                      </Form.Item>

                      {/* Shared planning-notes thread — Client/BM/BS/Admin can
                          all add to it. This is what the client sees on this
                          post's planning preview while it's still a bare
                          Draft, and stays visible afterward too. */}
                      <div style={{ marginBottom: 12 }}>
                        <label
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            display: "block",
                            marginBottom: 6,
                          }}
                        >
                          Planning Notes{" "}
                          <span style={{ fontWeight: 400, fontSize: 12, color: "#8c8c8c" }}>
                            (visible to client)
                          </span>
                        </label>
                        <div
                          style={{
                            maxHeight: "220px",
                            overflowY: "auto",
                            background: "#fafafa",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            padding: "10px",
                            marginBottom: 8,
                          }}
                        >
                          {planningNotes.length > 0 ? (
                            planningNotes.map((note, i) => (
                              <div key={note._id || i} style={{ marginBottom: 10 }}>
                                <div
                                  style={{
                                    fontSize: 13,
                                    whiteSpace: "pre-wrap",
                                    background: note.authorRole === "customer" ? "#e6f4ff" : "#fff",
                                    border: "1px solid #eee",
                                    borderRadius: 6,
                                    padding: "6px 10px",
                                  }}
                                >
                                  {note.text}
                                </div>
                                <div style={{ fontSize: 11, color: "#999", marginTop: 2 }}>
                                  <strong>{note.authorName || "Someone"}</strong>
                                  {" · "}
                                  {dayjs(note.time).format("DD MMM, HH:mm")}
                                </div>
                              </div>
                            ))
                          ) : (
                            <p style={{ color: "#999", textAlign: "center", margin: 0 }}>
                              No notes yet
                            </p>
                          )}
                        </div>
                        {canModifyPost && (
                          <div style={{ display: "flex", gap: 6 }}>
                            <TextArea
                              rows={2}
                              placeholder="Add a note for the client..."
                              value={planningNoteDraft}
                              onChange={(e) => setPlanningNoteDraft(e.target.value)}
                            />
                            <Button type="primary" size="small" onClick={submitPlanningNote}>
                              Send
                            </Button>
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  <div className="action-footer-buttons">
                    {!isPastDateNew && !isScheduledLocked && !isPublishedFooterLocked && canModifyPost && record?.action !== "approved" && (
                      <Button
                        htmlType="submit"
                        className="submitted-btn"
                        icon={<CheckCircleOutlined />}
                        loading={formSubmitting && activeActionType === "review"}
                        disabled={formSubmitting}
                        onClick={(e) => {
                          flushAllPostEditors();
                          if (filledOptionCount >= 2) {
                            e.preventDefault();
                            openOptionsPicker(() => {
                              selectActionType("review");
                              setTimeout(() => form.submit(), 0);
                            }, "Send for review");
                            return;
                          }
                          selectActionType("review");
                        }}
                      >
                        Send for review
                      </Button>
                    )}

                    {/* Extra option alongside the normal "Send for review" flow
                        above for when the CLIENT authored/edited this post and
                        sent it TO the Admin (brandStatus "Under Review"): the
                        Admin can just Approve it directly. Approve mirrors the
                        client's own Approve exactly: it just sets
                        action:"approved" (backend already supports this — see
                        Admin.editCalender's `action == "approved"` branch), which
                        flips the Publish/Save-as-Draft ternary below over to
                        Publish so the Admin can push it live themselves — it does
                        NOT auto-publish. */}
                    {!isScheduledLocked && isEditMode && record?.brandStatus === "Under Review" && calendarPermission?.edit && (
                      <Button
                        className="submitted-btn"
                        icon={<CheckCircleOutlined />}
                        loading={formSubmitting && activeActionType === "approved"}
                        disabled={formSubmitting}
                        onClick={() => withOptionsPicker(async () => {
                          try {
                            flushAllPostEditors();
                            await form.validateFields();
                            selectActionType("approved");
                            await onEdit(form.getFieldsValue());
                          } catch (error) {
                            console.log("Validation failed:", error);
                          }
                        }, "Approve")}
                      >
                        Approve
                      </Button>
                    )}

                    {!isScheduledLocked && (isEditMode ? (
                      // isPublishedFooterLocked correctly hides this block once a
                      // live post is back in an active edit cycle and still awaiting
                      // a review decision (isPendingReview) — but once that edit gets
                      // APPROVED, isPendingReview flips back to false while
                      // isPostPublished stays true forever (sticky), so
                      // isPublishedFooterLocked flips back to true too — hiding the
                      // Publish button at the exact moment it's needed to actually
                      // push the approved edit live. Excluding action==="approved"
                      // here restores it without loosening the other buttons gated
                      // by isPublishedFooterLocked elsewhere, which already have
                      // their own correct action!=="approved" checks.
                      (isPublishedFooterLocked && record?.action !== "approved") ? null : record?.action !== "approved" ? (
                        calendarPermission?.edit && (
                          <Button
                            htmlType="submit"
                            className="submitted-btn"
                            icon={<ClockCircleOutlined />}
                            loading={formSubmitting && activeActionType === "draft"}
                            disabled={formSubmitting}
                            onClick={() => {
                              flushAllPostEditors();
                              selectActionType("draft");
                            }}
                          >
                            Save as Draft
                          </Button>
                        )
                      ) : (
                        calendarPermission?.edit && (
                          <Button
                            className="submitted-btn"
                            icon={<ClockCircleOutlined />}
                            disabled={formSubmitting}
                            onClick={() => withOptionsPicker(() => {
                              selectActionType("publish");
                              setIsModalOpen(true);
                            }, "Publish", true, true)}
                          >
                            Publish
                          </Button>
                        )
                      )
                    ) : (
                      !isPastDateNew && calendarPermission?.add && (
                        <Button
                          htmlType="submit"
                          className="submitted-btn"
                          icon={<ClockCircleOutlined />}
                          loading={formSubmitting && activeActionType === "draft"}
                          disabled={formSubmitting}
                          onClick={() => {
                            flushAllPostEditors();
                            selectActionType("draft");
                          }}
                        >
                          Save as Draft
                        </Button>
                      )
                    ))}

                    {/* A brand-new post on a past date has nothing to schedule,
                        review, or publish going forward — the only honest
                        action is recording that it already went out on
                        LinkedIn's native app. This creates the post (as a
                        draft, silently) and immediately opens the same
                        "Mark Published on LinkedIn" modal used for existing
                        posts below, scoped to the just-created record —
                        reusing that flow rather than duplicating it. */}
                    {isPastDateNew && calendarPermission?.add && (
                      <Button
                        className="submitted-btn"
                        icon={<LinkedinFilled />}
                        loading={formSubmitting}
                        disabled={formSubmitting}
                        onClick={handleCreateThenMarkExternal}
                      >
                        Mark Published on LinkedIn
                      </Button>
                    )}

                    {isEditMode && record && record?.action === "publish" && isPostScheduledForFuture(record) && calendarPermission?.edit && (
                      <Button
                        className="submitted-btn"
                        icon={<CalendarOutlined />}
                        onClick={() => {
                          const scheduledAt = getScheduledMoment(record);
                          setReschedulePost(record);
                          // DatePicker/TimePicker here are the default antd (moment-based)
                          // components — passing a dayjs value throws
                          // "clone.weekday is not a function" internally.
                          setRescheduleDate(scheduledAt?.isValid() ? moment(scheduledAt.toDate()) : null);
                          setRescheduleTime(scheduledAt?.isValid() ? moment(scheduledAt.toDate()) : null);
                          setRescheduleModalVisible(true);
                        }}
                      >
                        Reschedule
                      </Button>
                    )}

                    {/* Only for content that's never actually gone live through
                        the app — isPostPublished(record) (a real postId) covers
                        both "published normally" and "already marked published
                        externally" (ExternalPublishHelper sets postId too), so
                        this alone is the correct guard; !publishedExternally is
                        kept as an explicit belt-and-suspenders check. Was
                        missing entirely before, so this button showed on
                        already-published posts too, which makes no sense —
                        there's nothing left to mark. */}
                    {isEditMode && calendarPermission?.edit && !isPostPublished(record) && !record?.publishedExternally && (
                      <Button
                        className="submitted-btn"
                        icon={<LinkedinFilled />}
                        onClick={() => {
                          setLinkedinUrlInput("");
                          setIsMarkExternalModalOpen(true);
                        }}
                      >
                        Mark Published on LinkedIn
                      </Button>
                    )}
                  </div>

                  {isEditMode && record?.publishedExternally && (
                    <div style={{ marginTop: 12, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                      <Tag color="cyan">Published on LinkedIn (external)</Tag>
                      {record?.linkedinPostUrl && (
                        <a href={record.linkedinPostUrl} target="_blank" rel="noopener noreferrer">
                          View on LinkedIn
                        </a>
                      )}
                    </div>
                  )}
                </Form>
              </Col>
            </Row>
          </div>
        </div>
      </Drawer>

      {/* Reschedule Modal */}
      <Modal
        title="Reschedule Post"
        // className="reschedule-modal"
        open={rescheduleModalVisible}
        onCancel={() => { setRescheduleModalVisible(false); setReschedulePost(null); setRescheduleDate(null); setRescheduleTime(null); }}
        footer={null}
        width={420}
        centered
      >
        <div style={{ padding: "16px 0" }}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", marginBottom: 6, fontWeight: 500 }}>New Date</label>
            <DatePicker
              value={rescheduleDate}
              onChange={(date) => setRescheduleDate(date)}
              style={{ width: "100%" }}
              disabledDate={(current) => current && current < moment().startOf("day")}
            />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: "block", marginBottom: 6, fontWeight: 500 }}>New Time (optional)</label>
            <TimePicker
              value={rescheduleTime}
              onChange={(time) => setRescheduleTime(time)}
              format="HH:mm"
              style={{ width: "100%" }}
            />
          </div>
          <Button
            className="submitted-btn"
            icon={<CalendarOutlined />}
            loading={rescheduleLoading}
            onClick={handleReschedule}
            style={{ width: "100%" }}
          >
            Reschedule
          </Button>
        </div>
      </Modal>

      {/* Mark Published on LinkedIn (externally) Modal — also reused by the
          past-date "create + mark published" flow (handleCreateThenMarkExternal),
          via pendingMarkExternalPostId standing in for record?._id when this
          is a just-created post rather than one already open for editing. */}
      <Modal
        title="Mark Published on LinkedIn"
        open={isMarkExternalModalOpen}
        onCancel={() => {
          const wasPendingCreate = !!pendingMarkExternalPostId;
          setIsMarkExternalModalOpen(false);
          setLinkedinUrlInput("");
          setMarkExternalOption(null);
          setPendingMarkExternalPostId(null);
          // The post itself was already created (just not marked published
          // yet) when this came from the past-date create flow — closing
          // without confirming shouldn't leave the compose drawer sitting
          // open on a post that's already saved.
          if (wasPendingCreate) {
            setOpen(false);
            resetForm();
            fetchData();
          }
        }}
        footer={null}
        width={480}
        centered
      >
        <div style={{ padding: "8px 0" }}>
          <p style={{ marginBottom: 16 }}>
            Use this when this post was published directly from the native LinkedIn app
            instead of through this app's publish flow. Paste the live LinkedIn post URL
            below so metrics can sync automatically.
          </p>
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: "block", marginBottom: 6, fontWeight: 500 }}>
              LinkedIn Post URL
            </label>
            <Input
              className="post-input"
              placeholder="https://www.linkedin.com/feed/update/..."
              value={linkedinUrlInput}
              onChange={(e) => setLinkedinUrlInput(e.target.value)}
            />
          </div>
          {markNeedsOption && (
  <div style={{ margin: "16px 0 8px" }}>
    <div style={{ fontWeight: 600, marginBottom: 8 }}>Which option did you publish?</div>
    <Radio.Group
      value={markOptionValue}
      onChange={(e) => setMarkExternalOption(e.target.value)}
      disabled={markExternalLoading}
      style={{ display: "flex", flexDirection: "column", gap: 8 }}
    >
      {optionDefs.map((o, k) => (
        <Radio key={o.idx} value={k} style={{ whiteSpace: "normal" }}>
          <b>Option {o.idx + 1}</b>
          {(record?.postOptions || [])[k]?.clientApproved && (
            <span style={{ marginLeft: 8, padding: "1px 8px", borderRadius: 999, background: "#dbeafe", color: "#1e40af", fontSize: 11, fontWeight: 700 }}>Approved by client</span>
          )}{" "}— {stripHtml(o.text || "").slice(0, 70)}{stripHtml(o.text || "").length > 70 ? "…" : ""}
        </Radio>
      ))}
    </Radio.Group>
  </div>
)}
          <Button
            type="primary"
            block
            loading={markExternalLoading}
            disabled={markExternalLoading || !linkedinUrlInput.trim() || (markNeedsOption && markOptionValue === null)}
            onClick={() => {
              const targetPostId = pendingMarkExternalPostId || record?._id;
              const wasPendingCreate = !!pendingMarkExternalPostId;
              setMarkExternalLoading(true);
              request({
                url: `/admin/access-module/post/${targetPostId}/mark-published-externally`,
                method: "PUT",
                data: { linkedinUrl: linkedinUrlInput.trim(), ...(markNeedsOption ? { chosenOptionIndex: markOptionValue } : {}) },
                onSuccess: (res) => {
                  setMarkExternalLoading(false);
                  setIsMarkExternalModalOpen(false);
                  setLinkedinUrlInput("");
                  setMarkExternalOption(null);
                  setPendingMarkExternalPostId(null);
                  ShowToast("Post marked as published on LinkedIn", Severty.SUCCESS);
                  const updatedPost = res?.data?.post;
                  if (updatedPost) {
                    setRecord((prev) => (prev?._id === updatedPost._id ? updatedPost : prev));
                  }
                  fetchData();
                  if (wasPendingCreate) {
                    setOpen(false);
                    resetForm();
                  }
                },
                onError: (res) => {
                  setMarkExternalLoading(false);
                  ShowToast(res?.message || "Failed to mark post as published on LinkedIn", Severty.ERROR);
                },
              });
            }}
            style={{ background: "#001529", borderColor: "#001529" }}
          >
            Confirm
          </Button>
        </div>
      </Modal>

      {/* Edit date and time post modal */}

      <Modal
        className="tab_modal"
        title="Select publish option"
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setPublishOption("now"); // reset on cancel
        }}
        footer={null}
        centered
      >
        <Radio.Group
          onChange={(e) => setPublishOption(e.target.value)}
          value={publishOption}
          style={{ marginBottom: 20 }}
        >
          <Radio value="now">Publish Now</Radio>
          <Radio value="later">Publish Later</Radio>
        </Radio.Group>

        {publishOption === "later" && (
          <Row gutter={[12, 12]}>
            <Col span={24} md={12}>
              <div style={{ marginBottom: 16 }}>
                <label>Date</label>
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD.MM.YYYY"
                  disabledDate={(current) => {
                    return current && current < moment().startOf("day");
                  }}
                  value={selectedDate ? moment(selectedDate) : null}
                  onChange={(date) => {
                    const formattedDate = date.format("YYYY-MM-DD");
                    setSelectedDate(formattedDate); // Set selectedDate
                  }}
                />
              </div>
            </Col>
            <Col span={24} md={12}>
              <div style={{ marginBottom: 24 }}>
                <label>Time</label>
                <TimePicker
                  style={{ width: "100%" }}
                  format="HH:mm"
                  value={selectedTime ? moment(selectedTime, "HH:mm") : null}
                  onChange={(time) => {
                    setSelectedTime(time ? time.format("HH:mm") : null); // Set selectedTime
                  }}
                />
              </div>
            </Col>
          </Row>
        )}

        <Button
          type="primary"
          block
          loading={isPublishSubmitting}
          disabled={isPublishSubmitting}
          onClick={() => onEdit(form.getFieldsValue())}
          style={{ background: "#001529", borderColor: "#001529" }}
        >
          Save
        </Button>
      </Modal>

      {/* Holiday Add / Edit Modal */}
      <Modal
        className="tab_modal"
        title={
          <span style={{ color: HOLIDAY_CONFIG.color }}>
            {editingHoliday ? "Edit Calendar Event" : "Add Calendar Event"}
          </span>
        }
        open={isHolidayModalOpen}
        onCancel={() => {
          setIsHolidayModalOpen(false);
          setEditingHoliday(null);
          holidayForm.resetFields();
        }}
        footer={null}
        centered
        width={500}
      >
        <Form
          form={holidayForm}
          layout="vertical"
          onFinish={saveHoliday}
        >
          <Form.Item
            name="holidayName"
            label="Event Title"
            rules={[{ required: true, message: "Please enter the event title" }]}
          >
            <Input placeholder="e.g. Independence Day, Regional campaign, Office closure..." className="post-input" />
          </Form.Item>

          <Form.Item
            name="holidayCategory"
            label="Event Type"
            rules={[{ required: true, message: "Please select the event type" }]}
          >
            <Select placeholder="Select event type" className="post-input">
              {EVENT_TYPE_OPTIONS.map((type) => (
                <Option key={type} value={type}>{type}</Option>
              ))}
            </Select>
          </Form.Item>

          <Row gutter={12}>
            <Col span={12}>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>Start Date</label>
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD MMM YYYY"
                  value={holidayStartDate ? moment(holidayStartDate) : null}
                  onChange={(date) => setHolidayStartDate(date ? date.format("YYYY-MM-DD") : null)}
                  placeholder="Start date"
                />
              </div>
            </Col>
            <Col span={12}>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>End Date</label>
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD MMM YYYY"
                  value={holidayEndDate ? moment(holidayEndDate) : null}
                  disabledDate={(current) =>
                    holidayStartDate ? current && current < moment(holidayStartDate).startOf("day") : false
                  }
                  onChange={(date) => setHolidayEndDate(date ? date.format("YYYY-MM-DD") : null)}
                  placeholder="End date"
                />
              </div>
            </Col>
          </Row>

          <Form.Item
            name="holidayVisibilityType"
            label="Visibility"
            rules={[{ required: true, message: "Please select visibility" }]}
          >
            <Radio.Group>
              <Radio value="global">Global</Radio>
              <Radio value="region">Region / timezone specific</Radio>
            </Radio.Group>
          </Form.Item>

          {holidayVisibilityType === "region" && (
            <Row gutter={12}>
              <Col span={12}>
                <Form.Item
                  name="holidayRegion"
                  label="Region"
                  rules={[{ required: true, message: "Please enter the region" }]}
                >
                  <Select mode="tags" placeholder="e.g. Hong Kong" className="post-input">
                    {holidayRegionOptions.map((region) => (
                      <Option key={region} value={region}>{region}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="holidayTimezone" label="Timezone">
                  <Select
                    showSearch
                    allowClear
                    mode="tags"
                    maxTagCount={1}
                    placeholder="Select or type timezone"
                    className="post-input"
                  >
                    {TIMEZONE_OPTIONS.map((timezone) => (
                      <Option key={timezone} value={timezone}>{timezone}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          )}

          <Form.Item name="holidayDescription" label="Description / Message (optional)">
            <Input.TextArea
              rows={2}
              maxLength={300}
              placeholder="Brief message for this calendar marking..."
              className="post-input"
              showCount
            />
          </Form.Item>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 8 }}>
            <Button
              onClick={() => {
                setIsHolidayModalOpen(false);
                setEditingHoliday(null);
                holidayForm.resetFields();
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ background: "#D4B106", borderColor: "#D4B106" }}
            >
              {editingHoliday ? "Save Changes" : "Add Event"}
            </Button>
          </div>
        </Form>
      </Modal>

      {/* Admin Calendar Marking Add / Edit Modal */}
      <Modal
        className="tab_modal"
        title={editingAdminMarking ? "Edit Marking" : "Add Marking"}
        open={isAdminMarkingModalOpen}
        onCancel={() => {
          setIsAdminMarkingModalOpen(false);
          setEditingAdminMarking(null);
          adminMarkingForm.resetFields();
        }}
        footer={null}
        centered
        width={500}
      >
        <Form
          form={adminMarkingForm}
          layout="vertical"
          onFinish={saveAdminMarking}
        >
          {!editingAdminMarking && (
            <Form.Item name="markFor" label="Mark For">
              <Select placeholder="Select who this marking is for" className="post-input">
                {adminMarkingAssociates?.client && (
                  <Option value={`client:${adminMarkingAssociates.client._id}`}>
                    {adminMarkingAssociates.client.name}
                  </Option>
                )}
                {adminMarkingAssociates?.brandManagers?.map((bm) => (
                  <Option key={bm._id} value={`brand_manager:${bm._id}`}>
                    BM: {bm.name}
                  </Option>
                ))}
                {adminMarkingAssociates?.brandStrategists?.map((bs) => (
                  <Option key={bs._id} value={`brand_strategist:${bs._id}`}>
                    BS: {bs.name}
                  </Option>
                ))}
                {adminMarkingAssociates?.brandHeads?.map((bh) => (
                  <Option key={bh._id} value={`brand_head:${bh._id}`}>
                    BH: {bh.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}

          <Form.Item
            name="adminMarkingType"
            label="Type"
            rules={[{ required: true, message: "Please select a marking type" }]}
          >
            <Select placeholder="Select marking type" className="post-input">
              {Object.entries(MARKING_TYPES).map(([key, cfg]) => (
                <Option key={key} value={key}>{cfg.emoji} {cfg.label}</Option>
              ))}
            </Select>
          </Form.Item>

          <Row gutter={12}>
            <Col span={12}>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>Start Date</label>
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD MMM YYYY"
                  value={adminMarkingStartDate ? moment(adminMarkingStartDate) : null}
                  onChange={(date) => setAdminMarkingStartDate(date ? date.format("YYYY-MM-DD") : null)}
                  placeholder="Start date"
                />
              </div>
            </Col>
            <Col span={12}>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>End Date</label>
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD MMM YYYY"
                  value={adminMarkingEndDate ? moment(adminMarkingEndDate) : null}
                  disabledDate={(current) =>
                    adminMarkingStartDate ? current && current < moment(adminMarkingStartDate).startOf("day") : false
                  }
                  onChange={(date) => setAdminMarkingEndDate(date ? date.format("YYYY-MM-DD") : null)}
                  placeholder="End date"
                />
              </div>
            </Col>
          </Row>

          <Form.Item name="adminMarkingNote" label="Note (optional)">
            <Input.TextArea
              rows={2}
              maxLength={500}
              placeholder="Brief note for this marking..."
              className="post-input"
              showCount
            />
          </Form.Item>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 8 }}>
            <Button
              onClick={() => {
                setIsAdminMarkingModalOpen(false);
                setEditingAdminMarking(null);
                adminMarkingForm.resetFields();
              }}
            >
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              {editingAdminMarking ? "Save Changes" : "Add Marking"}
            </Button>
          </div>
        </Form>
      </Modal>

      <Modal
        className="tab_modal"
        title="Are you sure you want to delete this post?"
        width={770}
        open={isDeleteModalOpen}
        onCancel={() => !deleteLoading && setIsDeleteModalOpen(false)}
        closable={!deleteLoading}
        maskClosable={!deleteLoading}
        footer={null}
        centered
      >
        {/* LinkedIn live-post warning — only shown when the post is published on LinkedIn */}
        {record?.postId && (
          <div className="delete-linkedin-warning">
            <span className="delete-linkedin-warning-icon">⚠️</span>
            <div className="delete-linkedin-warning-text">
              <strong>This post is live on LinkedIn.</strong>
              <span> Deleting it here will also permanently remove it from your LinkedIn profile.</span>
            </div>
          </div>
        )}
        <div className="delete-post-modal">
          <div className="delete-post-modal-image">
            <img src={record?.media?.[0] || T} />
          </div>
          <div className="right-side-deatail-post">
            <div className="delete-deatail-post-header">
              <div className="user-profile-delete-ps">
                <span>
                  <img src={LinkdinIcon} />
                </span>
                <h6>{record?.title}</h6>
              </div>
              <div className="user-profile-date-ps user-profile-delete-ps">
                <img src={CalendarIcon} />
                <h6>
                  {record?.selectedDate
                    ? (getScheduledMoment(record)?.isValid()
                        ? getScheduledMoment(record).format("YYYY-MM-DD")
                        : moment(record.selectedDate).format("YYYY-MM-DD"))
                    : "N/A"}
                </h6>
              </div>
            </div>
            <p>
              {(() => {
                const div = document.createElement("div");
                div.innerHTML = record?.postText || "";
                return div.innerText;
              })()}
            </p>
            {/* Real status instead of a hardcoded "Draft" label — this modal
                is reachable from any post regardless of its actual status. */}
            <div className="draft-status-tab">
              <img src={DraftIcon} />
              {record?.brandStatus || record?.clientStatus || "Draft"}
            </div>
          </div>
        </div>
        <div className="action-footer-buttons">
          {calendarPermission?.delete && (
            <>
              <Button
                className="cancel-btn"
                disabled={deleteLoading}
                onClick={() => setIsDeleteModalOpen(false)}
              >
                Cancel
              </Button>
              <Button
                className="submitted-btn delete-confirm-btn"
                loading={deleteLoading}
                onClick={() => deleteContent(record)}
              >
                {record?.postId ? "Yes, Delete from LinkedIn too" : "Yes, Delete"}
              </Button>
            </>
          )}
        </div>
      </Modal>

      {/* Type Change Warning Modal */}
      <Modal
        open={typeChangeModalVisible}
        title="Change Post Type?"
        onCancel={() => {
          setTypeChangeModalVisible(false);
          setPendingPostType(null);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setTypeChangeModalVisible(false);
              setPendingPostType(null);
            }}
          >
            Cancel
          </Button>,
          <Button
            key="confirm"
            type="primary"
            danger
            onClick={() => {
              if (pendingPostType) applyPostTypeChange(pendingPostType);
              setTypeChangeModalVisible(false);
              setPendingPostType(null);
            }}
          >
            Change Type
          </Button>,
        ]}
        centered
      >
        <p>
          Are you sure you want to change the post type? Changing the post type
          will remove the data associated with the current type. This action
          cannot be undone.
        </p>
      </Modal>

      <Modal
        open={gfxModalVisible}
        title="Send to Graphics"
        width={800}
        onCancel={() => setGfxModalVisible(false)}
        okText="Create Graphics Request"
        okButtonProps={{ loading: gfxSaving }}
        onOk={() => gfxForm.submit()}
        style={{ top: 20 }}
        bodyStyle={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}
      >
        <div style={{ marginBottom: 16, padding: 12, background: "#e6f4ff", border: "1px solid #91caff", borderRadius: 4 }}>
          As an Admin, this request bypasses the Graphics Team workload block if the member is fully occupied.
        </div>
        <Form form={gfxForm} layout="vertical" onFinish={onGfxFinish}>
          <Row gutter={20}>
            <Col span={12}>
              <Form.Item
                label="Client Name (internal reference only)"
                name="clientNameRef"
                extra={
                  user?.linkedinUrl ? (
                    <a href={user.linkedinUrl} target="_blank" rel="noreferrer" className="gfx-client-option-linkedin">
                      <LinkedinFilled /> View LinkedIn profile
                    </a>
                  ) : null
                }
              >
                <Input placeholder="Client name" />
              </Form.Item>
              <Form.Item name="clientLinkedinUrl" hidden>
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Campaign / Project" name="campaignProject" rules={[{ required: true, message: "Required" }]}>
                <Input placeholder="Campaign / Project name" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item label="Post Title" name="postTitle">
            <Input disabled />
          </Form.Item>
          <Form.Item label="Post Body" name="postBody">
            <Input.TextArea rows={3} disabled />
          </Form.Item>

          <Row gutter={20}>
            <Col span={12}>
              <Form.Item label="Graphic Brief" name="graphicBrief">
                <Input.TextArea rows={3} placeholder="What should the Graphics Team create?" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Design Instructions" name="designInstructions">
                <Input.TextArea rows={3} placeholder="Colors, sizing, brand guidelines, etc." />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={20}>
            <Col span={8}>
              <Form.Item label="Delivery Date" name="deliveryDate" rules={[{ required: true, message: "Required" }]}>
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Priority" name="priority" initialValue="Medium">
                <Select options={["Low", "Medium", "High", "Urgent"].map((p) => ({ label: p, value: p }))} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Assign To" name="assignedTo">
                <Select
                  allowClear
                  placeholder="Graphics Team member"
                  options={gfxMembers.map((m) => ({ label: m.name, value: m._id }))}
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item label="Attachments">
            <Upload
              multiple
              beforeUpload={(file) => {
                setGfxFileList((prev) => [...prev, file]);
                return false;
              }}
              onRemove={(file) => setGfxFileList((prev) => prev.filter((f) => f.uid !== file.uid))}
              fileList={gfxFileList}
            >
              <Button icon={<UploadOutlined />}>Select Files</Button>
            </Upload>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default CalendarPage;

{
  /* Post successfully modal start */
}
{
  /* <Modal
        width={640}
        className="tab_modal"
        open={isSubmittedModalOpen}
        onCancel={() => setIsSubmittedModalOpen(false)}
        footer={null}
        centered
        title={
          <div style={{ fontWeight: 600, fontSize: "18px" }}>
            Post successfully summited ✅
          </div>
        }
      >
        <div className="submit-form-modal">
          <p>
            <strong>Title:</strong> {submittedData.title}
          </p>

          <p>
            <strong>Post Content:</strong> {submittedData.content}
          </p>

          <p>
            <strong>Scheduled Date & Time:</strong> {submittedData.dateTime}
          </p>
          <div className="upload-media-inn">
            <p>
              <strong>Uploaded Media</strong>
            </p>
            <Row gutter={[32, 12]}>
              {submittedData.media?.map((file, idx) => (
                <Col span={24} md={12}>
                  <div className="uploded-media-files" key={idx}>
                    <img src={UploadedImage01} />
                    <span> {file} </span>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>

        <Button
          type="primary"
          block
          onClick={() => setIsSubmittedModalOpen(false)}
          style={{
            marginTop: 20,
            background: "#001529",
            borderColor: "#001529",
          }}
        >
          Edit
        </Button>
      </Modal> */
}
{
  /* delete post modal */
}
